(() => {
var $450fc775b2f7950e$var$n, $450fc775b2f7950e$export$41c562ebe57d11e2, $450fc775b2f7950e$var$u, $450fc775b2f7950e$export$a8257692ac88316c, $450fc775b2f7950e$var$i, $450fc775b2f7950e$var$r, $450fc775b2f7950e$var$o, $450fc775b2f7950e$var$e, $450fc775b2f7950e$var$f, $450fc775b2f7950e$var$c, $450fc775b2f7950e$var$s, $450fc775b2f7950e$var$a, $450fc775b2f7950e$var$h, $450fc775b2f7950e$var$p = {}, $450fc775b2f7950e$var$v = [], $450fc775b2f7950e$var$y = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i, $450fc775b2f7950e$var$d = Array.isArray;
function $450fc775b2f7950e$var$w(n, l) {
    for(var u in l)n[u] = l[u];
    return n;
}
function $450fc775b2f7950e$var$g(n) {
    n && n.parentNode && n.parentNode.removeChild(n);
}
function $450fc775b2f7950e$export$c8a8987d4410bf2d(l, u, t) {
    var i, r, o, e = {};
    for(o in u)"key" == o ? i = u[o] : "ref" == o ? r = u[o] : e[o] = u[o];
    if (arguments.length > 2 && (e.children = arguments.length > 3 ? $450fc775b2f7950e$var$n.call(arguments, 2) : t), "function" == typeof l && null != l.defaultProps) for(o in l.defaultProps)void 0 === e[o] && (e[o] = l.defaultProps[o]);
    return $450fc775b2f7950e$var$m(l, e, i, r, null);
}
function $450fc775b2f7950e$var$m(n, t, i, r, o) {
    var e = {
        type: n,
        props: t,
        key: i,
        ref: r,
        __k: null,
        __: null,
        __b: 0,
        __e: null,
        __c: null,
        constructor: void 0,
        __v: null == o ? ++$450fc775b2f7950e$var$u : o,
        __i: -1,
        __u: 0
    };
    return null == o && null != $450fc775b2f7950e$export$41c562ebe57d11e2.vnode && $450fc775b2f7950e$export$41c562ebe57d11e2.vnode(e), e;
}
function $450fc775b2f7950e$export$7d1e3a5e95ceca43() {
    return {
        current: null
    };
}
function $450fc775b2f7950e$export$ffb0004e005737fa(n) {
    return n.children;
}
function $450fc775b2f7950e$export$16fa2f45be04daa8(n, l) {
    this.props = n, this.context = l;
}
function $450fc775b2f7950e$var$S(n, l) {
    if (null == l) return n.__ ? $450fc775b2f7950e$var$S(n.__, n.__i + 1) : null;
    for(var u; l < n.__k.length; l++)if (null != (u = n.__k[l]) && null != u.__e) return u.__e;
    return "function" == typeof n.type ? $450fc775b2f7950e$var$S(n) : null;
}
function $450fc775b2f7950e$var$C(n) {
    if (n.__P && n.__d) {
        var u = n.__v, t = u.__e, i = [], r = [], o = $450fc775b2f7950e$var$w({}, u);
        o.__v = u.__v + 1, $450fc775b2f7950e$export$41c562ebe57d11e2.vnode && $450fc775b2f7950e$export$41c562ebe57d11e2.vnode(o), $450fc775b2f7950e$var$z(n.__P, o, u, n.__n, n.__P.namespaceURI, 32 & u.__u ? [
            t
        ] : null, i, null == t ? $450fc775b2f7950e$var$S(u) : t, !!(32 & u.__u), r), o.__v = u.__v, o.__.__k[o.__i] = o, $450fc775b2f7950e$var$V(i, o, r), u.__e = u.__ = null, o.__e != t && $450fc775b2f7950e$var$M(o);
    }
}
function $450fc775b2f7950e$var$M(n) {
    if (null != (n = n.__) && null != n.__c) return n.__e = n.__c.base = null, n.__k.some(function(l) {
        if (null != l && null != l.__e) return n.__e = n.__c.base = l.__e;
    }), $450fc775b2f7950e$var$M(n);
}
function $450fc775b2f7950e$var$$(n) {
    (!n.__d && (n.__d = !0) && $450fc775b2f7950e$var$i.push(n) && !$450fc775b2f7950e$var$I.__r++ || $450fc775b2f7950e$var$r != $450fc775b2f7950e$export$41c562ebe57d11e2.debounceRendering) && (($450fc775b2f7950e$var$r = $450fc775b2f7950e$export$41c562ebe57d11e2.debounceRendering) || $450fc775b2f7950e$var$o)($450fc775b2f7950e$var$I);
}
function $450fc775b2f7950e$var$I() {
    for(var n, l = 1; $450fc775b2f7950e$var$i.length;)$450fc775b2f7950e$var$i.length > l && $450fc775b2f7950e$var$i.sort($450fc775b2f7950e$var$e), n = $450fc775b2f7950e$var$i.shift(), l = $450fc775b2f7950e$var$i.length, $450fc775b2f7950e$var$C(n);
    $450fc775b2f7950e$var$I.__r = 0;
}
function $450fc775b2f7950e$var$P(n, l, u, t, i, r, o, e, f, c, s) {
    var a, h, y, d, w, g, _, m = t && t.__k || $450fc775b2f7950e$var$v, b = l.length;
    for(f = $450fc775b2f7950e$var$A(u, l, m, f, b), a = 0; a < b; a++)null != (y = u.__k[a]) && (h = -1 != y.__i && m[y.__i] || $450fc775b2f7950e$var$p, y.__i = a, g = $450fc775b2f7950e$var$z(n, y, h, i, r, o, e, f, c, s), d = y.__e, y.ref && h.ref != y.ref && (h.ref && $450fc775b2f7950e$var$D(h.ref, null, y), s.push(y.ref, y.__c || d, y)), null == w && null != d && (w = d), (_ = !!(4 & y.__u)) || h.__k === y.__k ? f = $450fc775b2f7950e$var$H(y, f, n, _) : "function" == typeof y.type && void 0 !== g ? f = g : d && (f = d.nextSibling), y.__u &= -7);
    return u.__e = w, f;
}
function $450fc775b2f7950e$var$A(n, l, u, t, i) {
    var r, o, e, f, c, s = u.length, a = s, h = 0;
    for(n.__k = new Array(i), r = 0; r < i; r++)null != (o = l[r]) && "boolean" != typeof o && "function" != typeof o ? ("string" == typeof o || "number" == typeof o || "bigint" == typeof o || o.constructor == String ? o = n.__k[r] = $450fc775b2f7950e$var$m(null, o, null, null, null) : $450fc775b2f7950e$var$d(o) ? o = n.__k[r] = $450fc775b2f7950e$var$m($450fc775b2f7950e$export$ffb0004e005737fa, {
        children: o
    }, null, null, null) : void 0 === o.constructor && o.__b > 0 ? o = n.__k[r] = $450fc775b2f7950e$var$m(o.type, o.props, o.key, o.ref ? o.ref : null, o.__v) : n.__k[r] = o, f = r + h, o.__ = n, o.__b = n.__b + 1, e = null, -1 != (c = o.__i = $450fc775b2f7950e$var$T(o, u, f, a)) && (a--, (e = u[c]) && (e.__u |= 2)), null == e || null == e.__v ? (-1 == c && (i > s ? h-- : i < s && h++), "function" != typeof o.type && (o.__u |= 4)) : c != f && (c == f - 1 ? h-- : c == f + 1 ? h++ : (c > f ? h-- : h++, o.__u |= 4))) : n.__k[r] = null;
    if (a) for(r = 0; r < s; r++)null != (e = u[r]) && 0 == (2 & e.__u) && (e.__e == t && (t = $450fc775b2f7950e$var$S(e)), $450fc775b2f7950e$var$E(e, e));
    return t;
}
function $450fc775b2f7950e$var$H(n, l, u, t) {
    var i, r;
    if ("function" == typeof n.type) {
        for(i = n.__k, r = 0; i && r < i.length; r++)i[r] && (i[r].__ = n, l = $450fc775b2f7950e$var$H(i[r], l, u, t));
        return l;
    }
    n.__e != l && (t && (l && n.type && !l.parentNode && (l = $450fc775b2f7950e$var$S(n)), u.insertBefore(n.__e, l || null)), l = n.__e);
    do l = l && l.nextSibling;
    while (null != l && 8 == l.nodeType);
    return l;
}
function $450fc775b2f7950e$export$47e4c5b300681277(n, l) {
    return l = l || [], null == n || "boolean" == typeof n || ($450fc775b2f7950e$var$d(n) ? n.some(function(n) {
        $450fc775b2f7950e$export$47e4c5b300681277(n, l);
    }) : l.push(n)), l;
}
function $450fc775b2f7950e$var$T(n, l, u, t) {
    var i, r, o, e = n.key, f = n.type, c = l[u], s = null != c && 0 == (2 & c.__u);
    if (null === c && null == e || s && e == c.key && f == c.type) return u;
    if (t > (s ? 1 : 0)) {
        for(i = u - 1, r = u + 1; i >= 0 || r < l.length;)if (null != (c = l[o = i >= 0 ? i-- : r++]) && 0 == (2 & c.__u) && e == c.key && f == c.type) return o;
    }
    return -1;
}
function $450fc775b2f7950e$var$j(n, l, u) {
    "-" == l[0] ? n.setProperty(l, null == u ? "" : u) : n[l] = null == u ? "" : "number" != typeof u || $450fc775b2f7950e$var$y.test(l) ? u : u + "px";
}
function $450fc775b2f7950e$var$F(n, l, u, t, i) {
    var r, o;
    n: if ("style" == l) {
        if ("string" == typeof u) n.style.cssText = u;
        else {
            if ("string" == typeof t && (n.style.cssText = t = ""), t) for(l in t)u && l in u || $450fc775b2f7950e$var$j(n.style, l, "");
            if (u) for(l in u)t && u[l] == t[l] || $450fc775b2f7950e$var$j(n.style, l, u[l]);
        }
    } else if ("o" == l[0] && "n" == l[1]) r = l != (l = l.replace($450fc775b2f7950e$var$f, "$1")), o = l.toLowerCase(), l = o in n || "onFocusOut" == l || "onFocusIn" == l ? o.slice(2) : l.slice(2), n.l || (n.l = {}), n.l[l + r] = u, u ? t ? u.u = t.u : (u.u = $450fc775b2f7950e$var$c, n.addEventListener(l, r ? $450fc775b2f7950e$var$a : $450fc775b2f7950e$var$s, r)) : n.removeEventListener(l, r ? $450fc775b2f7950e$var$a : $450fc775b2f7950e$var$s, r);
    else {
        if ("http://www.w3.org/2000/svg" == i) l = l.replace(/xlink(H|:h)/, "h").replace(/sName$/, "s");
        else if ("width" != l && "height" != l && "href" != l && "list" != l && "form" != l && "tabIndex" != l && "download" != l && "rowSpan" != l && "colSpan" != l && "role" != l && "popover" != l && l in n) try {
            n[l] = null == u ? "" : u;
            break n;
        } catch (n) {}
        "function" == typeof u || (null == u || !1 === u && "-" != l[4] ? n.removeAttribute(l) : n.setAttribute(l, "popover" == l && 1 == u ? "" : u));
    }
}
function $450fc775b2f7950e$var$O(n) {
    return function(u) {
        if (this.l) {
            var t = this.l[u.type + n];
            if (null == u.t) u.t = $450fc775b2f7950e$var$c++;
            else if (u.t < t.u) return;
            return t($450fc775b2f7950e$export$41c562ebe57d11e2.event ? $450fc775b2f7950e$export$41c562ebe57d11e2.event(u) : u);
        }
    };
}
function $450fc775b2f7950e$var$z(n, u, t, i, r, o, e, f, c, s) {
    var a, h, p, y, _, m, b, S, C, M, $, I, A, H, L, T = u.type;
    if (void 0 !== u.constructor) return null;
    128 & t.__u && (c = !!(32 & t.__u), o = [
        f = u.__e = t.__e
    ]), (a = $450fc775b2f7950e$export$41c562ebe57d11e2.__b) && a(u);
    n: if ("function" == typeof T) try {
        if (S = u.props, C = "prototype" in T && T.prototype.render, M = (a = T.contextType) && i[a.__c], $ = a ? M ? M.props.value : a.__ : i, t.__c ? b = (h = u.__c = t.__c).__ = h.__E : (C ? u.__c = h = new T(S, $) : (u.__c = h = new $450fc775b2f7950e$export$16fa2f45be04daa8(S, $), h.constructor = T, h.render = $450fc775b2f7950e$var$G), M && M.sub(h), h.state || (h.state = {}), h.__n = i, p = h.__d = !0, h.__h = [], h._sb = []), C && null == h.__s && (h.__s = h.state), C && null != T.getDerivedStateFromProps && (h.__s == h.state && (h.__s = $450fc775b2f7950e$var$w({}, h.__s)), $450fc775b2f7950e$var$w(h.__s, T.getDerivedStateFromProps(S, h.__s))), y = h.props, _ = h.state, h.__v = u, p) C && null == T.getDerivedStateFromProps && null != h.componentWillMount && h.componentWillMount(), C && null != h.componentDidMount && h.__h.push(h.componentDidMount);
        else {
            if (C && null == T.getDerivedStateFromProps && S !== y && null != h.componentWillReceiveProps && h.componentWillReceiveProps(S, $), u.__v == t.__v || !h.__e && null != h.shouldComponentUpdate && !1 === h.shouldComponentUpdate(S, h.__s, $)) {
                u.__v != t.__v && (h.props = S, h.state = h.__s, h.__d = !1), u.__e = t.__e, u.__k = t.__k, u.__k.some(function(n) {
                    n && (n.__ = u);
                }), $450fc775b2f7950e$var$v.push.apply(h.__h, h._sb), h._sb = [], h.__h.length && e.push(h);
                break n;
            }
            null != h.componentWillUpdate && h.componentWillUpdate(S, h.__s, $), C && null != h.componentDidUpdate && h.__h.push(function() {
                h.componentDidUpdate(y, _, m);
            });
        }
        if (h.context = $, h.props = S, h.__P = n, h.__e = !1, I = $450fc775b2f7950e$export$41c562ebe57d11e2.__r, A = 0, C) h.state = h.__s, h.__d = !1, I && I(u), a = h.render(h.props, h.state, h.context), $450fc775b2f7950e$var$v.push.apply(h.__h, h._sb), h._sb = [];
        else do h.__d = !1, I && I(u), a = h.render(h.props, h.state, h.context), h.state = h.__s;
        while (h.__d && ++A < 25);
        h.state = h.__s, null != h.getChildContext && (i = $450fc775b2f7950e$var$w($450fc775b2f7950e$var$w({}, i), h.getChildContext())), C && !p && null != h.getSnapshotBeforeUpdate && (m = h.getSnapshotBeforeUpdate(y, _)), H = null != a && a.type === $450fc775b2f7950e$export$ffb0004e005737fa && null == a.key ? $450fc775b2f7950e$var$q(a.props.children) : a, f = $450fc775b2f7950e$var$P(n, $450fc775b2f7950e$var$d(H) ? H : [
            H
        ], u, t, i, r, o, e, f, c, s), h.base = u.__e, u.__u &= -161, h.__h.length && e.push(h), b && (h.__E = h.__ = null);
    } catch (n) {
        if (u.__v = null, c || null != o) {
            if (n.then) {
                for(u.__u |= c ? 160 : 128; f && 8 == f.nodeType && f.nextSibling;)f = f.nextSibling;
                o[o.indexOf(f)] = null, u.__e = f;
            } else {
                for(L = o.length; L--;)$450fc775b2f7950e$var$g(o[L]);
                $450fc775b2f7950e$var$N(u);
            }
        } else u.__e = t.__e, u.__k = t.__k, n.then || $450fc775b2f7950e$var$N(u);
        $450fc775b2f7950e$export$41c562ebe57d11e2.__e(n, u, t);
    }
    else null == o && u.__v == t.__v ? (u.__k = t.__k, u.__e = t.__e) : f = u.__e = $450fc775b2f7950e$var$B(t.__e, u, t, i, r, o, e, c, s);
    return (a = $450fc775b2f7950e$export$41c562ebe57d11e2.diffed) && a(u), 128 & u.__u ? void 0 : f;
}
function $450fc775b2f7950e$var$N(n) {
    n && (n.__c && (n.__c.__e = !0), n.__k && n.__k.some($450fc775b2f7950e$var$N));
}
function $450fc775b2f7950e$var$V(n, u, t) {
    for(var i = 0; i < t.length; i++)$450fc775b2f7950e$var$D(t[i], t[++i], t[++i]);
    $450fc775b2f7950e$export$41c562ebe57d11e2.__c && $450fc775b2f7950e$export$41c562ebe57d11e2.__c(u, n), n.some(function(u) {
        try {
            n = u.__h, u.__h = [], n.some(function(n) {
                n.call(u);
            });
        } catch (n) {
            $450fc775b2f7950e$export$41c562ebe57d11e2.__e(n, u.__v);
        }
    });
}
function $450fc775b2f7950e$var$q(n) {
    return "object" != typeof n || null == n || n.__b > 0 ? n : $450fc775b2f7950e$var$d(n) ? n.map($450fc775b2f7950e$var$q) : $450fc775b2f7950e$var$w({}, n);
}
function $450fc775b2f7950e$var$B(u, t, i, r, o, e, f, c, s) {
    var a, h, v, y, w, _, m, b = i.props || $450fc775b2f7950e$var$p, k = t.props, x = t.type;
    if ("svg" == x ? o = "http://www.w3.org/2000/svg" : "math" == x ? o = "http://www.w3.org/1998/Math/MathML" : o || (o = "http://www.w3.org/1999/xhtml"), null != e) {
        for(a = 0; a < e.length; a++)if ((w = e[a]) && "setAttribute" in w == !!x && (x ? w.localName == x : 3 == w.nodeType)) {
            u = w, e[a] = null;
            break;
        }
    }
    if (null == u) {
        if (null == x) return document.createTextNode(k);
        u = document.createElementNS(o, x, k.is && k), c && ($450fc775b2f7950e$export$41c562ebe57d11e2.__m && $450fc775b2f7950e$export$41c562ebe57d11e2.__m(t, e), c = !1), e = null;
    }
    if (null == x) b === k || c && u.data == k || (u.data = k);
    else {
        if (e = e && $450fc775b2f7950e$var$n.call(u.childNodes), !c && null != e) for(b = {}, a = 0; a < u.attributes.length; a++)b[(w = u.attributes[a]).name] = w.value;
        for(a in b)w = b[a], "dangerouslySetInnerHTML" == a ? v = w : "children" == a || a in k || "value" == a && "defaultValue" in k || "checked" == a && "defaultChecked" in k || $450fc775b2f7950e$var$F(u, a, null, w, o);
        for(a in k)w = k[a], "children" == a ? y = w : "dangerouslySetInnerHTML" == a ? h = w : "value" == a ? _ = w : "checked" == a ? m = w : c && "function" != typeof w || b[a] === w || $450fc775b2f7950e$var$F(u, a, w, b[a], o);
        if (h) c || v && (h.__html == v.__html || h.__html == u.innerHTML) || (u.innerHTML = h.__html), t.__k = [];
        else if (v && (u.innerHTML = ""), $450fc775b2f7950e$var$P("template" == t.type ? u.content : u, $450fc775b2f7950e$var$d(y) ? y : [
            y
        ], t, i, r, "foreignObject" == x ? "http://www.w3.org/1999/xhtml" : o, e, f, e ? e[0] : i.__k && $450fc775b2f7950e$var$S(i, 0), c, s), null != e) for(a = e.length; a--;)$450fc775b2f7950e$var$g(e[a]);
        c || (a = "value", "progress" == x && null == _ ? u.removeAttribute("value") : null != _ && (_ !== u[a] || "progress" == x && !_ || "option" == x && _ != b[a]) && $450fc775b2f7950e$var$F(u, a, _, b[a], o), a = "checked", null != m && m != u[a] && $450fc775b2f7950e$var$F(u, a, m, b[a], o));
    }
    return u;
}
function $450fc775b2f7950e$var$D(n, u, t) {
    try {
        if ("function" == typeof n) {
            var i = "function" == typeof n.__u;
            i && n.__u(), i && null == u || (n.__u = n(u));
        } else n.current = u;
    } catch (n) {
        $450fc775b2f7950e$export$41c562ebe57d11e2.__e(n, t);
    }
}
function $450fc775b2f7950e$var$E(n, u, t) {
    var i, r;
    if ($450fc775b2f7950e$export$41c562ebe57d11e2.unmount && $450fc775b2f7950e$export$41c562ebe57d11e2.unmount(n), (i = n.ref) && (i.current && i.current != n.__e || $450fc775b2f7950e$var$D(i, null, u)), null != (i = n.__c)) {
        if (i.componentWillUnmount) try {
            i.componentWillUnmount();
        } catch (n) {
            $450fc775b2f7950e$export$41c562ebe57d11e2.__e(n, u);
        }
        i.base = i.__P = null;
    }
    if (i = n.__k) for(r = 0; r < i.length; r++)i[r] && $450fc775b2f7950e$var$E(i[r], u, t || "function" != typeof n.type);
    t || $450fc775b2f7950e$var$g(n.__e), n.__c = n.__ = n.__e = void 0;
}
function $450fc775b2f7950e$var$G(n, l, u) {
    return this.constructor(n, u);
}
function $450fc775b2f7950e$export$b3890eb0ae9dca99(u, t, i) {
    var r, o, e, f;
    t == document && (t = document.documentElement), $450fc775b2f7950e$export$41c562ebe57d11e2.__ && $450fc775b2f7950e$export$41c562ebe57d11e2.__(u, t), o = (r = "function" == typeof i) ? null : i && i.__k || t.__k, e = [], f = [], $450fc775b2f7950e$var$z(t, u = (!r && i || t).__k = $450fc775b2f7950e$export$c8a8987d4410bf2d($450fc775b2f7950e$export$ffb0004e005737fa, null, [
        u
    ]), o || $450fc775b2f7950e$var$p, $450fc775b2f7950e$var$p, t.namespaceURI, !r && i ? [
        i
    ] : o ? null : t.firstChild ? $450fc775b2f7950e$var$n.call(t.childNodes) : null, e, !r && i ? i : o ? o.__e : t.firstChild, r, f), $450fc775b2f7950e$var$V(e, u, f);
}
function $450fc775b2f7950e$export$fa8d919ba61d84db(n, l) {
    $450fc775b2f7950e$export$b3890eb0ae9dca99(n, l, $450fc775b2f7950e$export$fa8d919ba61d84db);
}
function $450fc775b2f7950e$export$e530037191fcd5d7(l, u, t) {
    var i, r, o, e, f = $450fc775b2f7950e$var$w({}, l.props);
    for(o in l.type && l.type.defaultProps && (e = l.type.defaultProps), u)"key" == o ? i = u[o] : "ref" == o ? r = u[o] : f[o] = void 0 === u[o] && null != e ? e[o] : u[o];
    return arguments.length > 2 && (f.children = arguments.length > 3 ? $450fc775b2f7950e$var$n.call(arguments, 2) : t), $450fc775b2f7950e$var$m(l.type, f, i || l.key, r || l.ref, null);
}
function $450fc775b2f7950e$export$fd42f52fd3ae1109(n) {
    function l(n) {
        var u, t;
        return this.getChildContext || (u = new Set, (t = {})[l.__c] = this, this.getChildContext = function() {
            return t;
        }, this.componentWillUnmount = function() {
            u = null;
        }, this.shouldComponentUpdate = function(n) {
            this.props.value != n.value && u.forEach(function(n) {
                n.__e = !0, $450fc775b2f7950e$var$$(n);
            });
        }, this.sub = function(n) {
            u.add(n);
            var l = n.componentWillUnmount;
            n.componentWillUnmount = function() {
                u && u.delete(n), l && l.call(n);
            };
        }), n.children;
    }
    return l.__c = "__cC" + $450fc775b2f7950e$var$h++, l.__ = n, l.Provider = l.__l = (l.Consumer = function(n, l) {
        return n.children(l);
    }).contextType = l, l;
}
$450fc775b2f7950e$var$n = $450fc775b2f7950e$var$v.slice, $450fc775b2f7950e$export$41c562ebe57d11e2 = {
    __e: function(n, l, u, t) {
        for(var i, r, o; l = l.__;)if ((i = l.__c) && !i.__) try {
            if ((r = i.constructor) && null != r.getDerivedStateFromError && (i.setState(r.getDerivedStateFromError(n)), o = i.__d), null != i.componentDidCatch && (i.componentDidCatch(n, t || {}), o = i.__d), o) return i.__E = i;
        } catch (l) {
            n = l;
        }
        throw n;
    }
}, $450fc775b2f7950e$var$u = 0, $450fc775b2f7950e$export$a8257692ac88316c = function(n) {
    return null != n && void 0 === n.constructor;
}, $450fc775b2f7950e$export$16fa2f45be04daa8.prototype.setState = function(n, l) {
    var u;
    u = null != this.__s && this.__s != this.state ? this.__s : this.__s = $450fc775b2f7950e$var$w({}, this.state), "function" == typeof n && (n = n($450fc775b2f7950e$var$w({}, u), this.props)), n && $450fc775b2f7950e$var$w(u, n), null != n && this.__v && (l && this._sb.push(l), $450fc775b2f7950e$var$$(this));
}, $450fc775b2f7950e$export$16fa2f45be04daa8.prototype.forceUpdate = function(n) {
    this.__v && (this.__e = !0, n && this.__h.push(n), $450fc775b2f7950e$var$$(this));
}, $450fc775b2f7950e$export$16fa2f45be04daa8.prototype.render = $450fc775b2f7950e$export$ffb0004e005737fa, $450fc775b2f7950e$var$i = [], $450fc775b2f7950e$var$o = "function" == typeof Promise ? Promise.prototype.then.bind(Promise.resolve()) : setTimeout, $450fc775b2f7950e$var$e = function(n, l) {
    return n.__v.__b - l.__v.__b;
}, $450fc775b2f7950e$var$I.__r = 0, $450fc775b2f7950e$var$f = /(PointerCapture)$|Capture$/i, $450fc775b2f7950e$var$c = 0, $450fc775b2f7950e$var$s = $450fc775b2f7950e$var$O(!1), $450fc775b2f7950e$var$a = $450fc775b2f7950e$var$O(!0), $450fc775b2f7950e$var$h = 0;


var $563cc721c6a67067$var$t = /["&<]/;
function $563cc721c6a67067$var$n(r) {
    if (0 === r.length || !1 === $563cc721c6a67067$var$t.test(r)) return r;
    for(var e = 0, n = 0, o = "", f = ""; n < r.length; n++){
        switch(r.charCodeAt(n)){
            case 34:
                f = "&quot;";
                break;
            case 38:
                f = "&amp;";
                break;
            case 60:
                f = "&lt;";
                break;
            default:
                continue;
        }
        n !== e && (o += r.slice(e, n)), o += f, e = n + 1;
    }
    return n !== e && (o += r.slice(e, n)), o;
}
var $563cc721c6a67067$var$o = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i, $563cc721c6a67067$var$f = 0, $563cc721c6a67067$var$i = Array.isArray;
function $563cc721c6a67067$export$34b9dba7ce09269b(e, t, n, o, i, u) {
    t || (t = {});
    var a, c, p = t;
    if ("ref" in p) for(c in p = {}, t)"ref" == c ? a = t[c] : p[c] = t[c];
    var l = {
        type: e,
        props: p,
        key: n,
        ref: a,
        __k: null,
        __: null,
        __b: 0,
        __e: null,
        __c: null,
        constructor: void 0,
        __v: --$563cc721c6a67067$var$f,
        __i: -1,
        __u: 0,
        __source: i,
        __self: u
    };
    if ("function" == typeof e && (a = e.defaultProps)) for(c in a)void 0 === p[c] && (p[c] = a[c]);
    return (0, $450fc775b2f7950e$export$41c562ebe57d11e2).vnode && (0, $450fc775b2f7950e$export$41c562ebe57d11e2).vnode(l), l;
}
function $563cc721c6a67067$export$45700d561b2268ac(r) {
    var t = $563cc721c6a67067$export$34b9dba7ce09269b((0, $450fc775b2f7950e$export$ffb0004e005737fa), {
        tpl: r,
        exprs: [].slice.call(arguments, 1)
    });
    return t.key = t.__v, t;
}
var $563cc721c6a67067$var$c = {}, $563cc721c6a67067$var$p = /[A-Z]/g;
function $563cc721c6a67067$export$991f6ffe102e5bac(e, t) {
    if ((0, $450fc775b2f7950e$export$41c562ebe57d11e2).attr) {
        var f = (0, $450fc775b2f7950e$export$41c562ebe57d11e2).attr(e, t);
        if ("string" == typeof f) return f;
    }
    if (t = function(r) {
        return null !== r && "object" == typeof r && "function" == typeof r.valueOf ? r.valueOf() : r;
    }(t), "ref" === e || "key" === e) return "";
    if ("style" === e && "object" == typeof t) {
        var i = "";
        for(var u in t){
            var a = t[u];
            if (null != a && "" !== a) {
                var l = "-" == u[0] ? u : $563cc721c6a67067$var$c[u] || ($563cc721c6a67067$var$c[u] = u.replace($563cc721c6a67067$var$p, "-$&").toLowerCase()), s = ";";
                "number" != typeof a || l.startsWith("--") || $563cc721c6a67067$var$o.test(l) || (s = "px;"), i = i + l + ":" + a + s;
            }
        }
        return e + '="' + $563cc721c6a67067$var$n(i) + '"';
    }
    return null == t || !1 === t || "function" == typeof t || "object" == typeof t ? "" : !0 === t ? e : e + '="' + $563cc721c6a67067$var$n("" + t) + '"';
}
function $563cc721c6a67067$export$40e96e718441efeb(r) {
    if (null == r || "boolean" == typeof r || "function" == typeof r) return null;
    if ("object" == typeof r) {
        if (void 0 === r.constructor) return r;
        if ($563cc721c6a67067$var$i(r)) {
            for(var e = 0; e < r.length; e++)r[e] = $563cc721c6a67067$export$40e96e718441efeb(r[e]);
            return r;
        }
    }
    return $563cc721c6a67067$var$n("" + r);
}





var $d6bdfea1a1e13052$var$t, $d6bdfea1a1e13052$var$r, $d6bdfea1a1e13052$var$u, $d6bdfea1a1e13052$var$i, $d6bdfea1a1e13052$var$o = 0, $d6bdfea1a1e13052$var$f = [], $d6bdfea1a1e13052$var$c = (0, $450fc775b2f7950e$export$41c562ebe57d11e2), $d6bdfea1a1e13052$var$e = $d6bdfea1a1e13052$var$c.__b, $d6bdfea1a1e13052$var$a = $d6bdfea1a1e13052$var$c.__r, $d6bdfea1a1e13052$var$v = $d6bdfea1a1e13052$var$c.diffed, $d6bdfea1a1e13052$var$l = $d6bdfea1a1e13052$var$c.__c, $d6bdfea1a1e13052$var$m = $d6bdfea1a1e13052$var$c.unmount, $d6bdfea1a1e13052$var$s = $d6bdfea1a1e13052$var$c.__;
function $d6bdfea1a1e13052$var$p(n, t) {
    $d6bdfea1a1e13052$var$c.__h && $d6bdfea1a1e13052$var$c.__h($d6bdfea1a1e13052$var$r, n, $d6bdfea1a1e13052$var$o || t), $d6bdfea1a1e13052$var$o = 0;
    var u = $d6bdfea1a1e13052$var$r.__H || ($d6bdfea1a1e13052$var$r.__H = {
        __: [],
        __h: []
    });
    return n >= u.__.length && u.__.push({}), u.__[n];
}
function $d6bdfea1a1e13052$export$60241385465d0a34(n) {
    return $d6bdfea1a1e13052$var$o = 1, $d6bdfea1a1e13052$export$13e3392192263954($d6bdfea1a1e13052$var$D, n);
}
function $d6bdfea1a1e13052$export$13e3392192263954(n, u, i) {
    var o = $d6bdfea1a1e13052$var$p($d6bdfea1a1e13052$var$t++, 2);
    if (o.t = n, !o.__c && (o.__ = [
        i ? i(u) : $d6bdfea1a1e13052$var$D(void 0, u),
        function(n) {
            var t = o.__N ? o.__N[0] : o.__[0], r = o.t(t, n);
            t !== r && (o.__N = [
                r,
                o.__[1]
            ], o.__c.setState({}));
        }
    ], o.__c = $d6bdfea1a1e13052$var$r, !$d6bdfea1a1e13052$var$r.__f)) {
        var f = function(n, t, r) {
            if (!o.__c.__H) return !0;
            var u = o.__c.__H.__.filter(function(n) {
                return n.__c;
            });
            if (u.every(function(n) {
                return !n.__N;
            })) return !c || c.call(this, n, t, r);
            var i = o.__c.props !== n;
            return u.some(function(n) {
                if (n.__N) {
                    var t = n.__[0];
                    n.__ = n.__N, n.__N = void 0, t !== n.__[0] && (i = !0);
                }
            }), c && c.call(this, n, t, r) || i;
        };
        $d6bdfea1a1e13052$var$r.__f = !0;
        var c = $d6bdfea1a1e13052$var$r.shouldComponentUpdate, e = $d6bdfea1a1e13052$var$r.componentWillUpdate;
        $d6bdfea1a1e13052$var$r.componentWillUpdate = function(n, t, r) {
            if (this.__e) {
                var u = c;
                c = void 0, f(n, t, r), c = u;
            }
            e && e.call(this, n, t, r);
        }, $d6bdfea1a1e13052$var$r.shouldComponentUpdate = f;
    }
    return o.__N || o.__;
}
function $d6bdfea1a1e13052$export$6d9c69b0de29b591(n, u) {
    var i = $d6bdfea1a1e13052$var$p($d6bdfea1a1e13052$var$t++, 3);
    !$d6bdfea1a1e13052$var$c.__s && $d6bdfea1a1e13052$var$C(i.__H, u) && (i.__ = n, i.u = u, $d6bdfea1a1e13052$var$r.__H.__h.push(i));
}
function $d6bdfea1a1e13052$export$e5c5a5f917a5871c(n, u) {
    var i = $d6bdfea1a1e13052$var$p($d6bdfea1a1e13052$var$t++, 4);
    !$d6bdfea1a1e13052$var$c.__s && $d6bdfea1a1e13052$var$C(i.__H, u) && (i.__ = n, i.u = u, $d6bdfea1a1e13052$var$r.__h.push(i));
}
function $d6bdfea1a1e13052$export$b8f5890fc79d6aca(n) {
    return $d6bdfea1a1e13052$var$o = 5, $d6bdfea1a1e13052$export$1538c33de8887b59(function() {
        return {
            current: n
        };
    }, []);
}
function $d6bdfea1a1e13052$export$d5a552a76deda3c2(n, t, r) {
    $d6bdfea1a1e13052$var$o = 6, $d6bdfea1a1e13052$export$e5c5a5f917a5871c(function() {
        if ("function" == typeof n) {
            var r = n(t());
            return function() {
                n(null), r && "function" == typeof r && r();
            };
        }
        if (n) return n.current = t(), function() {
            return n.current = null;
        };
    }, null == r ? r : r.concat(n));
}
function $d6bdfea1a1e13052$export$1538c33de8887b59(n, r) {
    var u = $d6bdfea1a1e13052$var$p($d6bdfea1a1e13052$var$t++, 7);
    return $d6bdfea1a1e13052$var$C(u.__H, r) && (u.__ = n(), u.__H = r, u.__h = n), u.__;
}
function $d6bdfea1a1e13052$export$35808ee640e87ca7(n, t) {
    return $d6bdfea1a1e13052$var$o = 8, $d6bdfea1a1e13052$export$1538c33de8887b59(function() {
        return n;
    }, t);
}
function $d6bdfea1a1e13052$export$fae74005e78b1a27(n) {
    var u = $d6bdfea1a1e13052$var$r.context[n.__c], i = $d6bdfea1a1e13052$var$p($d6bdfea1a1e13052$var$t++, 9);
    return i.c = n, u ? (null == i.__ && (i.__ = !0, u.sub($d6bdfea1a1e13052$var$r)), u.props.value) : n.__;
}
function $d6bdfea1a1e13052$export$dc8fbce3eb94dc1e(n, t) {
    $d6bdfea1a1e13052$var$c.useDebugValue && $d6bdfea1a1e13052$var$c.useDebugValue(t ? t(n) : n);
}
function $d6bdfea1a1e13052$export$c052f6604b7d51fe(n) {
    var u = $d6bdfea1a1e13052$var$p($d6bdfea1a1e13052$var$t++, 10), i = $d6bdfea1a1e13052$export$60241385465d0a34();
    return u.__ = n, $d6bdfea1a1e13052$var$r.componentDidCatch || ($d6bdfea1a1e13052$var$r.componentDidCatch = function(n, t) {
        u.__ && u.__(n, t), i[1](n);
    }), [
        i[0],
        function() {
            i[1](void 0);
        }
    ];
}
function $d6bdfea1a1e13052$export$f680877a34711e37() {
    var n = $d6bdfea1a1e13052$var$p($d6bdfea1a1e13052$var$t++, 11);
    if (!n.__) {
        for(var u = $d6bdfea1a1e13052$var$r.__v; null !== u && !u.__m && null !== u.__;)u = u.__;
        var i = u.__m || (u.__m = [
            0,
            0
        ]);
        n.__ = "P" + i[0] + "-" + i[1]++;
    }
    return n.__;
}
function $d6bdfea1a1e13052$var$j() {
    for(var n; n = $d6bdfea1a1e13052$var$f.shift();){
        var t = n.__H;
        if (n.__P && t) try {
            t.__h.some($d6bdfea1a1e13052$var$z), t.__h.some($d6bdfea1a1e13052$var$B), t.__h = [];
        } catch (r) {
            t.__h = [], $d6bdfea1a1e13052$var$c.__e(r, n.__v);
        }
    }
}
$d6bdfea1a1e13052$var$c.__b = function(n) {
    $d6bdfea1a1e13052$var$r = null, $d6bdfea1a1e13052$var$e && $d6bdfea1a1e13052$var$e(n);
}, $d6bdfea1a1e13052$var$c.__ = function(n, t) {
    n && t.__k && t.__k.__m && (n.__m = t.__k.__m), $d6bdfea1a1e13052$var$s && $d6bdfea1a1e13052$var$s(n, t);
}, $d6bdfea1a1e13052$var$c.__r = function(n) {
    $d6bdfea1a1e13052$var$a && $d6bdfea1a1e13052$var$a(n), $d6bdfea1a1e13052$var$t = 0;
    var i = ($d6bdfea1a1e13052$var$r = n.__c).__H;
    i && ($d6bdfea1a1e13052$var$u === $d6bdfea1a1e13052$var$r ? (i.__h = [], $d6bdfea1a1e13052$var$r.__h = [], i.__.some(function(n) {
        n.__N && (n.__ = n.__N), n.u = n.__N = void 0;
    })) : (i.__h.some($d6bdfea1a1e13052$var$z), i.__h.some($d6bdfea1a1e13052$var$B), i.__h = [], $d6bdfea1a1e13052$var$t = 0)), $d6bdfea1a1e13052$var$u = $d6bdfea1a1e13052$var$r;
}, $d6bdfea1a1e13052$var$c.diffed = function(n) {
    $d6bdfea1a1e13052$var$v && $d6bdfea1a1e13052$var$v(n);
    var t = n.__c;
    t && t.__H && (t.__H.__h.length && (1 !== $d6bdfea1a1e13052$var$f.push(t) && $d6bdfea1a1e13052$var$i === $d6bdfea1a1e13052$var$c.requestAnimationFrame || (($d6bdfea1a1e13052$var$i = $d6bdfea1a1e13052$var$c.requestAnimationFrame) || $d6bdfea1a1e13052$var$w)($d6bdfea1a1e13052$var$j)), t.__H.__.some(function(n) {
        n.u && (n.__H = n.u), n.u = void 0;
    })), $d6bdfea1a1e13052$var$u = $d6bdfea1a1e13052$var$r = null;
}, $d6bdfea1a1e13052$var$c.__c = function(n, t) {
    t.some(function(n) {
        try {
            n.__h.some($d6bdfea1a1e13052$var$z), n.__h = n.__h.filter(function(n) {
                return !n.__ || $d6bdfea1a1e13052$var$B(n);
            });
        } catch (r) {
            t.some(function(n) {
                n.__h && (n.__h = []);
            }), t = [], $d6bdfea1a1e13052$var$c.__e(r, n.__v);
        }
    }), $d6bdfea1a1e13052$var$l && $d6bdfea1a1e13052$var$l(n, t);
}, $d6bdfea1a1e13052$var$c.unmount = function(n) {
    $d6bdfea1a1e13052$var$m && $d6bdfea1a1e13052$var$m(n);
    var t, r = n.__c;
    r && r.__H && (r.__H.__.some(function(n) {
        try {
            $d6bdfea1a1e13052$var$z(n);
        } catch (n) {
            t = n;
        }
    }), r.__H = void 0, t && $d6bdfea1a1e13052$var$c.__e(t, r.__v));
};
var $d6bdfea1a1e13052$var$k = "function" == typeof requestAnimationFrame;
function $d6bdfea1a1e13052$var$w(n) {
    var t, r = function() {
        clearTimeout(u), $d6bdfea1a1e13052$var$k && cancelAnimationFrame(t), setTimeout(n);
    }, u = setTimeout(r, 35);
    $d6bdfea1a1e13052$var$k && (t = requestAnimationFrame(r));
}
function $d6bdfea1a1e13052$var$z(n) {
    var t = $d6bdfea1a1e13052$var$r, u = n.__c;
    "function" == typeof u && (n.__c = void 0, u()), $d6bdfea1a1e13052$var$r = t;
}
function $d6bdfea1a1e13052$var$B(n) {
    var t = $d6bdfea1a1e13052$var$r;
    n.__c = n.__(), $d6bdfea1a1e13052$var$r = t;
}
function $d6bdfea1a1e13052$var$C(n, t) {
    return !n || n.length !== t.length || t.some(function(t, r) {
        return t !== n[r];
    });
}
function $d6bdfea1a1e13052$var$D(n, t) {
    return "function" == typeof t ? t(n) : t;
}






function $7282a58d465f88c4$export$e69968945bee9866({ variant: variant = "primary", className: className = "", ...props }) {
    let variantClasses = "";
    if (variant === "primary") variantClasses = "bg-brutal-orange text-black dark:text-gray-900 hover:bg-brutal-orange-hover";
    else if (variant === "secondary") variantClasses = "bg-white dark:bg-gray-950 text-gray-900 dark:text-gray-100 hover:bg-orange-50 dark:hover:bg-gray-800";
    else if (variant === "ghost") variantClasses = "bg-transparent text-gray-900 dark:text-gray-100 hover:bg-orange-50 dark:hover:bg-gray-800";
    const base = "brutal-btn inline-flex items-center justify-center min-h-[2.5rem] px-5 py-2.5 font-semibold rounded-none border-2 border-black dark:border-gray-100";
    return /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("button", {
        ...props,
        className: `${base} ${variantClasses} ${className}`.trim()
    });
}
function $7282a58d465f88c4$export$e0d8aacd8d06bfd5({ className: className = "", type: type = "text", ...props }) {
    const base = "brutal-input px-4 py-2.5 text-base rounded-none border-2 border-black dark:border-gray-100 bg-white dark:bg-gray-950 text-gray-900 dark:text-gray-100";
    return /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("input", {
        ...props,
        type: type,
        className: `${base} ${className}`.trim()
    });
}
function $7282a58d465f88c4$export$460dfbe7d36d7938({ className: className = "", ...props }) {
    const base = "brutal-input px-2 py-1.5 text-sm rounded-none border-2 border-black dark:border-gray-100 bg-white dark:bg-gray-950 text-gray-900 dark:text-gray-100";
    return /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("select", {
        ...props,
        className: `${base} ${className}`.trim()
    });
}




const $c9d11e0a6831e0d1$var$AVATAR_SIZE = 16;
/** High-entropy 32-bit hash from string (djb2-like with extra mixing). */ function $c9d11e0a6831e0d1$var$hash32(s, seed) {
    let h = seed * 0x811c9dc5 >>> 0;
    for(let i = 0; i < s.length; i += 1){
        h = Math.imul(h ^ s.charCodeAt(i), 0x01000193);
        h = h >>> 0 ^ (h << 13 | h >>> 19);
    }
    return h >>> 0;
}
/** Returns 8 uint32 values from username for avatar variation. */ function $c9d11e0a6831e0d1$var$multiHash(username) {
    const out = [];
    for(let i = 0; i < 8; i += 1)out.push($c9d11e0a6831e0d1$var$hash32(username, i + 1));
    return out;
}
function $c9d11e0a6831e0d1$var$setPixel(bits, width, x, y, on) {
    if (x < 0 || x >= width || y < 0 || y >= width) return;
    const i = y * width + x;
    const byteIndex = i >> 3;
    const bitIndex = 7 - (i & 7);
    if (on) bits[byteIndex] |= 1 << bitIndex;
    else bits[byteIndex] &= ~(1 << bitIndex);
}
/** Rotate point (x,y) around (cx,cy) by angle in 90° steps (0..3). */ function $c9d11e0a6831e0d1$var$rotate90(x, y, cx, cy, steps) {
    let dx = x - cx;
    let dy = y - cy;
    for(let k = 0; k < (steps % 4 + 4) % 4; k += 1){
        const t = dx;
        dx = -dy;
        dy = t;
    }
    return [
        cx + dx,
        cy + dy
    ];
}
function $c9d11e0a6831e0d1$export$4c80afb07a91a771(username) {
    const h = $c9d11e0a6831e0d1$var$multiHash(username || "?");
    const W = $c9d11e0a6831e0d1$var$AVATAR_SIZE;
    const byteCount = W * W >> 3;
    const bits = new Uint8Array(byteCount);
    const pattern = h[0] % 4;
    const spacing = h[1] % 3 + 1;
    const inclination = h[2] % 4;
    const invert = (h[3] & 1) === 1;
    const thick = h[4] % 2 === 1;
    const symmetry = (h[5] & 1) === 1;
    const cx = (W - 1) / 2;
    const cy = (W - 1) / 2;
    const clamp = (v)=>Math.max(0, Math.min(W - 1, Math.round(v)));
    const draw = (x, y, on)=>{
        const [rx, ry] = $c9d11e0a6831e0d1$var$rotate90(x, y, cx, cy, inclination);
        $c9d11e0a6831e0d1$var$setPixel(bits, W, clamp(rx), clamp(ry), on);
        if (symmetry) {
            const [sx, sy] = $c9d11e0a6831e0d1$var$rotate90(W - 1 - x, y, cx, cy, inclination);
            $c9d11e0a6831e0d1$var$setPixel(bits, W, clamp(sx), clamp(sy), on);
        }
    };
    if (pattern === 0) {
        for(let y = 0; y < W; y += 1)for(let x = 0; x < W; x += 1){
            const v = $c9d11e0a6831e0d1$var$hash32(`${username}:${x}:${y}`, h[6]) % spacing === 0;
            draw(x, y, invert ? !v : v);
        }
    } else if (pattern === 1) {
        const half = thick ? 2 : 1;
        for(let y = 0; y < W; y += 1)for(let x = 0; x < W; x += 1){
            const on = Math.abs(x - cx) < half || Math.abs(y - cy) < half;
            draw(x, y, invert ? !on : on);
        }
    } else if (pattern === 2) {
        const half = thick ? 2 : 1;
        for(let y = 0; y < W; y += 1)for(let x = 0; x < W; x += 1){
            const on = Math.abs(y - cy) < half;
            draw(x, y, invert ? !on : on);
        }
    } else {
        for(let y = 0; y < W; y += 1)for(let x = 0; x < W; x += 1){
            const on = Math.abs(x - cx - (y - cy)) < 1 || Math.abs(x - cx + (y - cy)) < 1;
            draw(x, y, invert ? !on : on);
        }
    }
    return {
        width: W,
        height: W,
        bits: bits
    };
}
function $c9d11e0a6831e0d1$export$2a73bcf51ef6df14(username, avatarsByUsername) {
    const stored = avatarsByUsername?.[username ?? ""];
    if (stored) return stored;
    return $c9d11e0a6831e0d1$export$4c80afb07a91a771(username ?? "?");
}
function $c9d11e0a6831e0d1$export$247d8033ea9f3ade(data) {
    if (!data || typeof data !== "object") return null;
    const anyData = data;
    const { bitmap: bitmap, width: width, height: height } = anyData;
    if (typeof bitmap !== "string" || typeof width !== "number" || typeof height !== "number" || !bitmap) return null;
    // base64 (no gzip) -> raw bytes
    let binary = "";
    try {
        binary = atob(bitmap);
    } catch  {
        return null;
    }
    const bytes = new Uint8Array(binary.length);
    for(let i = 0; i < binary.length; i += 1)bytes[i] = binary.charCodeAt(i);
    return {
        width: width,
        height: height,
        bits: bytes
    };
}


/**
 * Event-driven state for the calendar. applyEvent(state, event) updates state from one event.
 */ 
const $8228b3fd71ca6b09$export$b748117d79873787 = {
    heart: "\u2764",
    laugh: "\uD83D\uDE02",
    thumbs_up: "\uD83D\uDC4D",
    thumbs_down: "\uD83D\uDC4E"
};
const $8228b3fd71ca6b09$var$USER_COLOR_CLASSES = [
    'text-brutal-purple border-brutal-purple',
    'text-brutal-orange border-brutal-orange',
    'text-emerald-600 border-emerald-600',
    'text-rose-600 border-rose-600',
    'text-sky-600 border-sky-600',
    'text-amber-700 border-amber-700'
];
function $8228b3fd71ca6b09$export$1ad7b801017acf63(username) {
    const name = username?.trim() || 'System';
    let hash = 0;
    for(let i = 0; i < name.length; i += 1)hash = hash * 31 + name.charCodeAt(i) | 0;
    const idx = Math.abs(hash) % $8228b3fd71ca6b09$var$USER_COLOR_CLASSES.length;
    return $8228b3fd71ca6b09$var$USER_COLOR_CLASSES[idx];
}
function $8228b3fd71ca6b09$export$bf20776e1dcd45e7(state) {
    const used = new Set();
    for (const slot of Object.values(state.slotsById || {}))for (const shortcode of Object.keys(slot.reaction_counts || {})){
        const emoji = $8228b3fd71ca6b09$export$b748117d79873787[shortcode];
        if (emoji) used.add(emoji);
    }
    for (const counts of Object.values(state.reactionsByMessage || {})){
        for (const emoji of Object.keys(counts || {}))if (!/^[a-z_]+$/.test(emoji)) used.add(emoji);
    }
    return [
        ...used
    ];
}
function $8228b3fd71ca6b09$export$3ccacf16444f72a3(tagName) {
    const n = tagName.toLowerCase();
    if (n === 'winner') return 'bg-brutal-purple text-white dark:bg-brutal-purple-hover dark:text-white';
    if (n === 'vetoed') return 'bg-orange-700 text-white dark:bg-orange-600 dark:text-white';
    return 'bg-brutal-orange text-black dark:bg-brutal-orange-dark dark:text-gray-900';
}
function $8228b3fd71ca6b09$export$d4c72bab9d6cc13a() {
    return {
        slotsById: {},
        slotsByDate: {},
        tagsById: {},
        tagsBySlot: {},
        reactionsBySlot: {},
        userReactionBySlot: {},
        reactionsByUserBySlot: {},
        reactionsByMessage: {},
        reactionsByUserByMessage: {},
        logMessages: [],
        avatarsByUsername: {},
        calendarName: null,
        displayNameChain: undefined,
        lastEventId: 0
    };
}
function $8228b3fd71ca6b09$export$946482ddfe71b064(cookieUsername, chain) {
    if (!chain || !cookieUsername) return cookieUsername;
    let current = cookieUsername;
    const seen = new Set();
    while(chain[current] && !seen.has(current)){
        seen.add(current);
        current = chain[current];
    }
    return current;
}
function $8228b3fd71ca6b09$export$27ca81ea148fa005(state, event, options = {}) {
    const currentUsername = options.username ?? null;
    const { id: id, type: type, data: data, message: message, username: username, created_at: created_at } = event;
    const next = {
        ...state
    };
    next.lastEventId = id;
    const isChatReaction = type === 'chat_message_reaction_added' || type === 'chat_message_reaction_removed';
    if (!isChatReaction) {
        const logEntry = {
            id: id,
            type: type,
            message: message ?? '',
            username: username ?? '',
            created_at: created_at ?? ''
        };
        next.logMessages = [
            ...state.logMessages || [],
            logEntry
        ];
    }
    if (!data || typeof data !== 'object') return next;
    switch(type){
        case 'calendar_renamed':
            {
                const raw = data.name;
                const name = typeof raw === 'string' ? raw.trim() : '';
                next.calendarName = name || null;
                break;
            }
        case 'username_changed':
            {
                const raw = data.name;
                const toName = typeof raw === 'string' ? raw.trim() : '';
                if (toName && username) {
                    next.displayNameChain = {
                        ...state.displayNameChain ?? {},
                        [username]: toName
                    };
                    // New name inherits the previous name's avatar so the log shows the same face.
                    const prevAvatar = state.avatarsByUsername?.[username];
                    if (prevAvatar) next.avatarsByUsername = {
                        ...next.avatarsByUsername ?? {},
                        [toName]: prevAvatar
                    };
                }
                break;
            }
        case 'slot_created':
            {
                const slot = {
                    id: data.slot_id,
                    user_id: data.user_id,
                    date: data.date,
                    start_time: data.start_time,
                    end_time: data.end_time,
                    description: data.description ?? '',
                    creator_name: data.creator_name ?? '',
                    tags: next.tagsBySlot[data.slot_id] ?? [],
                    reaction_counts: next.reactionsBySlot[data.slot_id] ?? {},
                    current_user_emoji: next.userReactionBySlot[data.slot_id] ?? ''
                };
                next.slotsById = {
                    ...next.slotsById,
                    [data.slot_id]: slot
                };
                const date = data.date;
                next.slotsByDate = {
                    ...next.slotsByDate
                };
                next.slotsByDate[date] = [
                    ...next.slotsByDate[date] || [],
                    slot
                ];
                break;
            }
        case 'slot_deleted':
            {
                const sid = data.slot_id;
                const slot = next.slotsById[sid];
                if (slot) {
                    const { [sid]: _, ...rest } = next.slotsById;
                    next.slotsById = rest;
                    const slotDate = slot.date;
                    next.slotsByDate = {
                        ...next.slotsByDate
                    };
                    next.slotsByDate[slotDate] = (next.slotsByDate[slotDate] || []).filter((s)=>s.id !== sid);
                }
                break;
            }
        case 'slot_description_updated':
            {
                const slot = next.slotsById[data.slot_id];
                if (slot) {
                    next.slotsById = {
                        ...next.slotsById,
                        [data.slot_id]: {
                            ...slot,
                            description: data.description ?? ''
                        }
                    };
                    const slotDate = slot.date;
                    next.slotsByDate = {
                        ...next.slotsByDate
                    };
                    next.slotsByDate[slotDate] = (next.slotsByDate[slotDate] || []).map((s)=>s.id === data.slot_id ? {
                            ...s,
                            description: data.description ?? ''
                        } : s);
                }
                break;
            }
        case 'reaction_set':
            {
                const sid = data.slot_id;
                const emoji = data.emoji;
                const who = String(data.username ?? '');
                next.reactionsBySlot = {
                    ...next.reactionsBySlot
                };
                next.reactionsByUserBySlot = {
                    ...next.reactionsByUserBySlot
                };
                const userMap = next.reactionsByUserBySlot[sid] ?? {};
                const prevEmoji = userMap[who];
                const counts = {
                    ...next.reactionsBySlot[sid] || {}
                };
                if (prevEmoji) {
                    counts[prevEmoji] = Math.max(0, (counts[prevEmoji] || 0) - 1);
                    if (counts[prevEmoji] === 0) delete counts[prevEmoji];
                }
                counts[emoji] = (counts[emoji] || 0) + 1;
                next.reactionsBySlot[sid] = counts;
                next.reactionsByUserBySlot[sid] = {
                    ...userMap,
                    [who]: emoji
                };
                if (currentUsername != null && who === currentUsername) next.userReactionBySlot = {
                    ...next.userReactionBySlot,
                    [sid]: emoji
                };
                const slot = next.slotsById[sid];
                if (slot) {
                    next.slotsById = {
                        ...next.slotsById,
                        [sid]: {
                            ...slot,
                            reaction_counts: counts
                        }
                    };
                    const slotDate = slot.date;
                    next.slotsByDate = {
                        ...next.slotsByDate
                    };
                    next.slotsByDate[slotDate] = (next.slotsByDate[slotDate] || []).map((s)=>s.id === sid ? {
                            ...s,
                            reaction_counts: counts
                        } : s);
                }
                break;
            }
        case 'reaction_cleared':
            {
                const sid = data.slot_id;
                const who = String(data.username ?? '');
                next.reactionsByUserBySlot = {
                    ...next.reactionsByUserBySlot
                };
                const userMap = next.reactionsByUserBySlot[sid] ?? {};
                const clearedEmoji = data.emoji ?? userMap[who] ?? next.userReactionBySlot[sid];
                const m = {
                    ...userMap
                };
                delete m[who];
                next.reactionsByUserBySlot[sid] = Object.keys(m).length ? m : {};
                if (currentUsername != null && who === currentUsername) {
                    next.userReactionBySlot = {
                        ...next.userReactionBySlot
                    };
                    delete next.userReactionBySlot[sid];
                }
                next.reactionsBySlot = {
                    ...next.reactionsBySlot
                };
                const counts = {
                    ...next.reactionsBySlot[sid] || {}
                };
                if (clearedEmoji) {
                    counts[clearedEmoji] = Math.max(0, (counts[clearedEmoji] || 0) - 1);
                    if (counts[clearedEmoji] === 0) delete counts[clearedEmoji];
                }
                next.reactionsBySlot[sid] = counts;
                const slot = next.slotsById[sid];
                if (slot) {
                    next.slotsById = {
                        ...next.slotsById,
                        [sid]: {
                            ...slot,
                            reaction_counts: counts
                        }
                    };
                    const slotDate = slot.date;
                    next.slotsByDate = {
                        ...next.slotsByDate
                    };
                    next.slotsByDate[slotDate] = (next.slotsByDate[slotDate] || []).map((s)=>s.id === sid ? {
                            ...s,
                            reaction_counts: counts
                        } : s);
                }
                break;
            }
        case 'tag_created':
            next.tagsById = {
                ...next.tagsById,
                [data.tag_id]: {
                    id: data.tag_id,
                    name: String(data.name ?? '')
                }
            };
            break;
        case 'tag_added_to_slot':
            {
                const sid = data.slot_id;
                next.tagsBySlot = {
                    ...next.tagsBySlot
                };
                next.tagsBySlot[sid] = [
                    ...next.tagsBySlot[sid] || [],
                    {
                        tag_id: data.tag_id,
                        tag_name: data.tag_name
                    }
                ];
                const slot = next.slotsById[sid];
                if (slot) {
                    const tags = next.tagsBySlot[sid] || [];
                    next.slotsById = {
                        ...next.slotsById,
                        [sid]: {
                            ...slot,
                            tags: tags
                        }
                    };
                    const slotDate = slot.date;
                    next.slotsByDate = {
                        ...next.slotsByDate
                    };
                    next.slotsByDate[slotDate] = (next.slotsByDate[slotDate] || []).map((s)=>s.id === sid ? {
                            ...s,
                            tags: tags
                        } : s);
                }
                break;
            }
        case 'tag_removed_from_slot':
            {
                const sid = data.slot_id;
                next.tagsBySlot = {
                    ...next.tagsBySlot
                };
                next.tagsBySlot[sid] = (next.tagsBySlot[sid] || []).filter((t)=>t.tag_id !== data.tag_id);
                const slot = next.slotsById[sid];
                if (slot) {
                    const tags = next.tagsBySlot[sid] || [];
                    next.slotsById = {
                        ...next.slotsById,
                        [sid]: {
                            ...slot,
                            tags: tags
                        }
                    };
                    const slotDate = slot.date;
                    next.slotsByDate = {
                        ...next.slotsByDate
                    };
                    next.slotsByDate[slotDate] = (next.slotsByDate[slotDate] || []).map((s)=>s.id === sid ? {
                            ...s,
                            tags: tags
                        } : s);
                }
                break;
            }
        case 'chat_message_posted':
            break;
        case 'chat_message_reaction_added':
            {
                const mid = data.message_id;
                const emoji = data.emoji;
                const who = String(data.username ?? '');
                next.reactionsByMessage = {
                    ...next.reactionsByMessage
                };
                next.reactionsByUserByMessage = {
                    ...next.reactionsByUserByMessage
                };
                const userMap = next.reactionsByUserByMessage[mid] ?? {};
                const userEmojis = Array.isArray(userMap[who]) ? userMap[who] : userMap[who] ? [
                    userMap[who]
                ] : [];
                if (!userEmojis.includes(emoji)) {
                    const nextEmojis = [
                        ...userEmojis,
                        emoji
                    ];
                    const counts = {
                        ...next.reactionsByMessage[mid] || {}
                    };
                    counts[emoji] = (counts[emoji] || 0) + 1;
                    next.reactionsByMessage[mid] = counts;
                    next.reactionsByUserByMessage[mid] = {
                        ...userMap,
                        [who]: nextEmojis
                    };
                }
                break;
            }
        case 'chat_message_reaction_removed':
            {
                const mid = data.message_id;
                let emoji = data.emoji ?? '';
                const who = String(data.username ?? '');
                next.reactionsByUserByMessage = {
                    ...next.reactionsByUserByMessage
                };
                const userMap = next.reactionsByUserByMessage[mid] ?? {};
                const userEmojis = Array.isArray(userMap[who]) ? userMap[who] : userMap[who] ? [
                    userMap[who]
                ] : [];
                if (!emoji && userEmojis.length > 0) emoji = userEmojis[0];
                const nextEmojis = userEmojis.filter((e)=>e !== emoji);
                next.reactionsByUserByMessage[mid] = nextEmojis.length > 0 ? {
                    ...userMap,
                    [who]: nextEmojis
                } : (()=>{
                    const m = {
                        ...userMap
                    };
                    delete m[who];
                    return Object.keys(m).length ? m : {};
                })();
                next.reactionsByMessage = {
                    ...next.reactionsByMessage
                };
                const counts = {
                    ...next.reactionsByMessage[mid] || {}
                };
                if (emoji) {
                    counts[emoji] = Math.max(0, (counts[emoji] || 0) - 1);
                    if (counts[emoji] === 0) delete counts[emoji];
                }
                next.reactionsByMessage[mid] = counts;
                break;
            }
        case 'user_face_set':
            {
                const anyData = data;
                const who = String(anyData.username ?? username ?? '').trim();
                if (!who) break;
                const decoded = (0, $c9d11e0a6831e0d1$export$247d8033ea9f3ade)(data);
                const avatars = {
                    ...state.avatarsByUsername || {}
                };
                if (decoded) avatars[who] = decoded;
                else delete avatars[who];
                next.avatarsByUsername = avatars;
                break;
            }
        default:
            break;
    }
    return next;
}


function $dc094c5397bc487f$export$2e2bcd8739ae039({ username: username, avatar: avatar, avatarsByUsername: avatarsByUsername, size: size = 24 }) {
    const canvasRef = (0, $d6bdfea1a1e13052$export$b8f5890fc79d6aca)(null);
    const toDraw = (0, $c9d11e0a6831e0d1$export$2a73bcf51ef6df14)(username, avatarsByUsername ?? (avatar != null ? {
        [username]: avatar
    } : undefined));
    (0, $d6bdfea1a1e13052$export$6d9c69b0de29b591)(()=>{
        const canvas = canvasRef.current;
        if (!canvas || !toDraw) return;
        const ctx = canvas.getContext("2d");
        if (!ctx) return;
        const { width: srcW, height: srcH, bits: bits } = toDraw;
        // Draw at native resolution so we don't lose pixels; display size is set via CSS.
        canvas.width = srcW;
        canvas.height = srcH;
        ctx.imageSmoothingEnabled = false;
        const imageData = ctx.createImageData(srcW, srcH);
        const data = imageData.data;
        for(let dy = 0; dy < srcH; dy += 1)for(let dx = 0; dx < srcW; dx += 1){
            const i = dy * srcW + dx;
            const byteIndex = i >> 3;
            const bitIndex = 7 - (i & 7);
            const bit = bits[byteIndex] >> bitIndex & 1;
            const v = bit ? 255 : 0;
            const offset = (dy * srcW + dx) * 4;
            data[offset] = v;
            data[offset + 1] = v;
            data[offset + 2] = v;
            data[offset + 3] = 255;
        }
        ctx.putImageData(imageData, 0, 0);
    }, [
        toDraw
    ]);
    const colorClass = (0, $8228b3fd71ca6b09$export$1ad7b801017acf63)(username);
    return /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("canvas", {
        ref: canvasRef,
        className: `avatar-canvas rounded-sm border-2 ${colorClass}`,
        style: {
            width: size,
            height: size
        },
        "aria-hidden": "true"
    });
}


function $7f8cb6be0e7ee0fb$export$5d608ab1c3dd731({ title: title = "Meetday" }) {
    return /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("header", {
        className: "flex flex-wrap items-center justify-between gap-3 px-6 py-4 border-b-4 border-black dark:border-gray-100 flex-shrink-0 bg-white dark:bg-gray-950",
        children: [
            /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("h1", {
                className: "m-0 text-3xl sm:text-4xl font-logo font-bold text-gray-900 dark:text-white tracking-tight uppercase",
                children: title
            }),
            /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)((0, $7282a58d465f88c4$export$e69968945bee9866), {
                type: "button",
                variant: "primary",
                className: "min-h-[2.5rem] px-5 py-2.5",
                onClick: ()=>window.meetdayToggleTheme?.(),
                "aria-label": "Toggle light/dark theme",
                children: "Theme"
            })
        ]
    });
}
const $7f8cb6be0e7ee0fb$var$USER_ICON_SIZE = 48;
function $7f8cb6be0e7ee0fb$export$9d9dfe772dd5e376({ slug: slug, calendarName: calendarName, avatar: avatar, username: username, shareURL: shareURL, onEditCalendarName: onEditCalendarName, onOpenSettings: onOpenSettings }) {
    const displayName = calendarName && calendarName.trim() || slug;
    const handleCopyShare = ()=>{
        if (!navigator.clipboard || !shareURL) return;
        navigator.clipboard.writeText(shareURL).then(()=>{
            const el = document.querySelector(".share-link[data-copy-url]");
            if (el) {
                const orig = el.textContent;
                el.textContent = "Copied!";
                el.classList.add("share-link-copied");
                setTimeout(()=>{
                    el.textContent = orig ?? "";
                    el.classList.remove("share-link-copied");
                }, 1500);
            }
        });
    };
    return /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("header", {
        className: "flex items-center justify-between gap-3 px-6 py-4 border-b-4 border-black dark:border-gray-100 flex-shrink-0 bg-white dark:bg-gray-950",
        children: [
            /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("div", {
                className: "flex-shrink-0",
                children: /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("a", {
                    href: "/",
                    className: "no-underline text-inherit hover:opacity-80 focus:outline-none focus:ring-2 focus:ring-brutal-orange focus:ring-offset-2",
                    "aria-label": "Meetday home",
                    children: /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("h1", {
                        className: "m-0 text-xl sm:text-2xl font-logo font-bold text-gray-900 dark:text-white tracking-tight uppercase whitespace-nowrap",
                        children: "Meetday"
                    })
                })
            }),
            /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("div", {
                className: "flex-1 flex justify-center min-w-0 px-2",
                children: onEditCalendarName ? /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("button", {
                    type: "button",
                    onClick: onEditCalendarName,
                    title: displayName,
                    className: "min-h-[2.5rem] px-4 py-2 text-sm font-semibold rounded-none border-2 border-black dark:border-gray-100 bg-brutal-purple text-white hover:bg-brutal-purple-hover truncate max-w-full",
                    "aria-label": `Calendar: ${displayName}. Click to rename.`,
                    children: displayName
                }) : /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("span", {
                    className: "text-sm font-medium text-gray-800 dark:text-gray-200 truncate max-w-full",
                    title: displayName,
                    children: displayName
                })
            }),
            /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("div", {
                className: "flex items-center justify-end gap-2 flex-shrink-0 w-24",
                children: [
                    /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)((0, $7282a58d465f88c4$export$e69968945bee9866), {
                        type: "button",
                        variant: "secondary",
                        className: "share-link min-h-[2.5rem] px-4 py-2 text-sm font-semibold",
                        "data-copy-url": shareURL,
                        title: shareURL,
                        onClick: handleCopyShare,
                        "aria-label": `Copy share link ${shareURL}`,
                        children: "Share"
                    }),
                    /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("button", {
                        type: "button",
                        onClick: onOpenSettings,
                        className: "flex items-center justify-center rounded-none border-2 border-black dark:border-gray-100 bg-white dark:bg-gray-900 hover:bg-gray-100 dark:hover:bg-gray-800 p-0.5 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-brutal-orange min-w-[2.75rem] min-h-[2.75rem]",
                        title: "Settings",
                        "aria-label": "Open settings",
                        children: /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)((0, $dc094c5397bc487f$export$2e2bcd8739ae039), {
                            username: username,
                            avatar: avatar,
                            size: $7f8cb6be0e7ee0fb$var$USER_ICON_SIZE
                        })
                    })
                ]
            })
        ]
    });
}




function $5c17587316121e5d$export$42a852a2b6b56249({ children: children, className: className = "", ...props }) {
    return /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("div", {
        className: `w-full max-w-md p-4 border-2 border-black dark:border-gray-100 bg-white dark:bg-gray-950 text-left text-gray-800 dark:text-gray-200 text-sm brutal-shadow ${className}`.trim(),
        ...props,
        children: children
    });
}


const $d571c127988d1dd8$var$RECENT_CALENDARS_KEY = "meetday_recent_calendars";
function $d571c127988d1dd8$var$getRecentCalendars() {
    if (typeof window === "undefined") return [];
    try {
        const raw = window.localStorage.getItem($d571c127988d1dd8$var$RECENT_CALENDARS_KEY);
        const list = raw ? JSON.parse(raw) : [];
        const cutoff = Date.now() - 10368000000; // ~120 days
        return list.filter((item)=>item && item.slug && item.lastVisited >= cutoff).sort((a, b)=>b.lastVisited - a.lastVisited).slice(0, 10);
    } catch  {
        return [];
    }
}
function $d571c127988d1dd8$export$2e2bcd8739ae039() {
    const [recentCalendars, setRecentCalendars] = (0, $d6bdfea1a1e13052$export$60241385465d0a34)([]);
    const [unreadCounts, setUnreadCounts] = (0, $d6bdfea1a1e13052$export$60241385465d0a34)({});
    (0, $d6bdfea1a1e13052$export$6d9c69b0de29b591)(()=>{
        setRecentCalendars($d571c127988d1dd8$var$getRecentCalendars());
    }, []);
    // Initial unread counts from API
    (0, $d6bdfea1a1e13052$export$6d9c69b0de29b591)(()=>{
        const slugs = recentCalendars.map((c)=>c.slug).filter(Boolean);
        if (slugs.length === 0) {
            setUnreadCounts({});
            return;
        }
        const params = new URLSearchParams({
            slugs: slugs.join(",")
        });
        fetch(`/api/unread-counts?${params.toString()}`, {
            credentials: "same-origin"
        }).then((res)=>res.ok ? res.json() : {}).then((data)=>setUnreadCounts(data || {})).catch(()=>setUnreadCounts({}));
    }, [
        recentCalendars
    ]);
    // WebSocket per recent calendar: when an event is received, increment that calendar's unread count in RT
    (0, $d6bdfea1a1e13052$export$6d9c69b0de29b591)(()=>{
        const slugs = recentCalendars.map((c)=>c.slug).filter(Boolean);
        if (slugs.length === 0) return;
        const sockets = [];
        const proto = typeof window !== "undefined" && window.location?.protocol === "https:" ? "wss:" : "ws:";
        const host = typeof window !== "undefined" ? window.location.host : "";
        slugs.forEach((slug)=>{
            const url = `${proto}//${host}/c/${slug}/ws`;
            const ws = new WebSocket(url);
            sockets.push(ws);
            ws.onmessage = (e)=>{
                try {
                    const data = JSON.parse(e.data);
                    if (data?.kind === "event" && data?.event) setUnreadCounts((prev)=>({
                            ...prev,
                            [slug]: (prev[slug] ?? 0) + 1
                        }));
                } catch  {
                // ignore
                }
            };
        });
        return ()=>{
            sockets.forEach((s)=>{
                if (s.readyState === WebSocket.OPEN || s.readyState === WebSocket.CONNECTING) s.close();
            });
        };
    }, [
        recentCalendars
    ]);
    return /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("div", {
        className: "min-h-screen flex flex-col",
        children: [
            /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)((0, $7f8cb6be0e7ee0fb$export$5d608ab1c3dd731), {}),
            /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("main", {
                className: "flex-1 flex flex-col items-center justify-around p-6 text-center w-full",
                children: [
                    /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("h2", {
                        className: "font-logo text-8xl sm:text-9xl md:text-[10rem] lg:text-[12rem] font-bold mb-10 tracking-tight uppercase brutal-text-shadow w-full px-0",
                        children: [
                            /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("span", {
                                className: "text-brutal-orange dark:text-brutal-orange-dark",
                                children: "Meet"
                            }),
                            /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("wbr", {}),
                            /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("span", {
                                className: "text-brutal-purple dark:text-brutal-purple-hover",
                                children: "day"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("div", {
                        className: "w-full max-w-2xl mx-auto flex flex-col items-center text-center gap-6",
                        children: [
                            /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("form", {
                                method: "post",
                                action: "/",
                                className: "m-0 w-full",
                                children: /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)((0, $7282a58d465f88c4$export$e69968945bee9866), {
                                    type: "submit",
                                    variant: "primary",
                                    className: "px-6 py-3 text-base min-h-[2.75rem] w-full",
                                    children: "Create new calendar"
                                })
                            }),
                            recentCalendars.length > 0 ? /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("div", {
                                className: "w-full flex flex-col gap-0 border-2 border-black dark:border-gray-100 bg-white dark:bg-gray-950",
                                children: [
                                    /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("div", {
                                        className: "px-4 py-2 border-b-2 border-black dark:border-gray-100 bg-gray-100 dark:bg-gray-900",
                                        children: /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("h3", {
                                            className: "m-0 font-logo font-bold text-sm uppercase tracking-tight text-gray-900 dark:text-white",
                                            children: "Recent calendars"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("ul", {
                                        className: "m-0 p-0 list-none flex flex-col",
                                        children: recentCalendars.map((cal)=>{
                                            const newCount = unreadCounts[cal.slug] ?? 0;
                                            return /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("li", {
                                                className: "border-b-2 border-black dark:border-gray-100 last:border-b-0",
                                                children: /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("a", {
                                                    href: `/c/${cal.slug}`,
                                                    className: "block px-4 py-3 font-logo font-semibold text-sm uppercase tracking-tight text-gray-900 dark:text-gray-100 hover:bg-brutal-orange hover:text-black dark:hover:text-gray-900 transition-colors flex items-center justify-between gap-2",
                                                    children: [
                                                        /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("span", {
                                                            className: "truncate",
                                                            children: cal.name && cal.name.trim() || cal.slug
                                                        }),
                                                        newCount > 0 && /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("span", {
                                                            className: "shrink-0 text-xs font-bold bg-brutal-orange dark:bg-brutal-orange-dark text-black dark:text-gray-900 px-2 py-0.5 rounded",
                                                            children: [
                                                                newCount,
                                                                " new"
                                                            ]
                                                        })
                                                    ]
                                                })
                                            }, cal.slug);
                                        })
                                    })
                                ]
                            }) : null,
                            /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)((0, $5c17587316121e5d$export$42a852a2b6b56249), {
                                className: "text-center",
                                children: /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("p", {
                                    className: "m-0",
                                    children: "Creates a calendar. You get a link. Share the link. Others open it and add when they are free. You see when everyone can meet."
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("footer", {
                className: "flex-shrink-0 border-t-4 border-black dark:border-gray-100 bg-gray-200 dark:bg-gray-800 py-4 px-6 text-center",
                children: /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("p", {
                    className: "m-0 text-sm font-logo font-bold uppercase tracking-tight text-gray-900 dark:text-gray-100",
                    children: "\xa9 2026 Coralbits SL"
                })
            })
        ]
    });
}





function $463ebce6cd32240f$export$2e2bcd8739ae039({ slug: slug }) {
    return /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)((0, $450fc775b2f7950e$export$ffb0004e005737fa), {
        children: [
            /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)((0, $7f8cb6be0e7ee0fb$export$5d608ab1c3dd731), {}),
            /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("main", {
                className: "flex-1 flex flex-col items-center justify-center p-6 max-w-2xl mx-auto text-center",
                children: [
                    /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("p", {
                        className: "text-lg text-gray-700 dark:text-gray-300 mb-6",
                        children: "Enter your name to join this calendar."
                    }),
                    /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("form", {
                        method: "post",
                        action: `/c/${slug}`,
                        className: "m-0 flex flex-col items-center gap-4",
                        children: [
                            /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)((0, $7282a58d465f88c4$export$e0d8aacd8d06bfd5), {
                                type: "text",
                                name: "username",
                                placeholder: "Your name",
                                required: true,
                                autoFocus: true,
                                className: "w-full max-w-xs"
                            }),
                            /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)((0, $7282a58d465f88c4$export$e69968945bee9866), {
                                type: "submit",
                                variant: "primary",
                                className: "px-6 py-3 text-base min-h-[2.75rem]",
                                children: "Continue"
                            })
                        ]
                    })
                ]
            })
        ]
    });
}













const $d4e2ce7b085e1358$var$DEFAULT_DELAY_MS = 400;
function $d4e2ce7b085e1358$export$2e2bcd8739ae039({ children: children, content: content, delayMs: delayMs = $d4e2ce7b085e1358$var$DEFAULT_DELAY_MS, multiline: multiline = false, className: className = "" }) {
    const [visible, setVisible] = (0, $d6bdfea1a1e13052$export$60241385465d0a34)(false);
    const timeoutRef = (0, $d6bdfea1a1e13052$export$b8f5890fc79d6aca)(null);
    const clearTimer = (0, $d6bdfea1a1e13052$export$35808ee640e87ca7)(()=>{
        if (timeoutRef.current !== null) {
            clearTimeout(timeoutRef.current);
            timeoutRef.current = null;
        }
    }, []);
    const show = (0, $d6bdfea1a1e13052$export$35808ee640e87ca7)(()=>{
        clearTimer();
        timeoutRef.current = setTimeout(()=>setVisible(true), delayMs);
    }, [
        delayMs,
        clearTimer
    ]);
    const hide = (0, $d6bdfea1a1e13052$export$35808ee640e87ca7)(()=>{
        clearTimer();
        setVisible(false);
    }, [
        clearTimer
    ]);
    if (content == null || content === "") return /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)((0, $450fc775b2f7950e$export$ffb0004e005737fa), {
        children: children
    });
    return /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("span", {
        className: `relative inline-block ${className}`,
        onMouseEnter: show,
        onMouseLeave: hide,
        children: [
            children,
            visible ? /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("span", {
                className: `absolute left-1/2 bottom-full -translate-x-1/2 mb-1.5 z-50 px-2 py-1.5 text-xs font-mono border-2 border-black dark:border-gray-100 bg-white dark:bg-gray-950 text-gray-900 dark:text-gray-100 brutal-tooltip-shadow pointer-events-none ${multiline ? "whitespace-normal text-left max-w-[min(90vw,40rem)]" : "whitespace-nowrap overflow-hidden text-ellipsis max-w-[min(90vw,20rem)]"}`,
                role: "tooltip",
                children: typeof content === "string" ? content : content
            }) : null
        ]
    });
}


function $cb13ae2da5a615aa$var$totalVotes(counts) {
    return Object.values(counts).reduce((a, b)=>a + b, 0);
}
function $cb13ae2da5a615aa$var$top2Votes(counts) {
    return Object.entries(counts).sort((a, b)=>b[1] - a[1]).slice(0, 2);
}
function $cb13ae2da5a615aa$var$todayStr() {
    const d = new Date();
    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
}
function $cb13ae2da5a615aa$export$2e2bcd8739ae039({ dateStr: dateStr, dayNum: dayNum, slots: slots = [], isSelected: isSelected, isOtherMonth: isOtherMonth = false, onDayClick: onDayClick, reactionsByUserBySlot: reactionsByUserBySlot = {}, tooltipDelayMs: tooltipDelayMs = 400 }) {
    const isEmpty = !dateStr;
    const today = $cb13ae2da5a615aa$var$todayStr();
    const isToday = dateStr === today;
    const isPast = dateStr && dateStr < today;
    const weekday = dateStr ? new Date(dateStr + "T12:00:00").getDay() : -1;
    const isWeekend = weekday === 0 || weekday === 6;
    const slotsByVotes = [
        ...slots
    ].sort((a, b)=>$cb13ae2da5a615aa$var$totalVotes(b.reaction_counts || {}) - $cb13ae2da5a615aa$var$totalVotes(a.reaction_counts || {}));
    const allTags = [];
    const seen = new Set();
    for (const slot of slots){
        for (const t of slot.tags || [])if (!seen.has(t.tag_id)) {
            seen.add(t.tag_id);
            allTags.push(t);
        }
    }
    let dayVariantClass = "bg-white dark:bg-gray-950";
    if (isOtherMonth) dayVariantClass = "bg-white dark:bg-gray-950 text-gray-400 dark:text-gray-500 opacity-60";
    else if (isToday) dayVariantClass = "bg-brutal-orange dark:bg-brutal-orange-dark";
    else if (isPast) dayVariantClass = isWeekend ? "bg-purple-100/80 dark:bg-brutal-purple-dark" : "bg-gray-100 dark:bg-gray-900/70";
    else if (isWeekend) dayVariantClass = "bg-purple-100 dark:bg-brutal-purple";
    let dayNumberClass = "font-semibold text-brutal-purple dark:text-brutal-orange";
    if (isOtherMonth) dayNumberClass = "font-semibold text-gray-400 dark:text-gray-500";
    else if (isToday || isSelected) dayNumberClass = "font-semibold text-black dark:text-gray-900";
    else if (isPast && !isWeekend) dayNumberClass = "font-semibold text-gray-600 dark:text-gray-300";
    else if (isPast && isWeekend) dayNumberClass = "font-semibold text-black dark:text-gray-50";
    const base = "aspect-square max-h-20 flex flex-col items-center justify-center rounded-none cursor-pointer transition-colors relative border border-black dark:border-gray-700";
    const emptyClass = isEmpty ? "invisible cursor-default" : "";
    const hoverClass = !isEmpty ? isOtherMonth ? "hover:bg-gray-100 dark:hover:bg-gray-900" : "hover:bg-orange-100 dark:hover:bg-brutal-purple-dark" : "";
    const selectedClass = isSelected ? "!bg-purple-100 dark:!bg-brutal-purple-dark" : "";
    const dayTooltipContent = slotsByVotes.length > 0 ? /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("div", {
        className: "flex flex-col gap-1.5",
        children: slotsByVotes.map((slot)=>{
            const whoVoted = reactionsByUserBySlot[slot.id];
            const firstLine = (slot.description || "").split("\n")[0].trim() || "(no description)";
            const hasVoters = whoVoted && Object.keys(whoVoted).length > 0;
            return /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("div", {
                className: "flex flex-col gap-0.5",
                children: [
                    /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("span", {
                        className: "whitespace-nowrap",
                        children: [
                            slot.start_time,
                            " \xb7 ",
                            firstLine
                        ]
                    }),
                    hasVoters ? /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("div", {
                        className: "flex flex-col",
                        children: Object.entries(whoVoted).map(([u, emoji])=>/*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("span", {
                                className: "whitespace-nowrap",
                                children: [
                                    (0, $8228b3fd71ca6b09$export$b748117d79873787)[emoji] ?? emoji,
                                    " ",
                                    u
                                ]
                            }, `${u}-${emoji}`))
                    }) : null
                ]
            }, slot.id);
        })
    }) : null;
    const dayCell = /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("div", {
        className: `${base} ${dayVariantClass} ${emptyClass} ${hoverClass} ${selectedClass}`,
        "data-date": dateStr,
        onClick: ()=>!isEmpty && onDayClick(dateStr),
        role: isEmpty ? undefined : "button",
        tabIndex: isEmpty ? undefined : 0,
        onKeyDown: (e)=>!isEmpty && (e.key === "Enter" || e.key === " ") && onDayClick(dateStr),
        children: [
            allTags.length > 0 ? /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("div", {
                className: "absolute top-0 left-0 flex flex-wrap gap-0.5 p-0.5 max-w-full",
                children: allTags.map((t)=>/*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("span", {
                        className: `inline-block px-1 py-0.5 text-[10px] font-logo font-bold uppercase rounded-sm -rotate-12 origin-left shadow-sm border-2 border-black dark:border-gray-100 ${(0, $8228b3fd71ca6b09$export$3ccacf16444f72a3)(t.tag_name)}`,
                        children: t.tag_name
                    }, t.tag_id))
            }) : null,
            dayNum ? /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("span", {
                className: dayNumberClass,
                children: dayNum
            }) : null,
            slotsByVotes.length > 0 ? /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("div", {
                className: "flex flex-col gap-0.5 mt-1 w-full font-mono text-[10px] leading-tight px-1 min-w-0",
                children: slotsByVotes.slice(0, 3).map((slot)=>{
                    const top2 = $cb13ae2da5a615aa$var$top2Votes(slot.reaction_counts || {});
                    const votesStr = top2.map(([emoji, n])=>`${(0, $8228b3fd71ca6b09$export$b748117d79873787)[emoji] || emoji}${n}`).join(" ");
                    return /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("div", {
                        className: "flex w-full justify-between items-baseline gap-1 truncate min-w-0",
                        children: [
                            /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("span", {
                                className: "truncate min-w-0",
                                children: slot.start_time
                            }),
                            votesStr ? /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("span", {
                                className: "shrink-0 tabular-nums",
                                children: votesStr
                            }) : null
                        ]
                    }, slot.id);
                })
            }) : null
        ]
    });
    if (!isEmpty && dayTooltipContent) return /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)((0, $d4e2ce7b085e1358$export$2e2bcd8739ae039), {
        content: dayTooltipContent,
        delayMs: tooltipDelayMs,
        multiline: true,
        className: "block w-full h-full",
        children: dayCell
    });
    return dayCell;
}


function $ca73cd009396021d$export$2e2bcd8739ae039({ days: days, onDayClick: onDayClick, reactionsByUserBySlot: reactionsByUserBySlot = {} }) {
    return /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("tr", {
        children: days.map((d, i)=>/*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("td", {
                className: "p-0 align-top border border-black dark:border-gray-800 calendar-cell",
                children: /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)((0, $cb13ae2da5a615aa$export$2e2bcd8739ae039), {
                    dateStr: d.dateStr,
                    dayNum: d.dayNum,
                    slots: d.slots,
                    isSelected: d.isSelected,
                    isOtherMonth: d.isOtherMonth,
                    onDayClick: onDayClick,
                    reactionsByUserBySlot: reactionsByUserBySlot
                })
            }, d.dateStr || `empty-${i}`))
    });
}


const $0d6fd1d44223ffd9$var$WEEKDAYS = [
    "Mon",
    "Tue",
    "Wed",
    "Thu",
    "Fri",
    "Sat",
    "Sun"
];
function $0d6fd1d44223ffd9$export$2e2bcd8739ae039({ state: state, config: config, selectedDate: selectedDate, onDayClick: onDayClick }) {
    const { month: month, year: year } = config;
    const first = new Date(year, month - 1, 1);
    const last = new Date(year, month, 0);
    const startWeekday = (first.getDay() + 6) % 7;
    const daysInMonth = last.getDate();
    let cellCount = startWeekday + daysInMonth;
    if (cellCount % 7) cellCount += 7 - cellCount % 7;
    const prevLast = new Date(year, month - 1, 0);
    const daysInPrev = prevLast.getDate();
    const weeks = [];
    let week = [];
    for(let i = 0; i < cellCount; i++){
        let dateStr = "";
        let dayNum = 0;
        let isOtherMonth = false;
        if (i < startWeekday) {
            const d = daysInPrev - startWeekday + 1 + i;
            const prevYear = month === 1 ? year - 1 : year;
            const prevMonth = month === 1 ? 12 : month - 1;
            dateStr = `${prevYear}-${String(prevMonth).padStart(2, "0")}-${String(d).padStart(2, "0")}`;
            dayNum = d;
            isOtherMonth = true;
        } else if (i < startWeekday + daysInMonth) {
            dayNum = i - startWeekday + 1;
            dateStr = `${year}-${String(month).padStart(2, "0")}-${String(dayNum).padStart(2, "0")}`;
        } else {
            const nextDay = i - startWeekday - daysInMonth + 1;
            const nextYear = month === 12 ? year + 1 : year;
            const nextMonth = month === 12 ? 1 : month + 1;
            dateStr = `${nextYear}-${String(nextMonth).padStart(2, "0")}-${String(nextDay).padStart(2, "0")}`;
            dayNum = nextDay;
            isOtherMonth = true;
        }
        const slots = state.slotsByDate[dateStr] || [];
        week.push({
            dateStr: dateStr,
            dayNum: dayNum,
            slots: slots,
            isSelected: dateStr === selectedDate,
            isOtherMonth: isOtherMonth
        });
        if (week.length === 7) {
            weeks.push(week);
            week = [];
        }
    }
    if (week.length) weeks.push(week);
    return /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("div", {
        className: "flex flex-col flex-1 min-h-[280px] my-4 border-2 border-black dark:border-gray-100",
        children: /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("table", {
            className: "w-full table-fixed border-collapse brutal-shadow bg-white dark:bg-gray-950",
            children: [
                /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("thead", {
                    children: /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("tr", {
                        children: $0d6fd1d44223ffd9$var$WEEKDAYS.map((d)=>/*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("th", {
                                className: "text-xs font-semibold text-center py-2 border-b-2 border-black dark:border-gray-100 bg-white dark:bg-gray-950",
                                children: d
                            }, d))
                    })
                }),
                /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("tbody", {
                    children: weeks.map((w, wi)=>/*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)((0, $ca73cd009396021d$export$2e2bcd8739ae039), {
                            days: w,
                            onDayClick: onDayClick,
                            reactionsByUserBySlot: state.reactionsByUserBySlot
                        }, wi))
                })
            ]
        })
    });
}






/** Called when the server returns 429 (rate limit). Argument: seconds to wait before retry. */ let $30170d3e8382adde$var$onRateLimited = null;
function $30170d3e8382adde$export$fb630ecd976ebe94(fn) {
    $30170d3e8382adde$var$onRateLimited = fn;
}
/** Called when the server returns 413 (request body too large). */ let $30170d3e8382adde$var$onEventTooLarge = null;
function $30170d3e8382adde$export$7205caaeb4a84222(fn) {
    $30170d3e8382adde$var$onEventTooLarge = fn;
}
const $30170d3e8382adde$var$MAX_RETRIES_ON_RATE_LIMIT = 2;
function $30170d3e8382adde$export$64a40cf65fcd549d(slug, event) {
    const url = `/c/${slug}/events`;
    const options = {
        method: "PUT",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify(event)
    };
    let lastRes = null;
    const run = async ()=>{
        for(let i = 0; i <= $30170d3e8382adde$var$MAX_RETRIES_ON_RATE_LIMIT; i++){
            lastRes = await fetch(url, options);
            if (lastRes.status === 413) {
                $30170d3e8382adde$var$onEventTooLarge?.();
                return lastRes;
            }
            if (lastRes.status !== 429) return lastRes;
            const retryAfter = Math.min(Math.max(parseInt(lastRes.headers.get("Retry-After") ?? "5", 10) || 5, 2), 60);
            $30170d3e8382adde$var$onRateLimited?.(retryAfter);
            await new Promise((r)=>setTimeout(r, retryAfter * 1000));
        }
        return lastRes;
    };
    return run();
}
function $30170d3e8382adde$export$3aa17b355b211dc5(slug, eventId) {
    return fetch(`/c/${slug}/mark-read`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            event_id: eventId
        }),
        credentials: "same-origin"
    });
}
function $30170d3e8382adde$export$db6dcff2e77846b2(slug, image, crop) {
    const form = new FormData();
    form.append("image", image);
    form.append("x", String(crop.x));
    form.append("y", String(crop.y));
    form.append("size", String(crop.size));
    if (typeof crop.scale === "number") form.append("scale", String(crop.scale));
    return fetch(`/c/${slug}/face`, {
        method: "POST",
        body: form
    });
}



const $e401cbf4e9d2c88b$var$EMOJIS = [
    "heart",
    "laugh",
    "thumbs_up",
    "thumbs_down"
];
function $e401cbf4e9d2c88b$var$votersForEmoji(reactionsByUser, emoji) {
    if (!reactionsByUser) return "";
    return Object.entries(reactionsByUser).filter(([, e])=>e === emoji).map(([u])=>u).join(", ");
}
function $e401cbf4e9d2c88b$export$2e2bcd8739ae039({ slot: slot, slug: slug, username: username, currentUserEmoji: currentUserEmoji = "", reactionsByUser: reactionsByUser = {}, existingTags: existingTags = [] }) {
    const [tagInput, setTagInput] = (0, $d6bdfea1a1e13052$export$60241385465d0a34)("");
    const [showTagDialog, setShowTagDialog] = (0, $d6bdfea1a1e13052$export$60241385465d0a34)(false);
    const [newTagName, setNewTagName] = (0, $d6bdfea1a1e13052$export$60241385465d0a34)("");
    const [desc, setDesc] = (0, $d6bdfea1a1e13052$export$60241385465d0a34)(slot.description ?? "");
    const [isEditingDesc, setIsEditingDesc] = (0, $d6bdfea1a1e13052$export$60241385465d0a34)(false);
    const counts = slot.reaction_counts || {};
    (0, $d6bdfea1a1e13052$export$6d9c69b0de29b591)(()=>{
        if (!isEditingDesc) setDesc(slot.description ?? "");
    }, [
        slot.description,
        isEditingDesc
    ]);
    const current = currentUserEmoji;
    const addTag = (e)=>{
        e.preventDefault();
        const name = tagInput.trim();
        if (!name) return;
        const existing = existingTags.find((t)=>t.name.toLowerCase() === name.toLowerCase());
        const tagId = existing ? existing.id : Date.now();
        const tagName = existing ? existing.name : name;
        if (!existing) (0, $30170d3e8382adde$export$64a40cf65fcd549d)(slug, {
            type: "tag_created",
            message: `${username} created tag "${tagName}"`,
            data: {
                tag_id: tagId,
                name: tagName
            }
        });
        (0, $30170d3e8382adde$export$64a40cf65fcd549d)(slug, {
            type: "tag_added_to_slot",
            message: `${username} added tag "${tagName}" to slot`,
            data: {
                slot_id: slot.id,
                tag_id: tagId,
                tag_name: tagName
            }
        });
        setTagInput("");
    };
    const submitReaction = (emoji)=>(e)=>{
            e.preventDefault();
            const disp = (0, $8228b3fd71ca6b09$export$b748117d79873787)[emoji] || emoji;
            (0, $30170d3e8382adde$export$64a40cf65fcd549d)(slug, {
                type: "reaction_set",
                message: `${username} reacted ${disp} on ${slot.date} ${slot.start_time}\u{2013}${slot.end_time}`,
                data: {
                    slot_id: slot.id,
                    user_id: 0,
                    emoji: emoji,
                    username: username
                }
            });
        };
    const clearReaction = (e)=>{
        e.preventDefault();
        (0, $30170d3e8382adde$export$64a40cf65fcd549d)(slug, {
            type: "reaction_cleared",
            message: `${username} cleared reaction on slot`,
            data: {
                slot_id: slot.id,
                user_id: 0,
                username: username,
                emoji: current
            }
        });
    };
    const removeTag = (tagId, tagName)=>(e)=>{
            e.preventDefault();
            (0, $30170d3e8382adde$export$64a40cf65fcd549d)(slug, {
                type: "tag_removed_from_slot",
                message: `${username} removed label "${tagName}"`,
                data: {
                    slot_id: slot.id,
                    tag_id: tagId,
                    tag_name: tagName
                }
            });
        };
    const saveDescription = (e)=>{
        e.preventDefault();
        const trimmed = desc.trim();
        if (trimmed === (slot.description ?? "")) {
            setIsEditingDesc(false);
            return;
        }
        (0, $30170d3e8382adde$export$64a40cf65fcd549d)(slug, {
            type: "slot_description_updated",
            message: `${username} edited the description for ${slot.date} ${slot.start_time}\u{2013}${slot.end_time}`,
            data: {
                slot_id: slot.id,
                date: slot.date,
                description: trimmed
            }
        });
        setIsEditingDesc(false);
    };
    const handleSelectTag = (e)=>{
        const target = e.target;
        const value = target.value;
        if (!value) return;
        if (value === "__new__") {
            setShowTagDialog(true);
            target.value = "";
            return;
        }
        const tagId = Number(value);
        const existing = existingTags.find((t)=>t.id === tagId);
        if (existing) (0, $30170d3e8382adde$export$64a40cf65fcd549d)(slug, {
            type: "tag_added_to_slot",
            message: `${username} added tag "${existing.name}" to slot`,
            data: {
                slot_id: slot.id,
                tag_id: existing.id,
                tag_name: existing.name
            }
        });
        target.value = "";
    };
    const handleCreateTag = (e)=>{
        e.preventDefault();
        const name = newTagName.trim();
        if (!name) return;
        const existing = existingTags.find((t)=>t.name.toLowerCase() === name.toLowerCase());
        let tagId = existing?.id ?? Date.now();
        const tagName = existing?.name ?? name;
        if (!existing) (0, $30170d3e8382adde$export$64a40cf65fcd549d)(slug, {
            type: "tag_created",
            message: `${username} created tag "${tagName}"`,
            data: {
                tag_id: tagId,
                name: tagName
            }
        });
        (0, $30170d3e8382adde$export$64a40cf65fcd549d)(slug, {
            type: "tag_added_to_slot",
            message: `${username} added tag "${tagName}" to slot`,
            data: {
                slot_id: slot.id,
                tag_id: tagId,
                tag_name: tagName
            }
        });
        setNewTagName("");
        setShowTagDialog(false);
    };
    return /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("div", {
        className: "flex flex-col gap-2",
        children: /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("div", {
            className: "p-4 mb-3 border-2 border-black dark:border-gray-100 bg-orange-50 dark:bg-gray-900 flex flex-col gap-2",
            "data-slot-id": slot.id,
            children: [
                /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("div", {
                    className: "flex flex-wrap gap-2 items-center",
                    children: [
                        /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("div", {
                            className: "font-semibold text-brutal-purple dark:text-brutal-purple-hover",
                            children: [
                                slot.start_time,
                                "\u2013",
                                slot.end_time
                            ]
                        }),
                        /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("div", {
                            className: "text-sm opacity-85",
                            children: slot.creator_name
                        }),
                        /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("div", {
                            className: "flex-1 min-w-0"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("div", {
                    className: "w-full",
                    children: isEditingDesc ? /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("form", {
                        onSubmit: saveDescription,
                        className: "flex flex-col gap-1 font-mono",
                        children: [
                            /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("textarea", {
                                value: desc,
                                onInput: (e)=>setDesc(e.target.value),
                                placeholder: "Description",
                                rows: 4,
                                className: "w-full px-3 py-2 text-sm border-2 border-black dark:border-gray-100 bg-white dark:bg-gray-950 text-gray-900 dark:text-gray-100 resize-y min-h-[4rem]",
                                autoFocus: true
                            }),
                            /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("div", {
                                className: "flex gap-2",
                                children: [
                                    /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("button", {
                                        type: "submit",
                                        className: "px-3 py-1.5 text-sm font-semibold rounded-none border-2 border-black dark:border-gray-100 bg-brutal-orange text-black dark:text-gray-900 hover:bg-brutal-orange-hover",
                                        children: "Save"
                                    }),
                                    /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("button", {
                                        type: "button",
                                        onClick: ()=>{
                                            setDesc(slot.description ?? "");
                                            setIsEditingDesc(false);
                                        },
                                        className: "px-3 py-1.5 text-sm rounded-none border-2 border-black dark:border-gray-100 bg-white dark:bg-gray-950 hover:bg-gray-200 dark:hover:bg-gray-800",
                                        children: "Cancel"
                                    })
                                ]
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("div", {
                        className: "flex items-start gap-2 font-mono",
                        children: [
                            /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("div", {
                                className: "flex-1 min-w-0 text-sm text-black dark:text-gray-100 whitespace-pre-wrap",
                                children: slot.description || "\u2014"
                            }),
                            /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)((0, $7282a58d465f88c4$export$e69968945bee9866), {
                                type: "button",
                                variant: "secondary",
                                className: "px-2 py-1 text-xs min-h-0 bg-white dark:bg-gray-900 text-gray-700 dark:text-gray-200 hover:bg-gray-200 dark:hover:bg-gray-700 shrink-0",
                                onClick: ()=>setIsEditingDesc(true),
                                children: "Edit"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("div", {
                    className: "flex flex-wrap gap-2 items-center mt-2",
                    children: [
                        (slot.tags || []).map((t)=>/*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("button", {
                                type: "button",
                                onClick: removeTag(t.tag_id, t.tag_name),
                                title: "Press to remove",
                                "aria-label": `Remove label ${t.tag_name}`,
                                className: `inline-flex items-center gap-1.5 px-2 py-0.5 text-sm font-semibold border-2 border-black dark:border-gray-100 ${(0, $8228b3fd71ca6b09$export$3ccacf16444f72a3)(t.tag_name)}`,
                                children: [
                                    t.tag_name,
                                    /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("span", {
                                        className: "opacity-90 ml-1",
                                        "aria-hidden": true,
                                        children: "\xd7"
                                    })
                                ]
                            }, t.tag_id)),
                        /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)((0, $7282a58d465f88c4$export$460dfbe7d36d7938), {
                            value: "",
                            onChange: handleSelectTag,
                            className: "text-xs min-w-[7rem]",
                            children: [
                                /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("option", {
                                    value: "",
                                    children: (slot.tags || []).length ? "Add label" : "Add label\u2026"
                                }),
                                existingTags.map((t)=>/*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("option", {
                                        value: t.id,
                                        children: t.name
                                    }, t.id)),
                                /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("option", {
                                    value: "__new__",
                                    children: "+ Create new label\u2026"
                                })
                            ]
                        })
                    ]
                }),
                showTagDialog && /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("div", {
                    className: "brutal-modal-overlay flex items-center justify-center",
                    children: /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("div", {
                        className: "border-2 border-black dark:border-gray-100 bg-white dark:bg-gray-950 p-4 max-w-xs w-[90%] flex flex-col gap-3",
                        children: [
                            /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("div", {
                                className: "text-sm font-semibold",
                                children: "Create new label"
                            }),
                            /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)((0, $7282a58d465f88c4$export$e0d8aacd8d06bfd5), {
                                value: newTagName,
                                onInput: (e)=>setNewTagName(e.target.value),
                                placeholder: "Label name",
                                className: "w-full"
                            }),
                            /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("div", {
                                className: "flex gap-2 justify-end",
                                children: [
                                    /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)((0, $7282a58d465f88c4$export$e69968945bee9866), {
                                        type: "button",
                                        variant: "primary",
                                        className: "px-3 py-1 text-xs min-h-0",
                                        onClick: handleCreateTag,
                                        children: "Save"
                                    }),
                                    /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)((0, $7282a58d465f88c4$export$e69968945bee9866), {
                                        type: "button",
                                        variant: "secondary",
                                        className: "px-3 py-1 text-xs min-h-0",
                                        onClick: ()=>{
                                            setShowTagDialog(false);
                                            setNewTagName("");
                                        },
                                        children: "Cancel"
                                    })
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("div", {
                    className: "flex gap-2 mt-2",
                    children: $e401cbf4e9d2c88b$var$EMOJIS.map((emoji)=>{
                        const voters = $e401cbf4e9d2c88b$var$votersForEmoji(reactionsByUser, emoji);
                        return /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("button", {
                            type: "button",
                            className: `px-1.5 py-0.5 text-lg min-w-[2rem] border-2 border-black dark:border-gray-100 ${current === emoji ? "bg-brutal-purple text-white" : "bg-white dark:bg-gray-950"}`,
                            title: voters ? `${(0, $8228b3fd71ca6b09$export$b748117d79873787)[emoji] || emoji} \xb7 ${voters}` : emoji,
                            onClick: current === emoji ? clearReaction : submitReaction(emoji),
                            children: [
                                (0, $8228b3fd71ca6b09$export$b748117d79873787)[emoji] || emoji,
                                " ",
                                counts[emoji] || 0
                            ]
                        }, emoji);
                    })
                })
            ]
        })
    });
}






function $9747b2b2a24a007c$export$2e2bcd8739ae039({ slug: slug, selectedDate: selectedDate, username: username, config: config }) {
    const [start, setStart] = (0, $d6bdfea1a1e13052$export$60241385465d0a34)('09:00');
    const [end, setEnd] = (0, $d6bdfea1a1e13052$export$60241385465d0a34)('10:00');
    const [desc, setDesc] = (0, $d6bdfea1a1e13052$export$60241385465d0a34)('');
    const submit = (e)=>{
        e.preventDefault();
        const slotId = Date.now();
        const message = `${username} added slot ${start}\u{2013}${end} on ${selectedDate}`;
        (0, $30170d3e8382adde$export$64a40cf65fcd549d)(slug, {
            type: 'slot_created',
            message: message,
            data: {
                slot_id: slotId,
                user_id: 0,
                date: selectedDate,
                start_time: start,
                end_time: end,
                description: desc,
                creator_name: username
            }
        }).then(()=>setDesc(''));
    };
    return /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("form", {
        onSubmit: submit,
        className: "flex flex-wrap gap-4 items-end mb-5 p-4 bg-orange-50 dark:bg-gray-900 border-2 border-black dark:border-gray-100",
        children: [
            /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)((0, $7282a58d465f88c4$export$e0d8aacd8d06bfd5), {
                type: "time",
                value: start,
                onInput: (e)=>setStart(e.target.value),
                className: "text-base min-h-[2.75rem] min-w-[6rem]"
            }),
            /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)((0, $7282a58d465f88c4$export$e0d8aacd8d06bfd5), {
                type: "time",
                value: end,
                onInput: (e)=>setEnd(e.target.value),
                className: "text-base min-h-[2.75rem] min-w-[6rem]"
            }),
            /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)((0, $7282a58d465f88c4$export$e0d8aacd8d06bfd5), {
                type: "text",
                value: desc,
                onInput: (e)=>setDesc(e.target.value),
                placeholder: "Description",
                className: "text-base min-h-[2.75rem] min-w-[14rem] flex-1"
            }),
            /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)((0, $7282a58d465f88c4$export$e69968945bee9866), {
                type: "submit",
                variant: "primary",
                className: "px-5 py-2.5 text-base min-h-[2.75rem]",
                children: "Add slot"
            })
        ]
    });
}


function $817e4203154ac98c$export$2e2bcd8739ae039({ state: state, config: config, slug: slug, selectedDate: selectedDate, username: username }) {
    const selectedSlots = selectedDate ? state.slotsByDate[selectedDate] || [] : [];
    const userReactionBySlot = state.userReactionBySlot || {};
    return /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("div", {
        className: "flex-1 min-w-0 overflow-y-auto p-4 bg-white dark:bg-gray-950 border-2 border-black dark:border-gray-100",
        children: /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("div", {
            className: "flex flex-col gap-4",
            children: selectedDate ? /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("div", {
                children: [
                    /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("h3", {
                        id: `day-${selectedDate}`,
                        className: "text-lg font-semibold mt-0 mb-2",
                        children: [
                            "Slots for ",
                            selectedDate
                        ]
                    }),
                    selectedSlots.length === 0 ? /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("p", {
                        className: "text-gray-600 dark:text-gray-400",
                        children: "No slots. Add one below."
                    }) : null,
                    selectedSlots.map((slot)=>/*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)((0, $e401cbf4e9d2c88b$export$2e2bcd8739ae039), {
                            slot: slot,
                            slug: slug,
                            username: username,
                            currentUserEmoji: userReactionBySlot[slot.id],
                            reactionsByUser: state.reactionsByUserBySlot?.[slot.id],
                            existingTags: Object.values(state.tagsById || {})
                        }, slot.id)),
                    /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)((0, $9747b2b2a24a007c$export$2e2bcd8739ae039), {
                        slug: slug,
                        selectedDate: selectedDate,
                        username: username,
                        config: config
                    })
                ]
            }, selectedDate) : /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("p", {
                className: "text-gray-600 dark:text-gray-400",
                children: "Click a day to see slots."
            })
        })
    });
}










// Full emoji picker: unicode chars (stored as-is). Grouped for easier browsing.
const $5b8d4f630a652e87$var$EMOJI_LIST = [
    "\u2764\uFE0F",
    "\uD83E\uDDE1",
    "\uD83D\uDC9B",
    "\uD83D\uDC9A",
    "\uD83D\uDC99",
    "\uD83D\uDC9C",
    "\uD83D\uDDA4",
    "\uD83E\uDD0D",
    "\uD83E\uDD0E",
    "\uD83D\uDC94",
    "\u2763\uFE0F",
    "\uD83D\uDC95",
    "\uD83D\uDC9E",
    "\uD83D\uDC93",
    "\uD83D\uDC97",
    "\uD83D\uDC96",
    "\uD83D\uDC98",
    "\uD83D\uDC9D",
    "\uD83D\uDE00",
    "\uD83D\uDE03",
    "\uD83D\uDE04",
    "\uD83D\uDE01",
    "\uD83D\uDE06",
    "\uD83D\uDE05",
    "\uD83E\uDD23",
    "\uD83D\uDE02",
    "\uD83D\uDE42",
    "\uD83D\uDE43",
    "\uD83D\uDE09",
    "\uD83D\uDE0A",
    "\uD83D\uDE07",
    "\uD83E\uDD70",
    "\uD83D\uDE0D",
    "\uD83E\uDD29",
    "\uD83D\uDE18",
    "\uD83D\uDE17",
    "\u263A\uFE0F",
    "\uD83D\uDE1A",
    "\uD83D\uDE19",
    "\uD83E\uDD72",
    "\uD83D\uDE0B",
    "\uD83D\uDE1B",
    "\uD83D\uDE1C",
    "\uD83E\uDD2A",
    "\uD83D\uDE1D",
    "\uD83E\uDD11",
    "\uD83E\uDD17",
    "\uD83E\uDD2D",
    "\uD83E\uDD2B",
    "\uD83E\uDD14",
    "\uD83E\uDD10",
    "\uD83E\uDD28",
    "\uD83D\uDE10",
    "\uD83D\uDE11",
    "\uD83D\uDE36",
    "\uD83D\uDE0F",
    "\uD83D\uDE12",
    "\uD83D\uDE44",
    "\uD83D\uDE2C",
    "\uD83E\uDD25",
    "\uD83D\uDE0C",
    "\uD83D\uDE14",
    "\uD83D\uDE2A",
    "\uD83E\uDD24",
    "\uD83D\uDE34",
    "\uD83D\uDE37",
    "\uD83E\uDD12",
    "\uD83E\uDD15",
    "\uD83E\uDD22",
    "\uD83E\uDD2E",
    "\uD83E\uDD27",
    "\uD83E\uDD75",
    "\uD83E\uDD76",
    "\uD83E\uDD74",
    "\uD83D\uDE35",
    "\uD83E\uDD2F",
    "\uD83E\uDD20",
    "\uD83E\uDD73",
    "\uD83E\uDD78",
    "\uD83D\uDE0E",
    "\uD83E\uDD13",
    "\uD83E\uDDD0",
    "\uD83D\uDE15",
    "\uD83D\uDE1F",
    "\uD83D\uDE41",
    "\u2639\uFE0F",
    "\uD83D\uDE2E",
    "\uD83D\uDE2F",
    "\uD83D\uDE32",
    "\uD83D\uDE33",
    "\uD83E\uDD7A",
    "\uD83D\uDE26",
    "\uD83D\uDE27",
    "\uD83D\uDE28",
    "\uD83D\uDE30",
    "\uD83D\uDE25",
    "\uD83D\uDE22",
    "\uD83D\uDE2D",
    "\uD83D\uDE31",
    "\uD83D\uDE16",
    "\uD83D\uDE23",
    "\uD83D\uDE1E",
    "\uD83D\uDE13",
    "\uD83D\uDE29",
    "\uD83D\uDE2B",
    "\uD83E\uDD71",
    "\uD83D\uDE24",
    "\uD83D\uDE21",
    "\uD83D\uDE20",
    "\uD83E\uDD2C",
    "\uD83D\uDE08",
    "\uD83D\uDC7F",
    "\uD83D\uDC4D",
    "\uD83D\uDC4E",
    "\uD83D\uDC4A",
    "\u270A",
    "\uD83E\uDD1B",
    "\uD83E\uDD1C",
    "\uD83E\uDD1E",
    "\u270C\uFE0F",
    "\uD83E\uDD1F",
    "\uD83E\uDD18",
    "\uD83D\uDC4C",
    "\uD83E\uDD0C",
    "\uD83E\uDD0F",
    "\uD83D\uDC48",
    "\uD83D\uDC49",
    "\uD83D\uDC46",
    "\uD83D\uDC47",
    "\u261D\uFE0F",
    "\u270B",
    "\uD83E\uDD1A",
    "\uD83D\uDD90\uFE0F",
    "\uD83D\uDD96",
    "\uD83D\uDC4B",
    "\uD83E\uDD19",
    "\uD83D\uDCAA",
    "\uD83E\uDDBE",
    "\uD83D\uDD95",
    "\uD83D\uDE4F",
    "\uD83D\uDC4F",
    "\uD83D\uDE4C",
    "\uD83D\uDC50",
    "\uD83E\uDD32",
    "\uD83E\uDD1D",
    "\uD83D\uDE4F",
    "\uD83D\uDD25",
    "\u2B50",
    "\uD83C\uDF1F",
    "\u2728",
    "\uD83D\uDCAB",
    "\uD83D\uDCA5",
    "\uD83D\uDCAF",
    "\uD83D\uDCA2",
    "\uD83D\uDCA6",
    "\uD83D\uDCA8",
    "\uD83D\uDD73\uFE0F",
    "\uD83D\uDCA3",
    "\uD83D\uDCAC",
    "\uD83D\uDC41\uFE0F",
    "\uD83D\uDC40",
    "\uD83E\uDDE0",
    "\uD83E\uDEC0",
    "\uD83E\uDEC1",
    "\uD83E\uDDB7",
    "\uD83E\uDDB4",
    "\uD83D\uDC43",
    "\uD83D\uDC42",
    "\uD83E\uDDBB",
    "\uD83D\uDC45",
    "\uD83D\uDC44",
    "\uD83C\uDF89",
    "\uD83C\uDF8A",
    "\uD83C\uDF88",
    "\uD83C\uDF81",
    "\uD83C\uDFC6",
    "\uD83E\uDD47",
    "\uD83E\uDD48",
    "\uD83E\uDD49",
    "\u26BD",
    "\uD83C\uDFC0",
    "\uD83C\uDFC8",
    "\u26BE",
    "\uD83E\uDD4E",
    "\uD83C\uDFBE",
    "\uD83C\uDFD0",
    "\uD83C\uDFC9",
    "\uD83E\uDD4F",
    "\uD83C\uDFB1",
    "\uD83E\uDE80",
    "\uD83C\uDFD3",
    "\uD83C\uDFF8",
    "\uD83C\uDFD2",
    "\uD83C\uDFD1",
    "\uD83E\uDD4D",
    "\uD83C\uDFCF",
    "\uD83E\uDE83",
    "\uD83E\uDD45",
    "\u26F3",
    "\uD83E\uDE81",
    "\uD83C\uDFF9",
    "\uD83C\uDFA3",
    "\uD83E\uDD3F",
    "\uD83E\uDD4A",
    "\uD83E\uDD4B",
    "\uD83C\uDFBD",
    "\uD83D\uDEF9",
    "\uD83D\uDEFC",
    "\uD83D\uDEF7",
    "\u26F8\uFE0F",
    "\uD83E\uDD4C",
    "\uD83C\uDFBF",
    "\u26F7\uFE0F",
    "\uD83C\uDFC2",
    "\uD83E\uDE82",
    "\uD83C\uDFCB\uFE0F",
    "\uD83E\uDD38",
    "\u26F9\uFE0F",
    "\uD83E\uDD3E",
    "\uD83C\uDFCC\uFE0F",
    "\uD83C\uDFC7",
    "\u26F9\uFE0F",
    "\uD83E\uDD3E",
    "\uD83C\uDFCC\uFE0F",
    "\uD83C\uDFC7",
    "\uD83C\uDFB5",
    "\uD83C\uDFB6",
    "\uD83C\uDFB8",
    "\uD83C\uDFB9",
    "\uD83C\uDFBA",
    "\uD83C\uDFBB",
    "\uD83E\uDE95",
    "\uD83E\uDD41",
    "\uD83E\uDE98",
    "\uD83E\uDE97",
    "\uD83C\uDFB7",
    "\uD83C\uDFA4",
    "\uD83C\uDFA7",
    "\uD83D\uDCFB",
    "\uD83C\uDF99\uFE0F",
    "\uD83C\uDF9A\uFE0F",
    "\uD83C\uDF9B\uFE0F",
    "\u2615",
    "\uD83C\uDF75",
    "\uD83C\uDF76",
    "\uD83C\uDF7A",
    "\uD83C\uDF7B",
    "\uD83E\uDD42",
    "\uD83C\uDF77",
    "\uD83E\uDD43",
    "\uD83C\uDF78",
    "\uD83C\uDF79",
    "\uD83C\uDF7E",
    "\uD83E\uDD44",
    "\uD83C\uDF74",
    "\uD83C\uDF7D\uFE0F",
    "\uD83E\uDD63",
    "\uD83E\uDD61",
    "\uD83E\uDD62",
    "\uD83C\uDF7D\uFE0F",
    "\uD83C\uDF55",
    "\uD83C\uDF54",
    "\uD83C\uDF5F",
    "\uD83C\uDF2D",
    "\uD83E\uDD6A",
    "\uD83C\uDF2E",
    "\uD83C\uDF2F",
    "\uD83E\uDD59",
    "\uD83E\uDDC6",
    "\uD83E\uDD5A",
    "\uD83C\uDF73",
    "\uD83E\uDD58",
    "\uD83C\uDF72",
    "\uD83E\uDD63",
    "\uD83E\uDD57",
    "\uD83C\uDF7F",
    "\uD83E\uDDC8",
    "\uD83E\uDDC2",
    "\uD83E\uDD6B",
    "\uD83C\uDF71",
    "\uD83C\uDF58",
    "\uD83C\uDF59",
    "\uD83C\uDF5A",
    "\uD83C\uDF5B",
    "\uD83C\uDF5C",
    "\uD83C\uDF5D",
    "\uD83C\uDF60",
    "\uD83C\uDF62",
    "\uD83C\uDF63",
    "\uD83C\uDF64",
    "\uD83C\uDF65",
    "\uD83E\uDD6E",
    "\uD83C\uDF61",
    "\uD83E\uDD5F",
    "\uD83E\uDD60",
    "\uD83E\uDD6E",
    "\uD83C\uDF66",
    "\uD83C\uDF67",
    "\uD83C\uDF68",
    "\uD83C\uDF69",
    "\uD83C\uDF6A",
    "\uD83C\uDF82",
    "\uD83C\uDF70",
    "\uD83E\uDDC1",
    "\uD83E\uDD67",
    "\uD83C\uDF6B",
    "\uD83C\uDF6C",
    "\uD83C\uDF6D",
    "\uD83C\uDF6E",
    "\uD83C\uDF6F",
    "\uD83C\uDF7C",
    "\uD83E\uDD5B",
    "\u2615",
    "\uD83D\uDE80",
    "\u2708\uFE0F",
    "\uD83D\uDEEB",
    "\uD83D\uDEEC",
    "\uD83D\uDEE9\uFE0F",
    "\uD83D\uDCBA",
    "\uD83D\uDEF0\uFE0F",
    "\uD83D\uDE81",
    "\uD83D\uDEF8",
    "\uD83D\uDEB2",
    "\uD83D\uDEF5",
    "\uD83C\uDFCD\uFE0F",
    "\uD83D\uDEFA",
    "\uD83D\uDEA8",
    "\uD83D\uDE94",
    "\uD83D\uDE8D",
    "\uD83D\uDE98",
    "\uD83D\uDE96",
    "\uD83D\uDEA1",
    "\uD83D\uDEA0",
    "\uD83D\uDE9F",
    "\uD83D\uDE83",
    "\uD83D\uDE8B",
    "\uD83D\uDE9E",
    "\uD83D\uDE9D",
    "\uD83D\uDE84",
    "\uD83D\uDE85",
    "\uD83D\uDE88",
    "\uD83D\uDE82",
    "\uD83D\uDE86",
    "\uD83D\uDE87",
    "\uD83D\uDE8A",
    "\uD83D\uDE89",
    "\u2708\uFE0F",
    "\uD83C\uDF08",
    "\u2600\uFE0F",
    "\uD83C\uDF24\uFE0F",
    "\u26C5",
    "\uD83C\uDF25\uFE0F",
    "\u2601\uFE0F",
    "\uD83C\uDF26\uFE0F",
    "\uD83C\uDF27\uFE0F",
    "\u26C8\uFE0F",
    "\uD83C\uDF29\uFE0F",
    "\uD83C\uDF28\uFE0F",
    "\u2744\uFE0F",
    "\u2603\uFE0F",
    "\u26C4",
    "\uD83C\uDF2C\uFE0F",
    "\uD83D\uDCA8",
    "\uD83D\uDCA7",
    "\uD83D\uDCA6",
    "\u2614",
    "\u2602\uFE0F",
    "\uD83C\uDF0A",
    "\uD83C\uDF2B\uFE0F",
    "\uD83C\uDF0D",
    "\uD83C\uDF0E",
    "\uD83C\uDF0F",
    "\uD83C\uDF10",
    "\uD83D\uDDFA\uFE0F",
    "\uD83E\uDDED",
    "\uD83C\uDFD4\uFE0F",
    "\u26F0\uFE0F",
    "\uD83C\uDF0B",
    "\uD83D\uDDFB",
    "\uD83C\uDFD5\uFE0F",
    "\uD83C\uDFD6\uFE0F",
    "\uD83C\uDFDC\uFE0F",
    "\uD83C\uDFDD\uFE0F",
    "\uD83D\uDEE4\uFE0F",
    "\uD83D\uDEE3\uFE0F",
    "\uD83D\uDDFE",
    "\uD83C\uDF91",
    "\uD83C\uDFDE\uFE0F",
    "\uD83D\uDC36",
    "\uD83D\uDC31",
    "\uD83D\uDC2D",
    "\uD83D\uDC39",
    "\uD83D\uDC30",
    "\uD83E\uDD8A",
    "\uD83D\uDC3B",
    "\uD83D\uDC3C",
    "\uD83D\uDC28",
    "\uD83D\uDC2F",
    "\uD83E\uDD81",
    "\uD83D\uDC2E",
    "\uD83D\uDC37",
    "\uD83D\uDC38",
    "\uD83D\uDC35",
    "\uD83D\uDE48",
    "\uD83D\uDE49",
    "\uD83D\uDE4A",
    "\uD83D\uDC12",
    "\uD83D\uDC14",
    "\uD83D\uDC27",
    "\uD83D\uDC26",
    "\uD83D\uDC24",
    "\uD83D\uDC23",
    "\uD83D\uDC25",
    "\uD83E\uDD86",
    "\uD83E\uDD85",
    "\uD83E\uDD89",
    "\uD83E\uDD87",
    "\uD83D\uDC3A",
    "\uD83D\uDC17",
    "\uD83D\uDC34",
    "\uD83E\uDD84",
    "\uD83D\uDC1D",
    "\uD83D\uDC1B",
    "\uD83E\uDD8B",
    "\uD83D\uDC0C",
    "\uD83D\uDC1E",
    "\uD83D\uDC1C",
    "\uD83E\uDD9F",
    "\uD83E\uDD97",
    "\uD83D\uDD77\uFE0F",
    "\uD83E\uDD82",
    "\uD83D\uDC22",
    "\uD83D\uDC0D",
    "\uD83E\uDD8E",
    "\uD83E\uDD96",
    "\uD83E\uDD95",
    "\uD83D\uDC19",
    "\uD83E\uDD91",
    "\uD83E\uDD90",
    "\uD83E\uDD9E",
    "\uD83E\uDD80",
    "\uD83D\uDC21",
    "\uD83D\uDC20",
    "\uD83D\uDC1F",
    "\uD83D\uDC2C",
    "\uD83D\uDC33",
    "\uD83D\uDC0B",
    "\uD83E\uDD88",
    "\uD83D\uDC0A",
    "\uD83C\uDF31",
    "\uD83C\uDF32",
    "\uD83C\uDF33",
    "\uD83C\uDF34",
    "\uD83C\uDF35",
    "\uD83C\uDF3E",
    "\uD83C\uDF3F",
    "\u2618\uFE0F",
    "\uD83C\uDF40",
    "\uD83C\uDF41",
    "\uD83C\uDF42",
    "\uD83C\uDF43",
    "\uD83C\uDF44",
    "\uD83C\uDF30",
    "\uD83E\uDD80",
    "\uD83E\uDD9E",
    "\uD83D\uDCCC",
    "\uD83D\uDCCD",
    "\uD83D\uDCCE",
    "\uD83D\uDD87\uFE0F",
    "\uD83D\uDCCF",
    "\uD83D\uDCD0",
    "\u2702\uFE0F",
    "\uD83D\uDDC3\uFE0F",
    "\uD83D\uDDC4\uFE0F",
    "\uD83D\uDDD1\uFE0F",
    "\uD83D\uDD12",
    "\uD83D\uDD13",
    "\uD83D\uDD0F",
    "\uD83D\uDD10",
    "\uD83D\uDD11",
    "\uD83D\uDDDD\uFE0F",
    "\uD83D\uDD28",
    "\uD83E\uDE93",
    "\u26CF\uFE0F",
    "\uD83D\uDEE0\uFE0F",
    "\uD83D\uDDE1\uFE0F",
    "\u2694\uFE0F",
    "\uD83D\uDD2B",
    "\uD83D\uDEE1\uFE0F",
    "\uD83E\uDEA4",
    "\uD83D\uDD27",
    "\uD83D\uDD29",
    "\u2699\uFE0F",
    "\uD83D\uDDDC\uFE0F",
    "\u2696\uFE0F",
    "\uD83E\uDDAF",
    "\uD83D\uDD17",
    "\u26D3\uFE0F",
    "\uD83E\uDE9D",
    "\uD83E\uDDF0",
    "\uD83E\uDE9B",
    "\uD83E\uDDF2",
    "\u26CF\uFE0F",
    "\u2705",
    "\u274C",
    "\u2753",
    "\u2757",
    "\u203C\uFE0F",
    "\u2049\uFE0F",
    "\uD83D\uDCAF",
    "\uD83D\uDD05",
    "\uD83D\uDD06",
    "\uD83D\uDCDB",
    "\uD83D\uDEAB",
    "\u26D4",
    "\uD83D\uDEB7",
    "\uD83D\uDEAF",
    "\uD83D\uDEB3",
    "\uD83D\uDEB1",
    "\uD83D\uDD1E",
    "\uD83D\uDCF5",
    "\uD83D\uDEAD",
    "\u2757",
    "\uD83D\uDCA2",
    "\uD83D\uDCA5",
    "\uD83D\uDCA4",
    "\uD83D\uDCA8",
    "\uD83D\uDD73\uFE0F",
    "\uD83D\uDED1",
    "\u26D4",
    "\uD83D\uDCDB",
    "\uD83D\uDEAB"
];
const $5b8d4f630a652e87$var$POPUP_WIDTH = 280;
// Top 10 commonly used favorites
const $5b8d4f630a652e87$var$DEFAULT_FAVORITES = [
    "\u2764\uFE0F",
    "\uD83D\uDE02",
    "\uD83D\uDC4D",
    "\uD83D\uDC4E",
    "\uD83C\uDF89",
    "\uD83D\uDD25",
    "\u2B50",
    "\uD83D\uDE4F",
    "\uD83D\uDC4F",
    "\uD83D\uDCAF"
];
function $5b8d4f630a652e87$export$2e2bcd8739ae039({ onSelect: onSelect, trigger: trigger = "\u2295", triggerClassName: triggerClassName = "", usedEmojis: usedEmojis = [] }) {
    const favorites = [
        ...new Set([
            ...$5b8d4f630a652e87$var$DEFAULT_FAVORITES,
            ...usedEmojis
        ])
    ];
    const restEmojis = $5b8d4f630a652e87$var$EMOJI_LIST.filter((e)=>!favorites.includes(e));
    const [open, setOpen] = (0, $d6bdfea1a1e13052$export$60241385465d0a34)(false);
    const [position, setPosition] = (0, $d6bdfea1a1e13052$export$60241385465d0a34)(null);
    const popupRef = (0, $d6bdfea1a1e13052$export$b8f5890fc79d6aca)(null);
    const buttonRef = (0, $d6bdfea1a1e13052$export$b8f5890fc79d6aca)(null);
    const openPopup = ()=>{
        const btn = buttonRef.current;
        if (btn) {
            const rect = btn.getBoundingClientRect();
            const left = Math.max(8, Math.min(rect.right - $5b8d4f630a652e87$var$POPUP_WIDTH, window.innerWidth - $5b8d4f630a652e87$var$POPUP_WIDTH - 8));
            setPosition({
                top: rect.bottom + 4,
                left: left
            });
            setOpen(true);
        }
    };
    (0, $d6bdfea1a1e13052$export$6d9c69b0de29b591)(()=>{
        if (!open) return;
        const onClickOutside = (e)=>{
            const el = popupRef.current;
            const btn = buttonRef.current;
            if (el && btn && !el.contains(e.target) && !btn.contains(e.target)) setOpen(false);
        };
        document.addEventListener("click", onClickOutside);
        return ()=>document.removeEventListener("click", onClickOutside);
    }, [
        open
    ]);
    const handleSelect = (emoji)=>{
        const shouldClose = onSelect(emoji);
        if (shouldClose === true) setOpen(false);
    };
    return /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)((0, $450fc775b2f7950e$export$ffb0004e005737fa), {
        children: [
            /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("button", {
                ref: buttonRef,
                type: "button",
                onClick: ()=>open ? setOpen(false) : openPopup(),
                className: `${triggerClassName}${open ? " !opacity-100" : ""}`,
                title: "Add reaction",
                "aria-label": "Add reaction",
                children: trigger
            }),
            open && position && /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("div", {
                ref: popupRef,
                className: "fixed z-50 w-[272px] max-h-[320px] overflow-y-auto p-2 bg-white dark:bg-gray-950 border-2 border-black dark:border-gray-100 flex flex-col gap-2",
                style: {
                    top: position.top,
                    left: position.left
                },
                children: [
                    favorites.length > 0 && /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("div", {
                        children: [
                            /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("div", {
                                className: "text-[10px] font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider mb-1 px-0.5",
                                children: "Favorites"
                            }),
                            /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("div", {
                                className: "grid grid-cols-8 gap-0.5",
                                children: favorites.map((emoji)=>/*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("button", {
                                        type: "button",
                                        onClick: ()=>handleSelect(emoji),
                                        className: "w-9 h-9 flex items-center justify-center text-xl border border-black dark:border-gray-600 bg-white dark:bg-gray-900 hover:bg-orange-100 dark:hover:bg-gray-800",
                                        title: emoji,
                                        children: emoji
                                    }, emoji))
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("div", {
                        children: [
                            /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("div", {
                                className: "text-[10px] font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider mb-1 px-0.5",
                                children: "All"
                            }),
                            /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("div", {
                                className: "grid grid-cols-8 gap-0.5",
                                children: restEmojis.map((emoji)=>/*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("button", {
                                        type: "button",
                                        onClick: ()=>handleSelect(emoji),
                                        className: "w-9 h-9 flex items-center justify-center text-xl border border-black dark:border-gray-600 bg-white dark:bg-gray-900 hover:bg-orange-100 dark:hover:bg-gray-800",
                                        title: emoji,
                                        children: emoji
                                    }, emoji))
                            })
                        ]
                    })
                ]
            })
        ]
    });
}




function $368b2e4642771d05$var$reactorsForEmoji(reactionsByUser, emoji) {
    if (!reactionsByUser) return "";
    return Object.entries(reactionsByUser).filter(([, emojis])=>{
        const arr = Array.isArray(emojis) ? emojis : emojis ? [
            emojis
        ] : [];
        return arr.includes(emoji);
    }).map(([u])=>u).join(", ");
}
function $368b2e4642771d05$export$2e2bcd8739ae039({ entry: entry, slug: slug, username: username, reactionCounts: reactionCounts = {}, currentUserEmojis: currentUserEmojis = [], reactionsByUser: reactionsByUser = {}, usedEmojis: usedEmojis = [], avatar: avatar, tooltipDelayMs: tooltipDelayMs = 400 }) {
    const { id: id, type: type, message: message, username: entryUsername, created_at: created_at } = entry;
    const isChat = type === "chat_message_posted";
    const handleReaction = (emoji)=>{
        if (!slug || !username) return;
        const hasEmoji = currentUserEmojis.includes(emoji);
        if (hasEmoji) {
            (0, $30170d3e8382adde$export$64a40cf65fcd549d)(slug, {
                type: "chat_message_reaction_removed",
                message: "",
                data: {
                    message_id: id,
                    username: username,
                    emoji: emoji
                }
            });
            return true;
        } else {
            (0, $30170d3e8382adde$export$64a40cf65fcd549d)(slug, {
                type: "chat_message_reaction_added",
                message: "",
                data: {
                    message_id: id,
                    emoji: emoji,
                    username: username
                }
            });
            return false;
        }
    };
    const hasReactions = Object.keys(reactionCounts).length > 0;
    const userColorClass = (0, $8228b3fd71ca6b09$export$1ad7b801017acf63)(entryUsername);
    return /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("div", {
        className: `text-sm p-2 pb-8 bg-orange-50 dark:bg-gray-900 border-2 relative group mb-[15px] ${entryUsername ? userColorClass : "border-black dark:border-gray-500"}`,
        children: [
            /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("div", {
                className: "pr-20 font-mono text-black dark:text-gray-100",
                children: [
                    /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("div", {
                        className: "flex items-start gap-2 mb-0.5",
                        children: [
                            entryUsername ? /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)((0, $dc094c5397bc487f$export$2e2bcd8739ae039), {
                                username: entryUsername,
                                avatar: avatar,
                                size: 64
                            }) : null,
                            /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("span", {
                                className: "block text-xs opacity-80",
                                children: [
                                    /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("span", {
                                        className: `font-semibold ${(0, $8228b3fd71ca6b09$export$1ad7b801017acf63)(entryUsername)}`,
                                        children: entryUsername || "System"
                                    }),
                                    " ",
                                    "\xb7 ",
                                    created_at
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("span", {
                        children: message
                    })
                ]
            }),
            isChat && slug && username ? /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("div", {
                className: "absolute right-2 -bottom-4 z-10 flex items-center gap-1",
                children: [
                    hasReactions ? /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("div", {
                        className: "flex flex-wrap gap-0.5",
                        children: Object.entries(reactionCounts).filter(([, count])=>count > 0).map(([emoji])=>{
                            const reactors = $368b2e4642771d05$var$reactorsForEmoji(reactionsByUser, emoji);
                            const display = (0, $8228b3fd71ca6b09$export$b748117d79873787)[emoji] || emoji;
                            const tooltipContent = reactors ? reactors : "No reactions";
                            return /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)((0, $d4e2ce7b085e1358$export$2e2bcd8739ae039), {
                                content: tooltipContent,
                                delayMs: tooltipDelayMs,
                                children: /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("button", {
                                    type: "button",
                                    onClick: ()=>handleReaction(emoji),
                                    className: `inline-flex items-center gap-0.5 px-1.5 py-0.5 text-sm border-2 border-black dark:border-gray-100 transition-colors ${currentUserEmojis.includes(emoji) ? "bg-brutal-purple text-white" : "bg-white dark:bg-gray-950 hover:bg-orange-100 dark:hover:bg-gray-800"}`,
                                    children: [
                                        display,
                                        " ",
                                        reactionCounts[emoji] || 0
                                    ]
                                })
                            }, emoji);
                        })
                    }) : null,
                    /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)((0, $5b8d4f630a652e87$export$2e2bcd8739ae039), {
                        onSelect: handleReaction,
                        usedEmojis: usedEmojis,
                        trigger: "+",
                        triggerClassName: "brutal-btn inline-flex items-center justify-center min-h-[1.5rem] min-w-[1.5rem] p-0 text-sm font-bold bg-white dark:bg-gray-950 text-gray-700 dark:text-gray-300 border-2 border-black dark:border-gray-100"
                    })
                ]
            }) : null
        ]
    }, id);
}








const $7513492da5ab6889$var$ACTION_TYPES = new Set([
    "slot_created",
    "slot_deleted",
    "slot_description_updated",
    "reaction_set",
    "reaction_cleared",
    "tag_created",
    "tag_added_to_slot",
    "tag_removed_from_slot"
]);
function $7513492da5ab6889$var$isActionType(type) {
    return $7513492da5ab6889$var$ACTION_TYPES.has(type);
}
function $7513492da5ab6889$export$cd40a8af1bfd30a2(entries) {
    const result = [];
    let group = [];
    let groupUser = null;
    for (const entry of entries){
        const isAction = $7513492da5ab6889$var$isActionType(entry.type);
        const user = entry.username ?? "";
        if (isAction && groupUser === user && group.length > 0) group.push(entry);
        else {
            if (group.length === 1) result.push(group[0]);
            else if (group.length > 1) result.push(group);
            group = [];
            groupUser = null;
            if (isAction) {
                group = [
                    entry
                ];
                groupUser = user;
            } else result.push(entry);
        }
    }
    if (group.length === 1) result.push(group[0]);
    else if (group.length > 1) result.push(group);
    return result;
}
function $7513492da5ab6889$export$2e2bcd8739ae039({ entries: entries, slug: slug, username: username, reactionsByMessage: reactionsByMessage = {}, reactionsByUserByMessage: reactionsByUserByMessage = {}, usedEmojis: usedEmojis = [], avatarsByUsername: avatarsByUsername = {} }) {
    const [expanded, setExpanded] = (0, $d6bdfea1a1e13052$export$60241385465d0a34)(false);
    const contentRef = (0, $d6bdfea1a1e13052$export$b8f5890fc79d6aca)(null);
    const first = entries[0];
    const displayName = first.username || "System";
    (0, $d6bdfea1a1e13052$export$6d9c69b0de29b591)(()=>{
        if (expanded && contentRef.current) contentRef.current.scrollIntoView({
            behavior: "smooth",
            block: "nearest"
        });
    }, [
        expanded
    ]);
    return /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("div", {
        ref: contentRef,
        className: "overflow-visible",
        children: [
            /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)((0, $7282a58d465f88c4$export$e69968945bee9866), {
                type: "button",
                variant: "secondary",
                onClick: ()=>setExpanded((e)=>!e),
                className: "w-full justify-start text-sm px-3 py-2 bg-orange-50 dark:bg-gray-900 hover:bg-orange-100 dark:hover:bg-gray-800 gap-2",
                children: [
                    /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("span", {
                        className: `inline-block transition-transform ${expanded ? "rotate-90" : ""}`,
                        "aria-hidden": true,
                        children: "\u25B6"
                    }),
                    /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("span", {
                        className: "text-xs opacity-80 flex-1",
                        children: [
                            /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("span", {
                                className: `font-semibold ${(0, $8228b3fd71ca6b09$export$1ad7b801017acf63)(displayName)}`,
                                children: displayName
                            }),
                            " ",
                            "\xb7 ",
                            entries.length,
                            " actions"
                        ]
                    }),
                    /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("span", {
                        className: "text-xs text-gray-500 dark:text-gray-400",
                        children: first.created_at
                    })
                ]
            }),
            expanded ? /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("div", {
                className: "flex flex-col gap-1 p-2 border-2 border-black dark:border-gray-500 mt-1 bg-white dark:bg-gray-950",
                children: entries.map((entry)=>/*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)((0, $368b2e4642771d05$export$2e2bcd8739ae039), {
                        entry: entry,
                        slug: slug,
                        username: username,
                        reactionCounts: entry.type === "chat_message_posted" ? reactionsByMessage[entry.id] : undefined,
                        currentUserEmojis: entry.type === "chat_message_posted" && username ? (()=>{
                            const v = reactionsByUserByMessage[entry.id]?.[username];
                            return Array.isArray(v) ? v : v ? [
                                v
                            ] : [];
                        })() : undefined,
                        reactionsByUser: entry.type === "chat_message_posted" ? reactionsByUserByMessage[entry.id] : undefined,
                        usedEmojis: usedEmojis,
                        avatar: (0, $c9d11e0a6831e0d1$export$2a73bcf51ef6df14)(entry.username ?? "", avatarsByUsername)
                    }, entry.id))
            }) : null
        ]
    });
}






function $29d7681bd26904cb$export$2e2bcd8739ae039({ state: state, slug: slug, username: username, lastReadEventId: lastReadEventId = 0 }) {
    const [body, setBody] = (0, $d6bdfea1a1e13052$export$60241385465d0a34)("");
    const scrollContainerRef = (0, $d6bdfea1a1e13052$export$b8f5890fc79d6aca)(null);
    (0, $d6bdfea1a1e13052$export$6d9c69b0de29b591)(()=>{
        const el = scrollContainerRef.current;
        if (el) el.scrollTop = el.scrollHeight;
    }, [
        state.logMessages?.length
    ]);
    const sendChat = (0, $d6bdfea1a1e13052$export$35808ee640e87ca7)((e)=>{
        e.preventDefault();
        if (!body.trim()) return;
        const msg = body.trim();
        (0, $30170d3e8382adde$export$64a40cf65fcd549d)(slug, {
            type: "chat_message_posted",
            message: msg,
            data: {
                body: msg
            }
        }).then(()=>setBody(""));
    }, [
        body,
        slug,
        username
    ]);
    const messages = state.logMessages || [];
    const grouped = (0, $7513492da5ab6889$export$cd40a8af1bfd30a2)(messages);
    const usedEmojis = (0, $8228b3fd71ca6b09$export$bf20776e1dcd45e7)(state);
    const avatarsByUsername = state.avatarsByUsername || {};
    /** Max event id in this item (single entry or group). */ const maxIdOf = (item)=>Array.isArray(item) ? Math.max(...item.map((e)=>e.id)) : item.id;
    const showSeparator = lastReadEventId > 0;
    return /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("div", {
        className: "flex flex-col border-2 border-black dark:border-gray-100 bg-white dark:bg-gray-950 min-h-[280px] max-h-[calc(100vh-12rem)] flex-shrink-0 w-full lg:w-80",
        children: [
            /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("div", {
                ref: scrollContainerRef,
                className: "flex-1 min-h-0 overflow-y-auto p-4 flex flex-col gap-2",
                children: grouped.map((item)=>{
                    const maxId = maxIdOf(item);
                    const showLineAfter = showSeparator && maxId === lastReadEventId;
                    return /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)((0, $450fc775b2f7950e$export$ffb0004e005737fa), {
                        children: [
                            Array.isArray(item) ? /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)((0, $7513492da5ab6889$export$2e2bcd8739ae039), {
                                entries: item,
                                slug: slug,
                                username: username,
                                reactionsByMessage: state.reactionsByMessage,
                                reactionsByUserByMessage: state.reactionsByUserByMessage,
                                usedEmojis: usedEmojis,
                                avatarsByUsername: avatarsByUsername
                            }) : /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)((0, $368b2e4642771d05$export$2e2bcd8739ae039), {
                                entry: item,
                                slug: item.type === "chat_message_posted" ? slug : undefined,
                                username: item.type === "chat_message_posted" ? username : undefined,
                                reactionCounts: item.type === "chat_message_posted" ? state.reactionsByMessage?.[item.id] : undefined,
                                currentUserEmojis: item.type === "chat_message_posted" && username ? (()=>{
                                    const v = state.reactionsByUserByMessage?.[item.id]?.[username];
                                    return Array.isArray(v) ? v : v ? [
                                        v
                                    ] : [];
                                })() : undefined,
                                reactionsByUser: item.type === "chat_message_posted" ? state.reactionsByUserByMessage?.[item.id] : undefined,
                                usedEmojis: usedEmojis,
                                avatar: (0, $c9d11e0a6831e0d1$export$2a73bcf51ef6df14)(item.username ?? "", avatarsByUsername)
                            }),
                            showLineAfter && /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("div", {
                                className: "flex items-center gap-2 py-1 text-xs text-gray-500 dark:text-gray-400",
                                "aria-hidden": "true",
                                children: [
                                    /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("span", {
                                        className: "flex-1 border-b-2 border-gray-300 dark:border-gray-600"
                                    }),
                                    /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("span", {
                                        className: "font-logo uppercase tracking-tight shrink-0",
                                        children: "Last seen"
                                    }),
                                    /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("span", {
                                        className: "flex-1 border-b-2 border-gray-300 dark:border-gray-600"
                                    })
                                ]
                            })
                        ]
                    }, Array.isArray(item) ? `group-${item[0].id}` : item.id);
                })
            }),
            /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("form", {
                className: "flex gap-2 p-4 border-t-2 border-black dark:border-gray-100",
                onSubmit: sendChat,
                children: [
                    /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)((0, $7282a58d465f88c4$export$e0d8aacd8d06bfd5), {
                        type: "text",
                        className: "flex-1 min-w-0",
                        placeholder: "Type a message...",
                        value: body,
                        onInput: (e)=>setBody(e.target.value)
                    }),
                    /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)((0, $7282a58d465f88c4$export$e69968945bee9866), {
                        type: "submit",
                        variant: "primary",
                        className: "px-5 py-2.5",
                        children: "Send"
                    })
                ]
            })
        ]
    });
}





function $6ad42b3bca101366$export$2e2bcd8739ae039({ open: open, onClose: onClose, title: title, children: children, maxWidth: maxWidth = "max-w-xs", titleClassName: titleClassName }) {
    if (!open) return null;
    return /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("div", {
        className: "brutal-modal-overlay flex items-center justify-center",
        role: "dialog",
        "aria-modal": "true",
        "aria-labelledby": "brutal-modal-title",
        onClick: onClose,
        children: /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("div", {
            className: `border-2 border-black dark:border-gray-100 bg-white dark:bg-gray-950 p-4 w-[90%] flex flex-col gap-3 ${maxWidth}`,
            onClick: (e)=>e.stopPropagation(),
            children: [
                /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("div", {
                    id: "brutal-modal-title",
                    className: titleClassName ?? "text-sm font-semibold text-gray-900 dark:text-gray-100",
                    children: title
                }),
                children
            ]
        })
    });
}








function $f3b7f362873169a6$export$2e2bcd8739ae039({ slug: slug, username: username, trigger: trigger }) {
    const [isOpen, setIsOpen] = (0, $d6bdfea1a1e13052$export$60241385465d0a34)(false);
    const [file, setFile] = (0, $d6bdfea1a1e13052$export$60241385465d0a34)(null);
    const [imageUrl, setImageUrl] = (0, $d6bdfea1a1e13052$export$60241385465d0a34)(null);
    const [imageWidth, setImageWidth] = (0, $d6bdfea1a1e13052$export$60241385465d0a34)(0);
    const [imageHeight, setImageHeight] = (0, $d6bdfea1a1e13052$export$60241385465d0a34)(0);
    const [cropX, setCropX] = (0, $d6bdfea1a1e13052$export$60241385465d0a34)(0);
    const [cropY, setCropY] = (0, $d6bdfea1a1e13052$export$60241385465d0a34)(0);
    const [cropSize, setCropSize] = (0, $d6bdfea1a1e13052$export$60241385465d0a34)(0);
    /** Zoom 0 = zoomed out (full crop), 100 = zoomed in (smallest crop). */ const [zoom, setZoom] = (0, $d6bdfea1a1e13052$export$60241385465d0a34)(0);
    const [isUploading, setIsUploading] = (0, $d6bdfea1a1e13052$export$60241385465d0a34)(false);
    const [error, setError] = (0, $d6bdfea1a1e13052$export$60241385465d0a34)(null);
    const canvasRef = (0, $d6bdfea1a1e13052$export$b8f5890fc79d6aca)(null);
    // Clean up object URL when component unmounts or image changes.
    (0, $d6bdfea1a1e13052$export$6d9c69b0de29b591)(()=>{
        return ()=>{
            if (imageUrl) URL.revokeObjectURL(imageUrl);
        };
    }, [
        imageUrl
    ]);
    const resetState = ()=>{
        setFile(null);
        if (imageUrl) URL.revokeObjectURL(imageUrl);
        setImageUrl(null);
        setImageWidth(0);
        setImageHeight(0);
        setCropX(0);
        setCropY(0);
        setCropSize(0);
        setZoom(0);
        setError(null);
    };
    const handleOpen = ()=>{
        setIsOpen(true);
    };
    const handleClose = ()=>{
        setIsOpen(false);
        resetState();
    };
    const loadFile = (selected)=>{
        if (!selected.type.startsWith("image/")) {
            setError("Please select an image file.");
            return;
        }
        setError(null);
        setFile(selected);
        if (imageUrl) URL.revokeObjectURL(imageUrl);
        const url = URL.createObjectURL(selected);
        setImageUrl(url);
        const img = new Image();
        img.onload = ()=>{
            const w = img.naturalWidth || img.width;
            const h = img.naturalHeight || img.height;
            setImageWidth(w);
            setImageHeight(h);
            const maxSize = Math.min(w, h);
            setCropSize(maxSize);
            setCropX((w - maxSize) / 2);
            setCropY((h - maxSize) / 2);
            setZoom(0);
        };
        img.onerror = ()=>{
            setError("Could not load image.");
        };
        img.src = url;
    };
    const handleFileChange = (e)=>{
        const input = e.target;
        const selected = input.files && input.files[0];
        if (!selected) return;
        loadFile(selected);
    };
    const openWithFile = (selectedFile)=>{
        loadFile(selectedFile);
        setIsOpen(true);
    };
    // Draw 64x64 preview of the current crop.
    (0, $d6bdfea1a1e13052$export$6d9c69b0de29b591)(()=>{
        if (!imageUrl || !cropSize || !canvasRef.current) return;
        const img = new Image();
        img.onload = ()=>{
            const canvas = canvasRef.current;
            if (!canvas) return;
            const ctx = canvas.getContext("2d");
            if (!ctx) return;
            ctx.clearRect(0, 0, canvas.width, canvas.height);
            ctx.imageSmoothingEnabled = true;
            ctx.imageSmoothingQuality = "high";
            ctx.drawImage(img, cropX, cropY, cropSize, cropSize, 0, 0, canvas.width, canvas.height);
        };
        img.src = imageUrl;
    }, [
        imageUrl,
        cropX,
        cropY,
        cropSize
    ]);
    const handleCropChangeX = (e)=>{
        const target = e.target;
        const maxX = Math.max(0, imageWidth - cropSize);
        const v = Math.min(Math.max(0, Number(target.value) || 0), maxX);
        setCropX(v);
    };
    const handleCropChangeY = (e)=>{
        const target = e.target;
        const maxY = Math.max(0, imageHeight - cropSize);
        const v = Math.min(Math.max(0, Number(target.value) || 0), maxY);
        setCropY(v);
    };
    const maxCropSize = imageWidth && imageHeight ? Math.min(imageWidth, imageHeight) : 0;
    const minCropSize = 64;
    const handleZoomChange = (e)=>{
        const target = e.target;
        const newZoom = Math.min(100, Math.max(0, Number(target.value) || 0));
        if (maxCropSize <= minCropSize) {
            setZoom(newZoom);
            return;
        }
        const centerX = cropX + cropSize / 2;
        const centerY = cropY + cropSize / 2;
        const newCropSize = Math.max(minCropSize, maxCropSize - newZoom / 100 * (maxCropSize - minCropSize));
        const newCropX = Math.max(0, Math.min(imageWidth - newCropSize, centerX - newCropSize / 2));
        const newCropY = Math.max(0, Math.min(imageHeight - newCropSize, centerY - newCropSize / 2));
        setZoom(newZoom);
        setCropSize(newCropSize);
        setCropX(newCropX);
        setCropY(newCropY);
    };
    const handleSubmit = async ()=>{
        if (!file || !cropSize) {
            setError("Choose an image and crop area first.");
            return;
        }
        setIsUploading(true);
        setError(null);
        const crop = {
            x: Math.round(cropX),
            y: Math.round(cropY),
            size: Math.round(cropSize)
        };
        try {
            await (0, $30170d3e8382adde$export$db6dcff2e77846b2)(slug, file, crop);
            handleClose();
        } catch (err) {
            // eslint-disable-next-line no-console
            console.error(err);
            setError("Failed to upload face image. Please try again.");
        } finally{
            setIsUploading(false);
        }
    };
    const triggerContent = trigger ? trigger(handleOpen, openWithFile) : /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("div", {
        className: "flex flex-col gap-2",
        children: /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("div", {
            className: "flex items-center justify-between gap-2",
            children: [
                /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("span", {
                    className: "text-xs text-gray-700 dark:text-gray-300",
                    children: [
                        "Face for ",
                        /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("span", {
                            className: "font-semibold",
                            children: username || "you"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)((0, $7282a58d465f88c4$export$e69968945bee9866), {
                    type: "button",
                    variant: "secondary",
                    className: "px-3 py-1 text-xs min-h-[2rem]",
                    onClick: handleOpen,
                    children: "Set face"
                })
            ]
        })
    });
    return /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)((0, $450fc775b2f7950e$export$ffb0004e005737fa), {
        children: [
            triggerContent,
            /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)((0, $6ad42b3bca101366$export$2e2bcd8739ae039), {
                open: isOpen,
                onClose: handleClose,
                title: "Set your face",
                maxWidth: "max-w-md",
                children: /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)((0, $450fc775b2f7950e$export$ffb0004e005737fa), {
                    children: [
                        !file ? /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("div", {
                            className: "flex flex-col gap-2",
                            children: [
                                /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("label", {
                                    className: "text-xs font-semibold text-gray-800 dark:text-gray-100",
                                    children: "Choose an image"
                                }),
                                /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("input", {
                                    type: "file",
                                    accept: "image/*",
                                    onChange: handleFileChange,
                                    className: "text-xs"
                                })
                            ]
                        }) : null,
                        imageUrl && cropSize > 0 ? /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("div", {
                            className: "flex flex-col gap-2",
                            children: /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("div", {
                                className: "flex items-center gap-4",
                                children: [
                                    /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("div", {
                                        className: "flex flex-col gap-1 flex-1",
                                        children: [
                                            /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("label", {
                                                className: "text-xs text-gray-700 dark:text-gray-300",
                                                children: "Zoom"
                                            }),
                                            /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("input", {
                                                type: "range",
                                                min: "0",
                                                max: "100",
                                                value: zoom,
                                                onInput: handleZoomChange,
                                                title: "Zoom in/out"
                                            }),
                                            /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("label", {
                                                className: "text-xs text-gray-700 dark:text-gray-300 mt-2",
                                                children: "Horizontal position"
                                            }),
                                            /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("input", {
                                                type: "range",
                                                min: "0",
                                                max: Math.max(0, imageWidth - cropSize),
                                                value: cropX,
                                                onInput: handleCropChangeX
                                            }),
                                            /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("label", {
                                                className: "text-xs text-gray-700 dark:text-gray-300 mt-2",
                                                children: "Vertical position"
                                            }),
                                            /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("input", {
                                                type: "range",
                                                min: "0",
                                                max: Math.max(0, imageHeight - cropSize),
                                                value: cropY,
                                                onInput: handleCropChangeY
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("div", {
                                        className: "flex flex-col items-center gap-1",
                                        children: [
                                            /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("span", {
                                                className: "text-xs text-gray-700 dark:text-gray-300",
                                                children: "64\xd764 preview"
                                            }),
                                            /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("canvas", {
                                                ref: canvasRef,
                                                width: 64,
                                                height: 64,
                                                className: "border-2 border-black dark:border-gray-100 bg-gray-200 dark:bg-gray-800"
                                            })
                                        ]
                                    })
                                ]
                            })
                        }) : null,
                        error ? /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("p", {
                            className: "text-xs text-red-700 dark:text-red-400",
                            children: error
                        }) : null,
                        /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("div", {
                            className: "flex gap-2 justify-end",
                            children: [
                                /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)((0, $7282a58d465f88c4$export$e69968945bee9866), {
                                    type: "button",
                                    variant: "secondary",
                                    className: "px-3 py-1 text-xs min-h-0",
                                    onClick: handleClose,
                                    disabled: isUploading,
                                    children: "Cancel"
                                }),
                                /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)((0, $7282a58d465f88c4$export$e69968945bee9866), {
                                    type: "button",
                                    variant: "primary",
                                    className: "px-3 py-1 text-xs min-h-0",
                                    onClick: handleSubmit,
                                    disabled: isUploading || !file || !cropSize,
                                    children: isUploading ? "Saving\u2026" : "Save"
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}



const $75c1ce28026314a1$var$FACE_SIZE = 64;
function $75c1ce28026314a1$var$getCurrentTheme() {
    if (typeof document === "undefined") return "light";
    try {
        return document.documentElement.classList.contains("dark") ? "dark" : "light";
    } catch  {
        return "light";
    }
}
function $75c1ce28026314a1$export$2e2bcd8739ae039({ open: open, onClose: onClose, slug: slug, username: username, avatar: avatar, notificationsEnabled: notificationsEnabled, notificationsSupported: notificationsSupported, onEnableNotifications: onEnableNotifications, onDisableNotifications: onDisableNotifications, onNotificationsChange: onNotificationsChange, onAccept: onAccept, installPrompt: installPrompt = null, isStandalone: isStandalone = false }) {
    const [nameValue, setNameValue] = (0, $d6bdfea1a1e13052$export$60241385465d0a34)(username);
    const [notificationsChecked, setNotificationsChecked] = (0, $d6bdfea1a1e13052$export$60241385465d0a34)(notificationsEnabled);
    const [themeValue, setThemeValue] = (0, $d6bdfea1a1e13052$export$60241385465d0a34)($75c1ce28026314a1$var$getCurrentTheme());
    const [installing, setInstalling] = (0, $d6bdfea1a1e13052$export$60241385465d0a34)(false);
    const fileInputRef = (0, $d6bdfea1a1e13052$export$b8f5890fc79d6aca)(null);
    const themeOnOpenRef = (0, $d6bdfea1a1e13052$export$b8f5890fc79d6aca)($75c1ce28026314a1$var$getCurrentTheme());
    const handleInstallClick = async ()=>{
        if (!installPrompt) return;
        setInstalling(true);
        try {
            await installPrompt.prompt();
        } finally{
            setInstalling(false);
        }
    };
    (0, $d6bdfea1a1e13052$export$6d9c69b0de29b591)(()=>{
        if (open) {
            setNameValue(username);
            setNotificationsChecked(notificationsEnabled);
            const current = $75c1ce28026314a1$var$getCurrentTheme();
            setThemeValue(current);
            themeOnOpenRef.current = current;
        }
    }, [
        open,
        username,
        notificationsEnabled
    ]);
    const handleThemeChange = (next)=>{
        setThemeValue(next);
        window.meetdaySetTheme?.(next);
    };
    const handleAccept = async ()=>{
        const updates = {};
        if (nameValue.trim() !== username) {
            const newName = nameValue.trim();
            if (newName) try {
                const res = await (0, $30170d3e8382adde$export$64a40cf65fcd549d)(slug, {
                    type: "username_changed",
                    message: "",
                    data: {
                        name: newName
                    }
                });
                if (!res.ok) throw new Error("Failed to update name");
                updates.username = newName;
            } catch  {
                // Leave dialog open; user can retry or cancel.
                return;
            }
        }
        if (notificationsChecked !== notificationsEnabled) {
            if (notificationsChecked && !notificationsSupported) ;
            else {
                if (notificationsChecked) await onEnableNotifications();
                else await onDisableNotifications();
                onNotificationsChange(notificationsChecked);
                updates.notifications = notificationsChecked;
            }
        }
        updates.theme = themeValue;
        onAccept?.(updates);
        onClose();
    };
    const handleCancel = ()=>{
        setNameValue(username);
        setNotificationsChecked(notificationsEnabled);
        setThemeValue(themeOnOpenRef.current);
        window.meetdaySetTheme?.(themeOnOpenRef.current);
        onClose();
    };
    if (!open) return null;
    return /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)((0, $6ad42b3bca101366$export$2e2bcd8739ae039), {
        open: open,
        onClose: handleCancel,
        title: "Settings",
        maxWidth: "max-w-sm",
        titleClassName: "text-2xl font-logo font-bold tracking-tight uppercase text-gray-900 dark:text-white",
        children: /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("div", {
            className: "flex flex-col gap-4",
            children: [
                /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("div", {
                    className: "flex flex-col gap-1",
                    children: [
                        /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("label", {
                            className: "text-xs font-semibold text-gray-800 dark:text-gray-100",
                            children: "Name"
                        }),
                        /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("input", {
                            type: "text",
                            value: nameValue,
                            onInput: (e)=>setNameValue(e.target.value),
                            maxLength: 120,
                            placeholder: "Your name",
                            className: "brutal-input px-4 py-2.5 text-base rounded-none border-2 border-black dark:border-gray-100 bg-white dark:bg-gray-950 text-gray-900 dark:text-gray-100 w-full"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("div", {
                    className: "flex flex-col gap-1",
                    children: [
                        /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("span", {
                            className: "text-xs font-semibold text-gray-800 dark:text-gray-100",
                            children: "Image"
                        }),
                        /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)((0, $f3b7f362873169a6$export$2e2bcd8739ae039), {
                            slug: slug,
                            username: username,
                            trigger: (_openModal, openWithFile)=>/*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)((0, $450fc775b2f7950e$export$ffb0004e005737fa), {
                                    children: [
                                        /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("input", {
                                            ref: fileInputRef,
                                            type: "file",
                                            accept: "image/*",
                                            className: "hidden",
                                            onChange: (e)=>{
                                                const file = e.target.files?.[0];
                                                if (file) openWithFile(file);
                                                e.target.value = "";
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("button", {
                                            type: "button",
                                            onClick: ()=>fileInputRef.current?.click(),
                                            className: "flex items-center justify-center rounded-none border-2 border-black dark:border-gray-100 bg-white dark:bg-gray-900 hover:bg-gray-100 dark:hover:bg-gray-800 p-0.5 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-brutal-orange w-16 h-16 flex-shrink-0",
                                            title: "Change face",
                                            "aria-label": "Change face",
                                            children: /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)((0, $dc094c5397bc487f$export$2e2bcd8739ae039), {
                                                username: username,
                                                avatar: avatar,
                                                size: $75c1ce28026314a1$var$FACE_SIZE
                                            })
                                        })
                                    ]
                                })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("div", {
                    className: "flex flex-col gap-1 p-3 border-2 border-black dark:border-gray-100 bg-white dark:bg-gray-900",
                    children: [
                        /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("div", {
                            className: "flex items-center gap-3",
                            children: [
                                /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("input", {
                                    type: "checkbox",
                                    id: "settings-notifications",
                                    checked: notificationsChecked,
                                    disabled: !notificationsSupported,
                                    onChange: (e)=>setNotificationsChecked(e.target.checked),
                                    className: "rounded-none border-2 border-black dark:border-gray-100 w-5 h-5 cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed"
                                }),
                                /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("label", {
                                    htmlFor: "settings-notifications",
                                    className: `font-logo font-bold text-sm uppercase tracking-tight text-gray-900 dark:text-gray-100 select-none ${notificationsSupported ? "cursor-pointer" : "cursor-not-allowed opacity-70"}`,
                                    children: "Enable notifications"
                                })
                            ]
                        }),
                        !notificationsSupported && /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("p", {
                            className: "text-xs text-gray-600 dark:text-gray-400",
                            children: "Not available: server is not configured for push (set MEETDAY_VAPID_PUBLIC and MEETDAY_VAPID_PRIVATE)."
                        })
                    ]
                }),
                !isStandalone ? /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("div", {
                    className: "flex flex-col gap-2 p-3 border-2 border-black dark:border-gray-100 bg-white dark:bg-gray-900",
                    children: [
                        /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("span", {
                            className: "font-logo font-bold text-xs uppercase tracking-tight text-gray-800 dark:text-gray-100",
                            children: "Install app"
                        }),
                        installPrompt ? /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("button", {
                            type: "button",
                            onClick: handleInstallClick,
                            disabled: installing,
                            className: "brutal-btn inline-flex justify-center items-center min-h-[2.5rem] px-4 py-2.5 font-semibold rounded-none border-2 border-black dark:border-gray-100 w-full text-sm bg-brutal-purple text-white hover:bg-brutal-purple-hover disabled:opacity-60",
                            children: installing ? "\u2026" : "Install Meetday"
                        }) : /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("p", {
                            className: "text-xs text-gray-600 dark:text-gray-400",
                            children: [
                                "Use your browser menu: ",
                                /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("strong", {
                                    children: "\u22EE"
                                }),
                                " \u2192 Install Meetday (Chrome/Edge). On iPhone/iPad: ",
                                /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("strong", {
                                    children: "Share"
                                }),
                                " \u2192 Add to Home Screen."
                            ]
                        })
                    ]
                }) : null,
                /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("div", {
                    className: "flex flex-col gap-2",
                    children: [
                        /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("span", {
                            className: "font-logo font-bold text-xs uppercase tracking-tight text-gray-800 dark:text-gray-100",
                            children: "Theme"
                        }),
                        /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("div", {
                            className: "flex gap-0 border-2 border-black dark:border-gray-100 overflow-hidden",
                            children: [
                                /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("label", {
                                    className: "flex-1 cursor-pointer",
                                    children: [
                                        /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("input", {
                                            type: "radio",
                                            name: "theme",
                                            checked: themeValue === "light",
                                            onChange: ()=>handleThemeChange("light"),
                                            className: "sr-only"
                                        }),
                                        /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("span", {
                                            className: `block text-center py-2.5 px-4 font-logo font-bold text-sm uppercase tracking-tight border-r-2 border-black dark:border-gray-100 transition-colors ${themeValue === "light" ? "bg-brutal-orange text-black dark:text-gray-900" : "bg-white dark:bg-gray-950 text-gray-900 dark:text-gray-100 hover:bg-gray-100 dark:hover:bg-gray-800"}`,
                                            children: "Light"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("label", {
                                    className: "flex-1 cursor-pointer",
                                    children: [
                                        /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("input", {
                                            type: "radio",
                                            name: "theme",
                                            checked: themeValue === "dark",
                                            onChange: ()=>handleThemeChange("dark"),
                                            className: "sr-only"
                                        }),
                                        /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("span", {
                                            className: `block text-center py-2.5 px-4 font-logo font-bold text-sm uppercase tracking-tight ${themeValue === "dark" ? "bg-brutal-orange text-black dark:text-gray-900" : "bg-white dark:bg-gray-950 text-gray-900 dark:text-gray-100 hover:bg-gray-100 dark:hover:bg-gray-800"}`,
                                            children: "Dark"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("form", {
                    method: "post",
                    action: `/c/${slug}/logout`,
                    className: "m-0",
                    children: /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("button", {
                        type: "submit",
                        className: "brutal-btn inline-flex justify-center min-h-[2.5rem] px-5 py-2.5 font-semibold rounded-none border-2 border-black dark:border-gray-100 w-full text-sm bg-transparent text-gray-900 dark:text-gray-100 hover:bg-orange-50 dark:hover:bg-gray-800",
                        children: "Log out"
                    })
                }),
                /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("div", {
                    className: "flex gap-2 justify-end pt-2 border-t-2 border-black dark:border-gray-100",
                    children: [
                        /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("button", {
                            type: "button",
                            onClick: handleCancel,
                            className: "brutal-btn inline-flex justify-center min-h-[2.25rem] px-4 py-1.5 text-sm font-semibold rounded-none border-2 border-black dark:border-gray-100 bg-white dark:bg-gray-950 text-gray-900 dark:text-gray-100 hover:bg-orange-50 dark:hover:bg-gray-800",
                            children: "Cancel"
                        }),
                        /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("button", {
                            type: "button",
                            onClick: handleAccept,
                            className: "brutal-btn inline-flex justify-center min-h-[2.25rem] px-4 py-1.5 text-sm font-semibold rounded-none border-2 border-black dark:border-gray-100 bg-brutal-orange text-black dark:text-gray-900 hover:bg-brutal-orange-hover",
                            children: "Accept"
                        })
                    ]
                })
            ]
        })
    });
}




const $080fd3f193a2c5b4$var$MONTH_OPTIONS = [
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12
].map((m)=>({
        value: m,
        label: new Date(2000, m - 1, 1).toLocaleString(undefined, {
            month: "long"
        })
    }));
const $080fd3f193a2c5b4$var$selectClass = "brutal-input rounded-none border-2 border-black dark:border-gray-100 bg-white dark:bg-gray-900 text-gray-900 dark:text-gray-100 min-h-[2.5rem] px-2 py-1.5 text-sm sm:text-base font-semibold w-full min-w-0";
function $080fd3f193a2c5b4$var$MonthNav({ month: month, year: year, onPrev: onPrev, onNext: onNext, onMonthChange: onMonthChange, onYearChange: onYearChange }) {
    const years = [];
    for(let y = year - 5; y <= year + 5; y += 1)years.push(y);
    return /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("nav", {
        className: "flex flex-nowrap items-center gap-2 sm:gap-3 mt-3 border-2 border-black dark:border-gray-100 bg-white dark:bg-gray-950 px-2 sm:px-4 py-2",
        children: [
            /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("button", {
                type: "button",
                className: "shrink-0 inline-flex items-center justify-center w-10 h-10 sm:min-w-[3rem] sm:px-4 sm:py-3 text-xl rounded-none border-2 border-black dark:border-gray-100 bg-brutal-purple text-white hover:bg-brutal-purple-hover",
                "aria-label": "Previous month",
                onClick: onPrev,
                children: "\u2190"
            }),
            /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("div", {
                className: "flex flex-1 items-center justify-center gap-2 min-w-0",
                children: [
                    /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("select", {
                        className: `${$080fd3f193a2c5b4$var$selectClass} flex-1 max-w-[8rem] sm:max-w-[10rem]`,
                        value: month,
                        onChange: onMonthChange,
                        "aria-label": "Month",
                        children: $080fd3f193a2c5b4$var$MONTH_OPTIONS.map(({ value: value, label: label })=>/*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("option", {
                                value: value,
                                children: label
                            }, value))
                    }),
                    /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("select", {
                        className: `${$080fd3f193a2c5b4$var$selectClass} w-auto max-w-[5rem] sm:max-w-[6rem]`,
                        value: year,
                        onChange: onYearChange,
                        "aria-label": "Year",
                        children: years.map((y)=>/*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("option", {
                                value: y,
                                children: y
                            }, y))
                    })
                ]
            }),
            /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("button", {
                type: "button",
                className: "shrink-0 inline-flex items-center justify-center w-10 h-10 sm:min-w-[3rem] sm:px-4 sm:py-3 text-xl rounded-none border-2 border-black dark:border-gray-100 bg-brutal-purple text-white hover:bg-brutal-purple-hover",
                "aria-label": "Next month",
                onClick: onNext,
                children: "\u2192"
            })
        ]
    });
}
const $080fd3f193a2c5b4$var$RECONNECT_DELAYS = [
    1000,
    2000,
    4000,
    8000,
    16000,
    30000
];
const $080fd3f193a2c5b4$var$MAX_RECONNECT_ATTEMPTS = 10;
const $080fd3f193a2c5b4$var$RECENT_CALENDARS_KEY = "meetday_recent_calendars";
function $080fd3f193a2c5b4$var$urlBase64ToUint8Array(base64String) {
    const padding = "=".repeat((4 - base64String.length % 4) % 4);
    const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
    const rawData = atob(base64);
    const outputArray = new Uint8Array(rawData.length);
    for(let i = 0; i < rawData.length; i += 1)outputArray[i] = rawData.charCodeAt(i);
    return outputArray;
}
/** Encode ArrayBuffer to base64url (no padding) for push subscription keys. */ function $080fd3f193a2c5b4$var$arrayBufferToBase64Url(buffer) {
    if (!buffer || buffer.byteLength === 0) return "";
    const bytes = new Uint8Array(buffer);
    let binary = "";
    for(let i = 0; i < bytes.length; i += 1)binary += String.fromCharCode(bytes[i]);
    return btoa(binary).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
}
function $080fd3f193a2c5b4$var$updateRecentCalendars(slug, name) {
    if (typeof window === "undefined" || !slug) return;
    try {
        const raw = window.localStorage.getItem($080fd3f193a2c5b4$var$RECENT_CALENDARS_KEY);
        const list = raw ? JSON.parse(raw) : [];
        const now = Date.now();
        const cutoff = now - 10368000000; // ~120 days
        const filtered = list.filter((item)=>item && item.slug && item.slug !== slug && item.lastVisited >= cutoff);
        const entry = {
            slug: slug,
            lastVisited: now
        };
        if (name && name.trim()) entry.name = name.trim();
        filtered.push(entry);
        filtered.sort((a, b)=>b.lastVisited - a.lastVisited);
        const trimmed = filtered.slice(0, 10);
        window.localStorage.setItem($080fd3f193a2c5b4$var$RECENT_CALENDARS_KEY, JSON.stringify(trimmed));
    } catch  {
    // Ignore storage errors.
    }
}
function $080fd3f193a2c5b4$export$2e2bcd8739ae039({ config: config }) {
    const [state, setState] = (0, $d6bdfea1a1e13052$export$60241385465d0a34)((0, $8228b3fd71ca6b09$export$d4c72bab9d6cc13a));
    const [selectedDate, setSelectedDate] = (0, $d6bdfea1a1e13052$export$60241385465d0a34)(config.selectedDate ?? "");
    const [viewMonth, setViewMonth] = (0, $d6bdfea1a1e13052$export$60241385465d0a34)(config.month);
    const [viewYear, setViewYear] = (0, $d6bdfea1a1e13052$export$60241385465d0a34)(config.year);
    const [connectionStatus, setConnectionStatus] = (0, $d6bdfea1a1e13052$export$60241385465d0a34)("connecting");
    const lastEventIdRef = (0, $d6bdfea1a1e13052$export$b8f5890fc79d6aca)(0);
    const reconnectTimeoutRef = (0, $d6bdfea1a1e13052$export$b8f5890fc79d6aca)(null);
    const reconnectAttemptRef = (0, $d6bdfea1a1e13052$export$b8f5890fc79d6aca)(0);
    const socketRef = (0, $d6bdfea1a1e13052$export$b8f5890fc79d6aca)(null);
    const username = (0, $8228b3fd71ca6b09$export$946482ddfe71b064)(config.username ?? "", state.displayNameChain ?? undefined);
    const [notificationsEnabled, setNotificationsEnabled] = (0, $d6bdfea1a1e13052$export$60241385465d0a34)(()=>{
        if (typeof window === "undefined") return false;
        try {
            return window.localStorage.getItem(`meetday_push_${config.slug}`) === "on";
        } catch  {
            return false;
        }
    });
    const [settingsOpen, setSettingsOpen] = (0, $d6bdfea1a1e13052$export$60241385465d0a34)(false);
    const [renameOpen, setRenameOpen] = (0, $d6bdfea1a1e13052$export$60241385465d0a34)(false);
    const [renameValue, setRenameValue] = (0, $d6bdfea1a1e13052$export$60241385465d0a34)("");
    const [installPrompt, setInstallPrompt] = (0, $d6bdfea1a1e13052$export$60241385465d0a34)(null);
    const [isStandalone, setIsStandalone] = (0, $d6bdfea1a1e13052$export$60241385465d0a34)(false);
    const [rateLimitMessage, setRateLimitMessage] = (0, $d6bdfea1a1e13052$export$60241385465d0a34)(null);
    const [eventTooLargeMessage, setEventTooLargeMessage] = (0, $d6bdfea1a1e13052$export$60241385465d0a34)(null);
    const rateLimitIntervalRef = (0, $d6bdfea1a1e13052$export$b8f5890fc79d6aca)(null);
    const rateLimitRetryAtRef = (0, $d6bdfea1a1e13052$export$b8f5890fc79d6aca)(0);
    const eventTooLargeTimeoutRef = (0, $d6bdfea1a1e13052$export$b8f5890fc79d6aca)(null);
    (0, $d6bdfea1a1e13052$export$6d9c69b0de29b591)(()=>{
        (0, $30170d3e8382adde$export$7205caaeb4a84222)(()=>{
            if (eventTooLargeTimeoutRef.current) clearTimeout(eventTooLargeTimeoutRef.current);
            setEventTooLargeMessage("Message too long. Please shorten it.");
            eventTooLargeTimeoutRef.current = setTimeout(()=>{
                eventTooLargeTimeoutRef.current = null;
                setEventTooLargeMessage(null);
            }, 5000);
        });
        return ()=>{
            (0, $30170d3e8382adde$export$7205caaeb4a84222)(null);
            if (eventTooLargeTimeoutRef.current) clearTimeout(eventTooLargeTimeoutRef.current);
        };
    }, []);
    (0, $d6bdfea1a1e13052$export$6d9c69b0de29b591)(()=>{
        (0, $30170d3e8382adde$export$fb630ecd976ebe94)((retryAfterSeconds)=>{
            if (rateLimitIntervalRef.current) {
                clearInterval(rateLimitIntervalRef.current);
                rateLimitIntervalRef.current = null;
            }
            const now = Date.now();
            rateLimitRetryAtRef.current = now + retryAfterSeconds * 1000;
            const tick = ()=>{
                const remaining = Math.max(0, Math.ceil((rateLimitRetryAtRef.current - Date.now()) / 1000));
                if (remaining <= 0) {
                    if (rateLimitIntervalRef.current) {
                        clearInterval(rateLimitIntervalRef.current);
                        rateLimitIntervalRef.current = null;
                    }
                    setRateLimitMessage(null);
                    return;
                }
                setRateLimitMessage(`Sending too quickly, retrying in ${remaining}s\u{2026}`);
            };
            tick();
            rateLimitIntervalRef.current = setInterval(tick, 1000);
        });
        return ()=>{
            (0, $30170d3e8382adde$export$fb630ecd976ebe94)(null);
            if (rateLimitIntervalRef.current) {
                clearInterval(rateLimitIntervalRef.current);
                rateLimitIntervalRef.current = null;
            }
        };
    }, []);
    (0, $d6bdfea1a1e13052$export$6d9c69b0de29b591)(()=>{
        const checkStandalone = ()=>setIsStandalone(window.matchMedia("(display-mode: standalone)").matches || navigator.standalone === true);
        checkStandalone();
        window.matchMedia("(display-mode: standalone)").addEventListener("change", checkStandalone);
        return ()=>window.matchMedia("(display-mode: standalone)").removeEventListener("change", checkStandalone);
    }, []);
    (0, $d6bdfea1a1e13052$export$6d9c69b0de29b591)(()=>{
        const handleInstallPrompt = (e)=>{
            e.preventDefault();
            setInstallPrompt(e);
        };
        window.addEventListener("beforeinstallprompt", handleInstallPrompt);
        return ()=>window.removeEventListener("beforeinstallprompt", handleInstallPrompt);
    }, []);
    const updateMonthYear = (month, year)=>{
        setViewMonth(month);
        setViewYear(year);
        setSelectedDate("");
        const params = new URLSearchParams(window.location.search);
        params.set("month", String(month));
        params.set("year", String(year));
        const newUrl = `${window.location.pathname}?${params.toString()}`;
        window.history.pushState({}, "", newUrl);
    };
    const goPrevMonth = ()=>{
        let m = viewMonth - 1;
        let y = viewYear;
        if (m < 1) {
            m = 12;
            y -= 1;
        }
        updateMonthYear(m, y);
    };
    const goNextMonth = ()=>{
        let m = viewMonth + 1;
        let y = viewYear;
        if (m > 12) {
            m = 1;
            y += 1;
        }
        updateMonthYear(m, y);
    };
    const handleMonthChange = (e)=>{
        const target = e.target;
        const m = Number(target?.value) || viewMonth;
        updateMonthYear(m, viewYear);
    };
    const handleYearChange = (e)=>{
        const target = e.target;
        const y = Number(target?.value) || viewYear;
        updateMonthYear(viewMonth, y);
    };
    const calendarConfig = {
        ...config,
        month: viewMonth,
        year: viewYear
    };
    lastEventIdRef.current = state.lastEventId;
    const fetchEvents = (0, $d6bdfea1a1e13052$export$35808ee640e87ca7)((sinceId = 0)=>{
        const url = sinceId > 0 ? `/c/${config.slug}/events?since_id=${sinceId}` : `/c/${config.slug}/events`;
        return fetch(url).then((r)=>r.json()).then((events)=>{
            const evList = events;
            const maxId = evList.length > 0 ? Math.max(...evList.map((e)=>e.id ?? 0)) : 0;
            if (sinceId > 0) setState((s)=>{
                let next = s;
                for (const ev of events)next = (0, $8228b3fd71ca6b09$export$27ca81ea148fa005)(next, ev, {
                    username: username
                });
                return next;
            });
            else {
                let s = (0, $8228b3fd71ca6b09$export$d4c72bab9d6cc13a)();
                events.forEach((ev)=>{
                    s = (0, $8228b3fd71ca6b09$export$27ca81ea148fa005)(s, ev, {
                        username: username
                    });
                });
                setState(s);
            }
            if (maxId > 0) (0, $30170d3e8382adde$export$3aa17b355b211dc5)(config.slug, maxId).catch(()=>{});
        }).catch(console.error);
    }, [
        config.slug,
        username
    ]);
    (0, $d6bdfea1a1e13052$export$6d9c69b0de29b591)(()=>{
        fetchEvents().catch(console.error);
    }, [
        fetchEvents
    ]);
    (0, $d6bdfea1a1e13052$export$6d9c69b0de29b591)(()=>{
        const connect = ()=>{
            const proto = window.location.protocol === "https:" ? "wss:" : "ws:";
            const url = `${proto}//${window.location.host}/c/${config.slug}/ws`;
            const sock = new WebSocket(url);
            socketRef.current = sock;
            sock.onopen = ()=>{
                reconnectAttemptRef.current = 0;
                setConnectionStatus("connected");
                const sinceId = lastEventIdRef.current;
                if (sinceId > 0) fetchEvents(sinceId);
            };
            sock.onmessage = (e)=>{
                try {
                    const { kind: kind, event: event } = JSON.parse(e.data);
                    if (kind === "event" && event) {
                        setState((s)=>(0, $8228b3fd71ca6b09$export$27ca81ea148fa005)(s, event, {
                                username: username
                            }));
                        const id = event?.id;
                        if (typeof id === "number" && id > 0) (0, $30170d3e8382adde$export$3aa17b355b211dc5)(config.slug, id).catch(()=>{});
                    }
                } catch (err) {
                    console.error(err);
                }
            };
            sock.onclose = ()=>{
                socketRef.current = null;
                setConnectionStatus("disconnected");
                const attempt = reconnectAttemptRef.current;
                if (attempt < $080fd3f193a2c5b4$var$MAX_RECONNECT_ATTEMPTS) {
                    setConnectionStatus("reconnecting");
                    const delay = $080fd3f193a2c5b4$var$RECONNECT_DELAYS[Math.min(attempt, $080fd3f193a2c5b4$var$RECONNECT_DELAYS.length - 1)];
                    reconnectAttemptRef.current = attempt + 1;
                    reconnectTimeoutRef.current = setTimeout(()=>{
                        reconnectTimeoutRef.current = null;
                        connect();
                    }, delay);
                }
            };
            sock.onerror = ()=>{
                sock.close();
            };
        };
        connect();
        return ()=>{
            if (reconnectTimeoutRef.current) {
                clearTimeout(reconnectTimeoutRef.current);
                reconnectTimeoutRef.current = null;
            }
            const sock = socketRef.current;
            if (sock) {
                sock.onclose = null;
                sock.close();
                socketRef.current = null;
            }
        };
    }, [
        config.slug,
        username,
        fetchEvents
    ]);
    const shareURL = typeof window !== "undefined" ? `${window.location.origin}/c/${config.slug}` : "";
    const calendarTitle = state.calendarName || config.slug;
    (0, $d6bdfea1a1e13052$export$6d9c69b0de29b591)(()=>{
        if (typeof document !== "undefined") document.title = calendarTitle ? `${calendarTitle} \u{2013} Meetday` : "Meetday";
    }, [
        calendarTitle
    ]);
    // Record this calendar in the local recent-calendars list.
    (0, $d6bdfea1a1e13052$export$6d9c69b0de29b591)(()=>{
        $080fd3f193a2c5b4$var$updateRecentCalendars(config.slug, state.calendarName ?? null);
    }, [
        config.slug,
        state.calendarName
    ]);
    /** Returns so the dialog can know not to update state on failure; throws on error so caller can catch. */ async function enableNotifications() {
        if (typeof window === "undefined") throw new Error("Not in browser");
        if (!("Notification" in window) || !("serviceWorker" in navigator)) throw new Error("Notifications or Service Worker not supported");
        let permission = Notification.permission;
        if (permission === "default") permission = await Notification.requestPermission();
        if (permission !== "granted") throw new Error("Notification permission denied");
        const registration = await navigator.serviceWorker.ready;
        let sub = await registration.pushManager.getSubscription();
        if (!sub) {
            const vapidKey = config.vapidPublicKey;
            if (!vapidKey || !String(vapidKey).trim()) throw new Error("Push notifications are not configured on this server. The server administrator must set MEETDAY_VAPID_PUBLIC and MEETDAY_VAPID_PRIVATE environment variables.");
            const appServerKey = $080fd3f193a2c5b4$var$urlBase64ToUint8Array(vapidKey);
            const appServerKeyBuffer = appServerKey.buffer;
            sub = await registration.pushManager.subscribe({
                userVisibleOnly: true,
                applicationServerKey: appServerKeyBuffer
            });
        }
        // Prefer toJSON() (works in Chrome); fall back to getKey() for keys.
        let p256dhStr = "";
        let authStr = "";
        const j = typeof sub.toJSON === "function" ? sub.toJSON() : null;
        if (j && j.keys) {
            p256dhStr = j.keys.p256dh ?? "";
            authStr = j.keys.auth ?? "";
        }
        if ((!p256dhStr || !authStr) && sub.getKey) {
            const p256 = sub.getKey("p256dh");
            const a = sub.getKey("auth");
            if (p256) p256dhStr = $080fd3f193a2c5b4$var$arrayBufferToBase64Url(p256);
            if (a) authStr = $080fd3f193a2c5b4$var$arrayBufferToBase64Url(a);
        }
        if (!p256dhStr || !authStr) {
            console.warn("Push subscription missing keys (p256dh/auth)");
            throw new Error("Could not read subscription keys");
        }
        const body = {
            endpoint: sub.endpoint,
            keys: {
                p256dh: p256dhStr,
                auth: authStr
            }
        };
        const res = await fetch(`/c/${config.slug}/push/subscribe`, {
            method: "POST",
            credentials: "include",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(body)
        });
        if (!res.ok) {
            const text = await res.text();
            console.warn("Push subscribe failed:", res.status, text);
            throw new Error(`Subscribe failed: ${res.status}`);
        }
        try {
            window.localStorage.setItem(`meetday_push_${config.slug}`, "on");
        } catch  {
        // ignore
        }
        setNotificationsEnabled(true);
    }
    async function disableNotifications() {
        if (typeof window === "undefined" || !("serviceWorker" in navigator)) return;
        try {
            const registration = await navigator.serviceWorker.ready;
            const sub = await registration.pushManager.getSubscription();
            const payload = sub ? {
                endpoint: sub.endpoint
            } : {};
            const res = await fetch(`/c/${config.slug}/push/unsubscribe`, {
                method: "POST",
                credentials: "include",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(payload)
            });
            if (!res.ok) console.warn("Push unsubscribe failed:", res.status, await res.text());
            try {
                window.localStorage.setItem(`meetday_push_${config.slug}`, "off");
            } catch  {
            // ignore
            }
            setNotificationsEnabled(false);
        } catch  {
        // Ignore failures; user can retry.
        }
    }
    const openRenameModal = ()=>{
        setRenameValue(state.calendarName || config.slug);
        setRenameOpen(true);
    };
    const handleRenameSubmit = (e)=>{
        e.preventDefault();
        const nextName = renameValue.trim();
        if (!nextName) {
            setRenameOpen(false);
            return;
        }
        const message = username ? `${username} renamed the calendar to "${nextName}".` : `Calendar renamed to "${nextName}".`;
        (0, $30170d3e8382adde$export$64a40cf65fcd549d)(config.slug, {
            type: "calendar_renamed",
            message: message,
            data: {
                name: nextName
            }
        }).finally(()=>{
            setRenameOpen(false);
        });
    };
    return /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)((0, $450fc775b2f7950e$export$ffb0004e005737fa), {
        children: [
            /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)((0, $6ad42b3bca101366$export$2e2bcd8739ae039), {
                open: renameOpen,
                onClose: ()=>setRenameOpen(false),
                title: "Rename calendar",
                maxWidth: "max-w-sm",
                children: /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("form", {
                    onSubmit: handleRenameSubmit,
                    className: "flex flex-col gap-3",
                    children: [
                        /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("label", {
                            className: "flex flex-col gap-1 text-sm text-gray-900 dark:text-gray-100",
                            children: [
                                /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("span", {
                                    children: "Calendar name"
                                }),
                                /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("input", {
                                    type: "text",
                                    className: "brutal-input px-3 py-2 rounded-none border-2 border-black dark:border-gray-100 bg-white dark:bg-gray-900 text-gray-900 dark:text-gray-100",
                                    value: renameValue,
                                    onInput: (e)=>{
                                        const target = e.target;
                                        setRenameValue(target.value);
                                    },
                                    maxLength: 120,
                                    autoFocus: true
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("div", {
                            className: "flex justify-end gap-2 mt-2",
                            children: [
                                /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("button", {
                                    type: "button",
                                    className: "inline-flex items-center justify-center min-h-[2.25rem] px-4 py-1.5 text-sm rounded-none border-2 border-black dark:border-gray-100 bg-white dark:bg-gray-900",
                                    onClick: ()=>setRenameOpen(false),
                                    children: "Cancel"
                                }),
                                /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("button", {
                                    type: "submit",
                                    className: "inline-flex items-center justify-center min-h-[2.25rem] px-4 py-1.5 text-sm rounded-none border-2 border-black dark:border-gray-100 bg-brutal-purple text-white hover:bg-brutal-purple-hover",
                                    children: "Save"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)((0, $75c1ce28026314a1$export$2e2bcd8739ae039), {
                open: settingsOpen,
                onClose: ()=>setSettingsOpen(false),
                slug: config.slug,
                username: username,
                avatar: (0, $c9d11e0a6831e0d1$export$2a73bcf51ef6df14)(config.username ?? "", state.avatarsByUsername),
                notificationsEnabled: notificationsEnabled,
                notificationsSupported: Boolean(String(config.vapidPublicKey ?? "").trim()),
                onEnableNotifications: enableNotifications,
                onDisableNotifications: disableNotifications,
                onNotificationsChange: setNotificationsEnabled,
                installPrompt: installPrompt,
                isStandalone: isStandalone
            }),
            /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("div", {
                className: "flex flex-1 min-h-0 flex-col w-full",
                children: [
                    /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)((0, $7f8cb6be0e7ee0fb$export$9d9dfe772dd5e376), {
                        slug: config.slug,
                        calendarName: state.calendarName ?? null,
                        avatar: (0, $c9d11e0a6831e0d1$export$2a73bcf51ef6df14)(config.username ?? "", state.avatarsByUsername),
                        username: username,
                        shareURL: shareURL,
                        onEditCalendarName: openRenameModal,
                        onOpenSettings: ()=>setSettingsOpen(true)
                    }),
                    /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("div", {
                        className: "relative flex flex-1 min-h-0 flex-col w-full pt-6 px-6 pb-10 max-w-4xl mx-auto gap-4 lg:flex-row lg:items-stretch lg:gap-6",
                        children: [
                            (connectionStatus === "disconnected" || connectionStatus === "reconnecting") && /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("div", {
                                className: "absolute top-0 left-0 right-0 z-10 px-4 py-2 text-center text-sm font-semibold bg-orange-200 dark:bg-orange-900/70 text-black dark:text-orange-100 border-b-4 border-orange-500 dark:border-orange-500",
                                role: "status",
                                "aria-live": "polite",
                                children: connectionStatus === "reconnecting" ? "Disconnected. Reconnecting\u2026" : "Disconnected"
                            }),
                            (rateLimitMessage || eventTooLargeMessage) && /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("div", {
                                className: `fixed bottom-4 left-1/2 -translate-x-1/2 z-20 px-3 py-2 text-xs rounded-none border-2 shadow-lg ${eventTooLargeMessage ? "font-semibold text-white bg-brutal-purple border-2 border-black dark:border-gray-100" : "text-gray-700 dark:text-gray-300 bg-white/95 dark:bg-gray-800/95 border-2 border-gray-400 dark:border-gray-500"}`,
                                role: "status",
                                "aria-live": "polite",
                                children: rateLimitMessage ?? eventTooLargeMessage
                            }),
                            /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("div", {
                                className: `flex flex-1 min-h-0 gap-4 w-full flex-col lg:flex-row ${connectionStatus === "disconnected" || connectionStatus === "reconnecting" ? "pt-12" : ""}`,
                                children: [
                                    /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("div", {
                                        className: "flex flex-col flex-1 min-w-0 gap-4 order-2 lg:order-1 lg:flex-[0_0_55%] lg:min-h-0 lg:max-w-[800px] lg:w-[800px]",
                                        children: [
                                            /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("section", {
                                                className: "flex-shrink-0 min-w-0",
                                                "aria-label": "Calendar",
                                                children: [
                                                    /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)($080fd3f193a2c5b4$var$MonthNav, {
                                                        month: viewMonth,
                                                        year: viewYear,
                                                        onPrev: goPrevMonth,
                                                        onNext: goNextMonth,
                                                        onMonthChange: handleMonthChange,
                                                        onYearChange: handleYearChange
                                                    }),
                                                    /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)((0, $0d6fd1d44223ffd9$export$2e2bcd8739ae039), {
                                                        state: state,
                                                        config: calendarConfig,
                                                        selectedDate: selectedDate,
                                                        onDayClick: setSelectedDate
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("section", {
                                                className: "flex-1 min-h-0 min-w-0 flex flex-col overflow-hidden",
                                                "aria-label": "Slots",
                                                children: /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)((0, $817e4203154ac98c$export$2e2bcd8739ae039), {
                                                    state: state,
                                                    config: calendarConfig,
                                                    slug: config.slug,
                                                    selectedDate: selectedDate,
                                                    username: username
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("aside", {
                                        className: "min-w-0 order-1 lg:order-2 lg:flex-shrink-0 lg:w-80",
                                        "aria-label": "Chat and activity log",
                                        children: /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)((0, $29d7681bd26904cb$export$2e2bcd8739ae039), {
                                            state: state,
                                            slug: config.slug,
                                            username: username,
                                            lastReadEventId: config.lastReadEventId
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
}


function $0bb138b31e9954b0$export$2e2bcd8739ae039({ config: config }) {
    (0, $d6bdfea1a1e13052$export$6d9c69b0de29b591)(()=>{
        document.title = config.page === "welcome" ? "Meetday" : config.page === "username" ? "Set your name \u2013 Meetday" : "Calendar \u2013 Meetday";
    }, [
        config.page
    ]);
    if (config.page === "welcome") return /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)((0, $d571c127988d1dd8$export$2e2bcd8739ae039), {});
    if (config.page === "username") return /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)((0, $463ebce6cd32240f$export$2e2bcd8739ae039), {
        ...config
    });
    // Calendar view: config is CalendarConfig
    const cal = config;
    return /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)("div", {
        className: "flex flex-1 flex-col min-h-0 w-full",
        children: /*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)((0, $080fd3f193a2c5b4$export$2e2bcd8739ae039), {
            config: {
                slug: cal.slug,
                username: cal.username,
                month: cal.month,
                year: cal.year,
                selectedDate: cal.selectedDate,
                shareURL: cal.shareURL,
                vapidPublicKey: cal.vapidPublicKey,
                lastReadEventId: cal.lastReadEventId
            }
        })
    });
}




var $e0b2785bd1c314cf$var$i;
function $e0b2785bd1c314cf$export$427ce13b63e52247(o, e) {
    return (0, $450fc775b2f7950e$export$41c562ebe57d11e2).__a && (0, $450fc775b2f7950e$export$41c562ebe57d11e2).__a(e), o;
}
null != ($e0b2785bd1c314cf$var$i = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : void 0) && $e0b2785bd1c314cf$var$i.__PREACT_DEVTOOLS__ && $e0b2785bd1c314cf$var$i.__PREACT_DEVTOOLS__.attachPreact("10.28.4", (0, $450fc775b2f7950e$export$41c562ebe57d11e2), {
    Fragment: (0, $450fc775b2f7950e$export$ffb0004e005737fa),
    Component: (0, $450fc775b2f7950e$export$16fa2f45be04daa8)
});


var $b8690923e809f48c$var$t = {};
function $b8690923e809f48c$export$57a0cba2fdd874ef() {
    $b8690923e809f48c$var$t = {};
}
function $b8690923e809f48c$export$be63e0664592e141(e) {
    return e.type === (0, $450fc775b2f7950e$export$ffb0004e005737fa) ? "Fragment" : "function" == typeof e.type ? e.type.displayName || e.type.name : "string" == typeof e.type ? e.type : "#text";
}
var $b8690923e809f48c$var$i = [], $b8690923e809f48c$var$s = [];
function $b8690923e809f48c$export$8b834d1f16c93a4() {
    return $b8690923e809f48c$var$i.length > 0 ? $b8690923e809f48c$var$i[$b8690923e809f48c$var$i.length - 1] : null;
}
var $b8690923e809f48c$var$l = !0;
function $b8690923e809f48c$var$u(e) {
    return "function" == typeof e.type && e.type != (0, $450fc775b2f7950e$export$ffb0004e005737fa);
}
function $b8690923e809f48c$export$74797e07ad614abb(n) {
    for(var e = [
        n
    ], o = n; null != o.__o;)e.push(o.__o), o = o.__o;
    return e.reduce(function(n, e) {
        n += "  in " + $b8690923e809f48c$export$be63e0664592e141(e);
        var o = e.__source;
        return o ? n += " (at " + o.fileName + ":" + o.lineNumber + ")" : $b8690923e809f48c$var$l && console.warn("Add @babel/plugin-transform-react-jsx-source to get a more detailed component stack. Note that you should not add it to production builds of your App for bundle size reasons."), $b8690923e809f48c$var$l = !1, n + "\n";
    }, "");
}
var $b8690923e809f48c$var$d = "function" == typeof WeakMap;
function $b8690923e809f48c$var$p(n) {
    var e = [];
    return n.__k ? (n.__k.forEach(function(n) {
        n && "function" == typeof n.type ? e.push.apply(e, $b8690923e809f48c$var$p(n)) : n && "string" == typeof n.type && e.push(n.type);
    }), e) : e;
}
function $b8690923e809f48c$var$h(n) {
    return n ? "function" == typeof n.type ? null == n.__ ? null != n.__e && null != n.__e.parentNode ? n.__e.parentNode.localName : "" : $b8690923e809f48c$var$h(n.__) : n.type : "";
}
var $b8690923e809f48c$var$v = (0, $450fc775b2f7950e$export$16fa2f45be04daa8).prototype.setState;
function $b8690923e809f48c$var$y(n) {
    return "table" === n || "tfoot" === n || "tbody" === n || "thead" === n || "td" === n || "tr" === n || "th" === n;
}
(0, $450fc775b2f7950e$export$16fa2f45be04daa8).prototype.setState = function(n, e) {
    return null == this.__v && null == this.state && console.warn('Calling "this.setState" inside the constructor of a component is a no-op and might be a bug in your application. Instead, set "this.state = {}" directly.\n\n' + $b8690923e809f48c$export$74797e07ad614abb($b8690923e809f48c$export$8b834d1f16c93a4())), $b8690923e809f48c$var$v.call(this, n, e);
};
var $b8690923e809f48c$var$m = /^(address|article|aside|blockquote|details|div|dl|fieldset|figcaption|figure|footer|form|h1|h2|h3|h4|h5|h6|header|hgroup|hr|main|menu|nav|ol|p|pre|search|section|table|ul)$/, $b8690923e809f48c$var$b = (0, $450fc775b2f7950e$export$16fa2f45be04daa8).prototype.forceUpdate;
function $b8690923e809f48c$var$w(n) {
    var e = n.props, o = $b8690923e809f48c$export$be63e0664592e141(n), t = "";
    for(var r in e)if (e.hasOwnProperty(r) && "children" !== r) {
        var i = e[r];
        "function" == typeof i && (i = "function " + (i.displayName || i.name) + "() {}"), i = Object(i) !== i || i.toString ? i + "" : Object.prototype.toString.call(i), t += " " + r + "=" + JSON.stringify(i);
    }
    var s = e.children;
    return "<" + o + t + (s && s.length ? ">..</" + o + ">" : " />");
}
(0, $450fc775b2f7950e$export$16fa2f45be04daa8).prototype.forceUpdate = function(n) {
    return null == this.__v ? console.warn('Calling "this.forceUpdate" inside the constructor of a component is a no-op and might be a bug in your application.\n\n' + $b8690923e809f48c$export$74797e07ad614abb($b8690923e809f48c$export$8b834d1f16c93a4())) : null == this.__P && console.warn('Can\'t call "this.forceUpdate" on an unmounted component. This is a no-op, but it indicates a memory leak in your application. To fix, cancel all subscriptions and asynchronous tasks in the componentWillUnmount method.\n\n' + $b8690923e809f48c$export$74797e07ad614abb(this.__v)), $b8690923e809f48c$var$b.call(this, n);
}, (0, $450fc775b2f7950e$export$41c562ebe57d11e2).__m = function(n, e) {
    var o = n.type, t = e.map(function(n) {
        return n && n.localName;
    }).filter(Boolean);
    console.error('Expected a DOM node of type "' + o + '" but found "' + t.join(", ") + "\" as available DOM-node(s), this is caused by the SSR'd HTML containing different DOM-nodes compared to the hydrated one.\n\n" + $b8690923e809f48c$export$74797e07ad614abb(n));
}, function() {
    !function() {
        var n = (0, $450fc775b2f7950e$export$41c562ebe57d11e2).__b, o = (0, $450fc775b2f7950e$export$41c562ebe57d11e2).diffed, t = (0, $450fc775b2f7950e$export$41c562ebe57d11e2).__, r = (0, $450fc775b2f7950e$export$41c562ebe57d11e2).vnode, a = (0, $450fc775b2f7950e$export$41c562ebe57d11e2).__r;
        (0, $450fc775b2f7950e$export$41c562ebe57d11e2).diffed = function(n) {
            $b8690923e809f48c$var$u(n) && $b8690923e809f48c$var$s.pop(), $b8690923e809f48c$var$i.pop(), o && o(n);
        }, (0, $450fc775b2f7950e$export$41c562ebe57d11e2).__b = function(e) {
            $b8690923e809f48c$var$u(e) && $b8690923e809f48c$var$i.push(e), n && n(e);
        }, (0, $450fc775b2f7950e$export$41c562ebe57d11e2).__ = function(n, e) {
            $b8690923e809f48c$var$s = [], t && t(n, e);
        }, (0, $450fc775b2f7950e$export$41c562ebe57d11e2).vnode = function(n) {
            n.__o = $b8690923e809f48c$var$s.length > 0 ? $b8690923e809f48c$var$s[$b8690923e809f48c$var$s.length - 1] : null, r && r(n);
        }, (0, $450fc775b2f7950e$export$41c562ebe57d11e2).__r = function(n) {
            $b8690923e809f48c$var$u(n) && $b8690923e809f48c$var$s.push(n), a && a(n);
        };
    }();
    var n = !1, o = (0, $450fc775b2f7950e$export$41c562ebe57d11e2).__b, r = (0, $450fc775b2f7950e$export$41c562ebe57d11e2).diffed, c = (0, $450fc775b2f7950e$export$41c562ebe57d11e2).vnode, l = (0, $450fc775b2f7950e$export$41c562ebe57d11e2).__r, v = (0, $450fc775b2f7950e$export$41c562ebe57d11e2).__e, b = (0, $450fc775b2f7950e$export$41c562ebe57d11e2).__, g = (0, $450fc775b2f7950e$export$41c562ebe57d11e2).__h, E = $b8690923e809f48c$var$d ? {
        useEffect: new WeakMap,
        useLayoutEffect: new WeakMap,
        lazyPropTypes: new WeakMap
    } : null, k = [];
    (0, $450fc775b2f7950e$export$41c562ebe57d11e2).__e = function(n, e, o, t) {
        if (e && e.__c && "function" == typeof n.then) {
            var r = n;
            n = new Error("Missing Suspense. The throwing component was: " + $b8690923e809f48c$export$be63e0664592e141(e));
            for(var i = e; i; i = i.__)if (i.__c && i.__c.__c) {
                n = r;
                break;
            }
            if (n instanceof Error) throw n;
        }
        try {
            (t = t || {}).componentStack = $b8690923e809f48c$export$74797e07ad614abb(e), v(n, e, o, t), "function" != typeof n.then && setTimeout(function() {
                throw n;
            });
        } catch (n) {
            throw n;
        }
    }, (0, $450fc775b2f7950e$export$41c562ebe57d11e2).__ = function(n, e) {
        if (!e) throw new Error("Undefined parent passed to render(), this is the second argument.\nCheck if the element is available in the DOM/has the correct id.");
        var o;
        switch(e.nodeType){
            case 1:
            case 11:
            case 9:
                o = !0;
                break;
            default:
                o = !1;
        }
        if (!o) {
            var t = $b8690923e809f48c$export$be63e0664592e141(n);
            throw new Error("Expected a valid HTML node as a second argument to render.\tReceived " + e + " instead: render(<" + t + " />, " + e + ");");
        }
        b && b(n, e);
    }, (0, $450fc775b2f7950e$export$41c562ebe57d11e2).__b = function(e) {
        var r = e.type;
        if (n = !0, void 0 === r) throw new Error("Undefined component passed to createElement()\n\nYou likely forgot to export your component or might have mixed up default and named imports" + $b8690923e809f48c$var$w(e) + "\n\n" + $b8690923e809f48c$export$74797e07ad614abb(e));
        if (null != r && "object" == typeof r) {
            if (void 0 !== r.__k && void 0 !== r.__e) throw new Error("Invalid type passed to createElement(): " + r + "\n\nDid you accidentally pass a JSX literal as JSX twice?\n\n  let My" + $b8690923e809f48c$export$be63e0664592e141(e) + " = " + $b8690923e809f48c$var$w(r) + ";\n  let vnode = <My" + $b8690923e809f48c$export$be63e0664592e141(e) + " />;\n\nThis usually happens when you export a JSX literal and not the component.\n\n" + $b8690923e809f48c$export$74797e07ad614abb(e));
            throw new Error("Invalid type passed to createElement(): " + (Array.isArray(r) ? "array" : r));
        }
        if (void 0 !== e.ref && "function" != typeof e.ref && "object" != typeof e.ref && !("$$typeof" in e)) throw new Error('Component\'s "ref" property should be a function, or an object created by createRef(), but got [' + typeof e.ref + "] instead\n" + $b8690923e809f48c$var$w(e) + "\n\n" + $b8690923e809f48c$export$74797e07ad614abb(e));
        if ("string" == typeof e.type) {
            for(var i in e.props)if ("o" === i[0] && "n" === i[1] && "function" != typeof e.props[i] && null != e.props[i]) throw new Error("Component's \"" + i + '" property should be a function, but got [' + typeof e.props[i] + "] instead\n" + $b8690923e809f48c$var$w(e) + "\n\n" + $b8690923e809f48c$export$74797e07ad614abb(e));
        }
        if ("function" == typeof e.type && e.type.propTypes) {
            if ("Lazy" === e.type.displayName && E && !E.lazyPropTypes.has(e.type)) {
                var s = "PropTypes are not supported on lazy(). Use propTypes on the wrapped component itself. ";
                try {
                    var c = e.type();
                    E.lazyPropTypes.set(e.type, !0), console.warn(s + "Component wrapped in lazy() is " + $b8690923e809f48c$export$be63e0664592e141(c));
                } catch (n) {
                    console.warn(s + "We will log the wrapped component's name once it is loaded.");
                }
            }
            var l = e.props;
            e.type.__f && delete (l = function(n, e) {
                for(var o in e)n[o] = e[o];
                return n;
            }({}, l)).ref, function(n, e, o, r, a) {
                Object.keys(n).forEach(function(o) {
                    var i;
                    try {
                        i = n[o](e, o, r, "prop", null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
                    } catch (n) {
                        i = n;
                    }
                    i && !(i.message in $b8690923e809f48c$var$t) && ($b8690923e809f48c$var$t[i.message] = !0, console.error("Failed prop type: " + i.message + (a && "\n" + a() || "")));
                });
            }(e.type.propTypes, l, 0, $b8690923e809f48c$export$be63e0664592e141(e), function() {
                return $b8690923e809f48c$export$74797e07ad614abb(e);
            });
        }
        o && o(e);
    };
    var T, _ = 0;
    (0, $450fc775b2f7950e$export$41c562ebe57d11e2).__r = function(e) {
        l && l(e), n = !0;
        var o = e.__c;
        if (o === T ? _++ : _ = 1, _ >= 25) throw new Error("Too many re-renders. This is limited to prevent an infinite loop which may lock up your browser. The component causing this is: " + $b8690923e809f48c$export$be63e0664592e141(e));
        T = o;
    }, (0, $450fc775b2f7950e$export$41c562ebe57d11e2).__h = function(e, o, t) {
        if (!e || !n) throw new Error("Hook can only be invoked from render methods.");
        g && g(e, o, t);
    };
    var O = function(n, e) {
        return {
            get: function() {
                var o = "get" + n + e;
                k && k.indexOf(o) < 0 && (k.push(o), console.warn("getting vnode." + n + " is deprecated, " + e));
            },
            set: function() {
                var o = "set" + n + e;
                k && k.indexOf(o) < 0 && (k.push(o), console.warn("setting vnode." + n + " is not allowed, " + e));
            }
        };
    }, I = {
        nodeName: O("nodeName", "use vnode.type"),
        attributes: O("attributes", "use vnode.props"),
        children: O("children", "use vnode.props.children")
    }, M = Object.create({}, I);
    (0, $450fc775b2f7950e$export$41c562ebe57d11e2).vnode = function(n) {
        var e = n.props;
        if (null !== n.type && null != e && ("__source" in e || "__self" in e)) {
            var o = n.props = {};
            for(var t in e){
                var r = e[t];
                "__source" === t ? n.__source = r : "__self" === t ? n.__self = r : o[t] = r;
            }
        }
        n.__proto__ = M, c && c(n);
    }, (0, $450fc775b2f7950e$export$41c562ebe57d11e2).diffed = function(e) {
        var o, t = e.type, i = e.__;
        if (e.__k && e.__k.forEach(function(n) {
            if ("object" == typeof n && n && void 0 === n.type) {
                var o = Object.keys(n).join(",");
                throw new Error("Objects are not valid as a child. Encountered an object with the keys {" + o + "}.\n\n" + $b8690923e809f48c$export$74797e07ad614abb(e));
            }
        }), e.__c === T && (_ = 0), "string" == typeof t && ($b8690923e809f48c$var$y(t) || "p" === t || "a" === t || "button" === t)) {
            var s = $b8690923e809f48c$var$h(i);
            if ("" !== s && $b8690923e809f48c$var$y(t)) "table" === t && "td" !== s && $b8690923e809f48c$var$y(s) ? console.error("Improper nesting of table. Your <table> should not have a table-node parent." + $b8690923e809f48c$var$w(e) + "\n\n" + $b8690923e809f48c$export$74797e07ad614abb(e)) : "thead" !== t && "tfoot" !== t && "tbody" !== t || "table" === s ? "tr" === t && "thead" !== s && "tfoot" !== s && "tbody" !== s ? console.error("Improper nesting of table. Your <tr> should have a <thead/tbody/tfoot> parent." + $b8690923e809f48c$var$w(e) + "\n\n" + $b8690923e809f48c$export$74797e07ad614abb(e)) : "td" === t && "tr" !== s ? console.error("Improper nesting of table. Your <td> should have a <tr> parent." + $b8690923e809f48c$var$w(e) + "\n\n" + $b8690923e809f48c$export$74797e07ad614abb(e)) : "th" === t && "tr" !== s && console.error("Improper nesting of table. Your <th> should have a <tr>." + $b8690923e809f48c$var$w(e) + "\n\n" + $b8690923e809f48c$export$74797e07ad614abb(e)) : console.error("Improper nesting of table. Your <thead/tbody/tfoot> should have a <table> parent." + $b8690923e809f48c$var$w(e) + "\n\n" + $b8690923e809f48c$export$74797e07ad614abb(e));
            else if ("p" === t) {
                var c = $b8690923e809f48c$var$p(e).filter(function(n) {
                    return $b8690923e809f48c$var$m.test(n);
                });
                c.length && console.error("Improper nesting of paragraph. Your <p> should not have " + c.join(", ") + " as child-elements." + $b8690923e809f48c$var$w(e) + "\n\n" + $b8690923e809f48c$export$74797e07ad614abb(e));
            } else "a" !== t && "button" !== t || -1 !== $b8690923e809f48c$var$p(e).indexOf(t) && console.error("Improper nesting of interactive content. Your <" + t + "> should not have other " + ("a" === t ? "anchor" : "button") + " tags as child-elements." + $b8690923e809f48c$var$w(e) + "\n\n" + $b8690923e809f48c$export$74797e07ad614abb(e));
        }
        if (n = !1, r && r(e), null != e.__k) for(var l = [], u = 0; u < e.__k.length; u++){
            var d = e.__k[u];
            if (d && null != d.key) {
                var v = d.key;
                if (-1 !== l.indexOf(v)) {
                    console.error('Following component has two or more children with the same key attribute: "' + v + '". This may cause glitches and misbehavior in rendering process. Component: \n\n' + $b8690923e809f48c$var$w(e) + "\n\n" + $b8690923e809f48c$export$74797e07ad614abb(e));
                    break;
                }
                l.push(v);
            }
        }
        if (null != e.__c && null != e.__c.__H) {
            var b = e.__c.__H.__;
            if (b) for(var g = 0; g < b.length; g += 1){
                var E = b[g];
                if (E.__H) {
                    for(var k = 0; k < E.__H.length; k++)if ((o = E.__H[k]) != o) {
                        var O = $b8690923e809f48c$export$be63e0664592e141(e);
                        console.warn("Invalid argument passed to hook. Hooks should not be called with NaN in the dependency array. Hook index " + g + " in component " + O + " was called with NaN.");
                    }
                }
            }
        }
    };
}();


const $b8e13ffc5d653b23$var$root = document.getElementById("app");
const $b8e13ffc5d653b23$var$config = window.__MEETDAY__ ?? {
    page: "welcome"
};
if ($b8e13ffc5d653b23$var$root) (0, $450fc775b2f7950e$export$b3890eb0ae9dca99)(/*#__PURE__*/ (0, $563cc721c6a67067$export$34b9dba7ce09269b)((0, $0bb138b31e9954b0$export$2e2bcd8739ae039), {
    config: $b8e13ffc5d653b23$var$config
}), $b8e13ffc5d653b23$var$root);

})();
//# sourceMappingURL=index.js.map
